import { Image } from "primereact/image";
import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { DataTable } from "primereact/datatable";
import { Auth, DataStore, Predicates, SortDirection, Storage } from "aws-amplify";
import { Timeline } from "primereact/timeline";
import { ValidateInitiatorRole } from "../../helper/validateRole";
import { Column } from "primereact/column";
import { Sidebar } from "primereact/sidebar";
import { Tag } from "primereact/tag";
import { toast } from "react-toastify";
import { handleNotificationsOnStatusChangeforPSA } from "../../components/actions/notficationActions";
import { createEmailNotifications } from "../../components/actions/notficationActions";
import { blobToDataURL, dataURLtoBlob } from "../../components/signature/signatureHelper";
import Layout from "../../components/common/nav/initiator/nav.component";
import SignatureDialog from "../../components/signature/SignatureDialog";
import sideBarRight from "../../assets/images/sidebarright.svg";
import user1 from "../../assets/images/user1.svg";
import user2 from "../../assets/images/user2.svg";
import Editpopup from "../../components/popup/editpopup";
import { Dialog } from "primereact/dialog";
import Login from "../../setup/auth/login.component";
import sidebar from "../../assets/images/sidebarright.svg";
import { Dropdown } from "primereact/dropdown";
import { TabView, TabPanel } from "primereact/tabview";
import { Avatar } from "primereact/avatar";
import {
    ConvertResponseForSelectWithRefCodedropdown,
    ConvertResponseForSelect,
    ConvertResponseOfNameCodeForSelect,
    GetValueFromArray, ConvertResponseForEmployeeSelect, graphQLGetAllData, graphQLFindRecordById
} from "../../helper/commonfunctions";
import {
    InitiateClassifiedWeeklyAbsenceReport,
    InitiateClassifiedWeeklyAbsenceReportStatus,
    Employee,
    Schools,
    Subject,
    PSAPartyDocument,
    PSAConsultant,
    PSATransactionCycle,
    PSAParty,
    PSADocuments
} from "../../models";
import moment from "moment";
import { Await, Link } from "react-router-dom";
import AWS from "aws-sdk";
import awsmobile from "../../aws-exports";
import { Calendar } from "primereact/calendar";
import { Request_Status, PSA_Status, USER_TYPES, USER_TYPES_NAMES, PSA_Status_For_Dropdown, PSA_Designation, PSA_ARCHIVE_DESIG } from "../../helper/enum";
import { reactLocalStorage } from "reactjs-localstorage";
import HtmlToPdf from "../../components/HtmlToPdf";
import ServiceAgreementPdf from "../../components/reportpdftemplate/serviceagreementpdf";
import "../../components/reportpdftemplate/base.min.css";
import "../../components/reportpdftemplate/fancy.min.css";
import "../../components/reportpdftemplate/main.css";
import PreviewAgreement from "../../../src/assets/images/stipend-form.jpg";
import { FilterMatchMode } from "primereact/api";
import { useFormik } from "formik";
// import PsaPdf from "../../components/reportpdftemplate/personalserviceagreementpdf";
import PsaPdf2 from "../../components/reportpdftemplate/Personalserviceagreementpdf2";
import ReactFullscreen from "react-easyfullscreen";
import { useReactToPrint } from "react-to-print";
import { Badge } from "primereact/badge";
import { groupBy, orderBy, range } from "lodash";
import { ProgressSpinner } from "primereact/progressspinner";
import { Card } from "primereact/card";
import { RadioButton } from "primereact/radiobutton";
import handleDateSelect from "../../helper/convertDateIntoPSTFormat";
import { GetAWSObjectURL } from "../../helper/aws";
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../graphql/mutations';
import * as queries from "../../graphql/queries";
import PsaPdf from "../../components/reportpdftemplate/personalserviceagreementpdf";
import html2canvas from 'html2canvas';
import JsPDF from "jspdf";
import ReportDeleteDialog from "../../components/reportSoftDelete";
import PersonalsServiceagreementModal from "../../pages/personalserviceagreement/PersonalsServiceagreementModal";
import CheckArchive from "../../components/common/CheckArchive";
import RestoreDialog from "../../components/reportArchive/RestoreDialog";
const PsaPdf4 = React.lazy(() => import('../../components/reportpdftemplate/personalserviceagreementpdf4'));

const uploadPDF = (pdfFile, filePath) => {
    const s3 = new AWS.S3({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region
    });

    const params = {
        Bucket: process.env.REACT_APP_AWS_Bucket,
        Key: filePath,
        Body: pdfFile,
        ContentType: "application/pdf"
    };

    try {
        s3.upload(params, (err, data) => {
            if (err) {
                console.log("S3 filesaving Error uploading PDF file:", err);
            } else {
                console.log("S3 filesaving PDF file uploaded successfully:", data);
            }
        });
    } catch (e) {
        console.log("Error when upload pdf:-", e);
    }
};

export default function PSAArchiveReport() {
    // PsaPdf4.preload();
    const childRef = useRef();

    const [isVisibleRestore, setIsVisibleRestore] = useState(false);
    // const [isVisibleDelete, setIsVisibleDelete] = useState(false);
    const [isVisibleDeleteID, setIsVisibleDeleteID] = useState(null);

    const loggedPersonnelServiceAgreeInitiator = reactLocalStorage.get("loggedPersonnelServiceAgreeInitiator");
    const loggedPersonnelServiceAgreeApprover = reactLocalStorage.get("loggedPersonnelServiceAgreeApprover");
    const [activeIndex, setActiveIndex] = useState(0);
    const [StipendsFormFullScreen, setStipendsFormFullScreen] = useState(false);
    const [RejectReport, setRejectReport] = useState(false);
    const [RejectReport_Send, setRejectReport_Send] = useState(false);
    const [Report_Approved, setReport_Approved] = useState(false);
    const [events, setEvents] = useState([]);
    const [reportLoading, setReportLoading] = useState(true);
    const [reportLoadingApprover, setReportLoadingApprover] = useState(true);
    const [masterDataLoaded, setIsMasterDataLoaded] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);


    const [ReminderDialog, setreminderDialog] = useState(false);
    const [ReminderData, setreminderData] = useState(null);

    const RemainderFunction = async (rowData) => {
        try {
            let status = 'REMINDER_PENDING_FOR_APPROVAL'
            let userid = rowData.assigneeId;
            console.log("useriduserid:-", userid);
            // if (rowData.approver_by) {
            //     status = "REMINDER_PENDING_FOR_PAYROLL"
            //     userid = rowData.l2_authority
            // }
            console.log(status)
            handleNotificationsOnStatusChangeforPSA(status, rowData?.id, "PERSONAL_SERVICE_AGREEMENT", userid, loggedUserId, '', '', rowData.psaEmail);
            setreminderDialog(false);
            toast.success("Remainder Sent Sucessfully")
        } catch (err) {
            console.log("Error is :-", err);
        }
    }


    const footerContentForReminder = (
        <div className="text-center">
            <div className="d-flex">
                <button
                    onClick={() => { RemainderFunction(ReminderData) }}
                    type="button"
                    className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
                >
                    Yes
                </button>
                <button
                    onClick={() => { setreminderDialog(false) }}
                    type="button"
                    className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
                    id="add-family-cancel-btn"
                >
                    No
                </button>
            </div>
        </div>
    );

    //advance filter
    // const [visibleAdvanceFilter, setVisibleAdvanceFilter] = useState(false);
    // const [assignmentTitleValue, setAssignmentTitleValue] = useState('');
    // const [psaRefValue, setPsaRefValue] = useState('');
    // const [psaConsultantValue, setPsaConsultantValue] = useState('');
    // const [selectedInitiator, setSelectedInitiator] = useState(null);
    // const [selectedDepartment, setSelectedDepartment] = useState(null);
    // const [selectedStatus, setSelectedStatus] = useState(null);
    // const [submittedDateValue, setSubmittedDateValue] = useState(null);

    // console.log("filteredData selectedInitiatorselectedInitiator:-", selectedInitiator);
    // console.log("filteredData activeIndex:-", activeIndex);

    // const [isUseFilter, setIsUseFilter] = useState(false);
    // const [filteredData, setFilteredData] = useState([]);
    // const [filteredDataApprover, setFilteredDataApprover] = useState([]);
    // console.log("filteredDatafilteredData:-", filteredData);

    // const handleSearch = () => {
    //   let filtered = [];
    //   if (activeIndex == 0) {
    //     filtered = initiatorReportList;
    //   } else if (activeIndex == 1) {
    //     filtered = approvalList;
    //   }

    //   if (filtered.length > 0) {
    //     if (assignmentTitleValue != '') {
    //       filtered = filtered.filter(value =>
    //         value.assignmentTitle.toLowerCase().includes(assignmentTitleValue.toLowerCase())
    //       )
    //     }
    //     if (psaRefValue != '') {
    //       filtered = filtered.filter(value =>
    //         value?.psaRefNo.includes(psaRefValue)
    //       )
    //     }

    //     if (psaConsultantValue != '') {
    //       filtered = filtered.filter(value =>
    //         value.psaEmail.toLowerCase().includes(psaConsultantValue.toLowerCase())
    //       )
    //     }

    //     if (selectedDepartment != null) {
    //       filtered = filtered.filter(value =>
    //         value.department?.includes((selectedDepartment?.name))
    //       )
    //     }
    //     if (selectedInitiator != null) {
    //       if (selectedInitiator.user_Id) {
    //         filtered = filtered.filter(value =>
    //           value.submittedBy.toLowerCase().includes((selectedInitiator?.user_Id).toString().toLowerCase())
    //         )
    //       } else {
    //         filtered = [];
    //       }
    //     }
    //     if (selectedStatus != null) {
    //       filtered = filtered.filter(value =>
    //         // value.status?.includes((selectedStatus?.name))
    //         value?.status === selectedStatus?.name
    //       )
    //     }
    //     if (submittedDateValue != null) {
    //       filtered = filtered.filter(value =>
    //         value.submittedOnFilter?.includes(moment(submittedDateValue).format("MM/DD/YYYY"))
    //       )
    //     }
    //   }
    //   setIsUseFilter(true);

    //   if (activeIndex == 0) {
    //     setFilteredData(filtered);
    //   } else if (activeIndex == 1) {
    //     setFilteredDataApprover(filtered)
    //   }

    //   setVisibleAdvanceFilter(false)
    // };
    // const clearFilterFields = () => {
    //   setAssignmentTitleValue('');
    //   setPsaRefValue('');
    //   setPsaConsultantValue('');
    //   setSelectedInitiator(null);
    //   setSelectedDepartment(null);
    //   setSelectedStatus(null);
    //   setSubmittedDateValue(null);
    //   setIsUseFilter(false);
    //   // setVisibleAdvanceFilter(false);
    //   // BindList();
    // }
    // const footerContentForAdvanceFilter = (
    //   <div>
    //     <Button label="Clear All" icon="pi pi-times" onClick={() => clearFilterFields()} className="p-button-text" />
    //     <Button label="Search" icon="pi pi-check" onClick={() => handleSearch()} autoFocus />
    //   </div>
    // );

    //states start
    const [allEmployeeDetails, setAllEmployeeDetails] = useState([]);
    const [empCodeList, setEmpCodeList] = useState([]);
    const [specificReportDetailsView, setSpecificReportDetailsView] = useState([]);
    const [specificReportDetailsEdit, setSpecificReportDetailsEdit] = useState([]);
    const [submitCount, setSubmitCount] = useState(0);
    const [approvedCount, setApprovedCount] = useState(0);
    const [rejectCount, setRejectCount] = useState(0);
    const [initiatorReportList, setInitiatorReportList] = useState([]);
    //states end
    const [fullViewEdit, setFullViewEdit] = useState(false);
    const [fullViewForView, setFullViewForView] = useState(false);
    const [visibleCreteReportPopup, setVisibleCreteReportPopup] = useState(false);
    const [showNextPopUp, setShowNextPopUp] = useState(false);
    const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
    const [groupName, setGroupName] = useState();
    const PSAIsSuperadmin = reactLocalStorage.get("isPersonalServiceSuperAdmin");

    const [accountCharge, setAccountCharged] = useState("");
    const [totalStaffingAllocationectedRole, setTotalStaffingAllocation] = useState("");
    let [userList, setUserList] = useState([]);
    const [subjectCode, setSubjectCodeList] = useState(null);
    const [value, setValue] = useState("");
    const [partyDocuments, setPartyDocuments] = useState([]);
    console.log("documents partyDocuments", partyDocuments);

    const [employeeId, setEmployeeId] = useState("");
    const [fteUtilized, setFteUtilized] = useState("");
    const [checked, setChecked] = useState(false);
    const [myaccountt, setProducts] = useState([]);
    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [visible, setVisible] = useState(false);
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [position, setPosition] = useState("center");
    const [visibleRight, setVisibleRight] = useState(false);
    const [activate, setActivate] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isSignatureAdded, setIsSignatureAdded] = useState(false);
    const [routingData, setRoutingData] = useState([]);
    const [pleaseWaitButton, setPleaseWaitButton] = useState(false);
    const [isPsaPdfUpdate, setIsPsaPdfUpdate] = useState(false);


    // Add Signature
    const [signatureFileAwsPath, setSignatureFileAwsPath] = useState(null);
    const [addSignature, setAddSignature] = useState(false);
    const [signaturePath, setSignaturePath] = useState(null);
    const [signatureDialog, setSignatureDialog] = useState(false);
    const [loggedInUserData, setLoggedInUserData] = useState([]);
    const [isApproverEdit, setIsApproverEdit] = useState(false);
    const [approvelStatusData, setApprovelStatusData] = useState([]);
    const [isItemsAdded, setIsItemsAdded] = useState(false);
    const [isHrConsultant, setIsHrConsultant] = useState(false);
    const [initiatorDocuments, setInitiatorDocuments] = useState([]);
    console.log("documents initiatorDocuments", initiatorDocuments);

    console.log("approvelStatusData", approvelStatusData);
    const handleClick = () => {
        setRejectReport_Send(false);
        setRejectReport(false);
        setPSAedit(false);
    };

    const customEmptyMessage = <div className="custom-empty-message h-[300px] flex justify-center items-center">No results found.</div>;

    const AddSign = check => {
        if (check === true) {
            setChecked(true);
            setAddSignature(true);
        }
    };




    const currentDateTime = moment();

    const [filters, setFilters] = useState({
        assignmentTitle: { value: null, matchMode: FilterMatchMode.CONTAINS },
        period: { value: null, matchMode: FilterMatchMode.CONTAINS },
        submittedOn: { value: null, matchMode: FilterMatchMode.CONTAINS },
        // remark: { value: null, matchMode: FilterMatchMode.CONTAINS }
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
        department: { value: null, matchMode: FilterMatchMode.EQUALS },
        partyName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        psaRefNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
        submittedBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
        assignee: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });



    const convertHtmlToBlob = async (props) => {
        // debugger
        if (props?.isExecutive) {
            const pdf = new JsPDF('p', 'mm', 'a4');
            console.log("pdf", pdf);


            try {
                const pages = document.querySelectorAll('.page-content'); // Replace with the class name of your page content


                console.log("pdfFile", pages);

                for (let i = 0; i < pages.length; i++) {
                    const page = pages[i];
                    const canvas = await html2canvas(page, {
                        scale: 2, // Adjust the scale factor
                        allowTaint: true, // Allow loading cross-origin images
                        useCORS: true, // Use cross-origin content
                    });

                    console.log("pdfFile-", canvas);

                    if (i > 0) {
                        pdf.addPage(); // Add a new page for each additional capture
                    }


                    const imgData = canvas.toDataURL('image/jpeg', 0.8); // Adjust image format and compression quality

                    console.log("imgData", imgData);
                    pdf.addImage(imgData, 'JPEG', 0, 0, 210, 330);
                    pdf.setTextColor(52, 58, 64);
                    pdf.setFontSize(10);
                    const totalPages = pages.length;
                    pdf.text(90, 285, `Page ${i + 1} of ${totalPages}`);

                    console.log("totalPages", totalPages);

                }
                const pdfFile = pdf.output("blob");
                console.log("pdfFile--", pdfFile);
                const fileName = 'PSAReport.pdf'; //`report-${Date.now()}.pdf`;
                const filePath = "public/psareport/" + props.psaConsultantId + `/${fileName}`;
                console.log("🚀 ~ file: personalserviceagreementpdf4.js:97 ~ convertHtmlToBlob ~ filePath:", filePath)
                //  pdf.save('multi-page-pdf.pdf');
                //  debugger
                uploadPDF(pdfFile, filePath);
            } catch (error) {
                // debugger
                console.log("🚀 ~ file: personalserviceagreementpdf4.js:96 ~ convertHtmlToBlob ~ error:", error)
            }
            //  pdf.save('multi-page-pdf.pdf');
        }


        // setTimeout(async () => {


        //   // childRef.current.convertHtmlToBlob();
        // }, 5000);
    }

    const getApprover = async e => {

        console.log("getApprover eeee:-", e);

        setFallBackApproverLevel(e.value);
        if (e.value === 1) {
            let first = approverListForReject.filter(item => item.type === "Initiator");
            setFallBackApprover(first[0]);
        } else if (e.value === 2) {
            let first = approverListForReject.filter(item => item.type === "budgetClerk");
            setFallBackApprover(first[0]);
        } else if (e.value === 3) {
            let first = approverListForReject.filter(item => item.type === "budgetManager");
            setFallBackApprover(first[0]);
        } else if (e.value === 4) {
            let first = approverListForReject.filter(item => item.type === "hrConsultant");
            setFallBackApprover(first[0]);
        } else if (e.value === 5) {
            let first = approverListForReject.filter(item => item.type === "executive");
            setFallBackApprover(first[0]);
        }

        // for (let i = 0; i < approverListForReject.length; i++) {
        // if (e.value. === approverListForReject[i]) {
        // setFallBackApprover({approverListForReject[i].name, );
        ////// setFallBackApproverId(approversOptions[i].code);
        // }
        // }
        // }
    };

    const [approvalList, setApprovalList] = useState([]);

    const footerContent = (
        <div className="text-center">
            <button
                className="border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded"
                onClick={() => {
                    setConfirmVisible(false);
                    setVisibleEdit(false);
                }}
            >
                Close
            </button>
        </div>
    );

    //*state
    const [reportId, setReportId] = useState("");
    const [schoolName, setSchoolName] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [status, setStatus] = useState(Object.values(PSA_Status_For_Dropdown));
    const [schoolNameArrayForFilter, setSchoolNameArrayForFilter] = useState("");
    const [schoolList, setSchoolList] = useState([]);
    const [schoolListArray, setSchoolListArray] = useState([]);

    //*List
    const [employeeList, setEmployeeList] = useState([]);
    const [psaPartyList, setPSAPartyList] = useState([]);
    const [cycleData, setCycleData] = useState([]);


    const [listParties, setListParties] = useState([]);
    const [reportEmployeeList, setReportEmployeeList] = useState([]);
    const [users, SetUsersList] = useState([]);
    const [absentCodeListDropdown, setSubjectListDropdown] = useState();
    const loggedUserId = reactLocalStorage.get("loggedUserId");
    const loggedFirstName = reactLocalStorage.get("loggedFirstName");
    const loggedLastName = reactLocalStorage.get("loggedLastName");

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [w9Detailes, SetW9Detailes] = useState(false);
    const [pSAPartyData, setPSAPartyData] = useState([]);

    const [ackUser, setAckUser] = useState(false);

    const [buttonClicked, setButtonClicked] = useState(false);

    const setEmpList = async (e, listName) => {
        try {
            const cognito = new AWS.CognitoIdentityServiceProvider();

            var params = {
                UserPoolId: awsmobile.aws_user_pools_id,
                Limit: 60,
                Filter: 'name ^= "' + e.target.value + '"'
            };

            await cognito.listUsers(params, (err, data) => {
                if (err) {
                    //(err.message);
                } else {
                    let usersData = [];
                    //let adminUsers = data.Users
                    var role = "";
                    var name = "";
                    var sub = "";
                    var email = "";
                    var usercode = "";

                    data.Users.forEach((user, i) => {
                        role = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                        name = user.Attributes.find(attr => attr.Name === "name")?.Value;
                        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                        email = user.Attributes.find(attr => attr.Name === "email")?.Value;
                        usercode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                        // name = usercode ? `${name} (${usercode})` : name;
                        let newUser = {
                            id: sub,
                            name: name,
                            email: email,
                            code: sub
                            //"role": role === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : role === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : role === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                        };

                        usersData.push(newUser);
                        if (i === data.Users.length - 1) {
                            if (listName === "fallBackApprover") {
                                setApproverListForReject(usersData);
                            } else {
                                // let approverRoleList = usersData.filter(item => item.role === USER_TYPES_NAMES.AP);
                                //setAllUsersList(usersData)
                            }
                        }
                        //usersData.push({ firstName: userFirstName, lastName: userLastName, label: userFirstName + " " + userLastName, value: adminUsers[i].Username });
                    });
                }
            });
        } catch (e) {
            //toast.error(e.message);
        }
    };

    //approver reject pop up fileds

    const [fallBackApprover, setFallBackApprover] = useState();
    const [fallBackApproverLevel, setFallBackApproverLevel] = useState("");
    const [approverLevelOptions, setApproverLevelOptions] = useState(null);
    //const approverLevelTypeDic = { 0: 'Initiator', 1: 'Teacher', 2: 'Site Admin/ Dept Head', 3: 'Budget Clerk', 4: 'Budget Director', 5: 'HR Director', 6: 'HR Technician' };
    const [approverListForReject, setApproverListForReject] = useState([]);
    // const approverLevelForReject = { 0: 'Initiator', 1: 'Teacher', 2: 'Site Admin/ Dept Head', 3: 'Budget Clerk', 4: 'Budget Director', 5: 'HR Director', 6: 'HR Technician' };

    const approverLevels = [
        "Initiator",
        "BUDGET_CLERK",
        "BUDGET_MANAGER",
        "HR_CONSULTANT_CLEARANCE_VERIFICATION",
        "EXECUTIVE_APPROVER",
        "HR_EXCECUTIVE_SECREATARY"
    ];

    const [approverLevelForReject, setApproverLevelForRejet] = useState([
        { label: "Initiator", value: 1 },
        { label: "Budget Clerk", value: 2 },
        { label: "Budget Manager", value: 3 },
        { label: "HR Executive Secretary Approver", value: 4 },
        { label: "Executive Approver", value: 5 },
        { label: "HR Executive Secretary Payroll", value: 6 }
    ]);

    // const initiatordata = [
    //   {
    //     srNo: "01",
    //     assignmentTitle: "Tile01",
    //     period: "1",
    //     submittedOn: "ON",
    //     remark: "Yes"
    //   },
    //   {
    //     srNo: "01",
    //     assignmentTitle: "Title02",
    //     period: "2",
    //     submittedOn: "Yes",
    //     remark: "No"
    //   }
    // ];

    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    const TaskStatusSL = product => {
        switch (product.status) {
            case "Reviewed & resubmitted":
                return "info";

            case "Rejected":
                return "danger";

            case "Pending":
                return "warning";

            case "SUBMITTED":
                return "info";

            case "Approved":
                return "success";

            case "Approved (P)":
                return "success";

            default:
                return null;
        }
    };

    const TaskStatusSLA = product => {
        return (
            <>
                <Badge value="" severity={TaskStatusSL(product)}></Badge> {product.status}
            </>
        );
    };

    const statusItemTemplate = option => {
        return <Tag value={option} severity={TaskStatusSL(option)} />;
    };

    const [PSAview, setPSAview] = useState(false);
    const [PSAedit, setPSAedit] = useState(false);
    const [psaconsultantData, setPsaconsultantData] = useState({});
    const [formData, setFormData] = useState({});
    const [psaconsultantDoc, setPsaConsultantDoc] = useState([]);
    const [psaconsultantViewDoc, setPsaconsultantViewDoc] = useState([]);
    const [formViewData, setFormViewData] = useState({});
    console.log("formViewDataformViewDataformViewData:-", formViewData);
    console.log("documents psaconsultantDoc:-", psaconsultantDoc);

    const [isEdit, setIsEdit] = useState(false);
    const [imEdit, setImEdit] = useState(false);
    const [id, setId] = useState();
    const [weeklyAbsenceReports, setWeeklyAbsenceReports] = useState();
    const [weeklyAbsenceReportSubmitted, setWeeklyAbsenceReportSubmitted] = useState();
    const [weeklyAbsenceReportApproved, setWeeklyAbsenceReportApproved] = useState();
    const [weeklyAbsenceReportRejected, setWeeklyAbsenceReportRejected] = useState();
    const [weeklyAbsenceReportPending, setWeeklyAbsenceReportPending] = useState();
    const [restoreData, setRestoreData] = useState(null);

    // const alljobactionContent = row => {
    //     console.log("RowRow", row);
    //     return (
    //         <div className="flex justify-center w-full grid grid-cols-3 gap-4" >
    //             <>
    //                 {
    //                     row.status === PSA_Status.PENDING_FOR_APPROVAL_PSA_CONSULTANT ||
    //                         row.status === PSA_Status.REJECTED ||
    //                         row.status === PSA_Status.PENDING ?

    //                         <>
    //                             <Link to='#' className="py-2 px-2.5" onClick={() => initiateNewReport(row.id)}>
    //                                 <i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i>
    //                             </Link>

    //                             {row?.Assignee !== "-" && row?.Assignee !== " " && row.status !== PSA_Status.REJECTED && row.status !== "Pending"
    //                                 && row.status !== "Acknowledged" && row.status !== "Acknowledged by HR Executive Secretary" ?
    //                                 <Link
    //                                     to="#"
    //                                     className="py-2 px-2.5 pt-2"
    //                                     onClick={() => {
    //                                         setreminderDialog(true)
    //                                         setreminderData(row)
    //                                     }}
    //                                 >
    //                                     <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
    //                                 </Link> : <div></div>}
    //                         </>
    //                         :
    //                         row.status !== PSA_Status.PENDING_FOR_APPROVAL_PSA_CONSULTANT ||
    //                             row.status !== PSA_Status.REJECTED ||
    //                             row.status !== PSA_Status.PENDING ?
    //                             <>
    //                                 <Link to='#' className="py-2 px-2.5"
    //                                     onClick={() => {
    //                                         // navigateTo('/initiator/stipend_form'); navigateTo(0)
    //                                         // onClickViewPopup(row, 'right');
    //                                         viewReport(row.id)
    //                                     }}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link>
    //                                 {
    //                                     row?.Assignee !== "-" && row?.Assignee !== " " && row.status !== PSA_Status.REJECTED && row.status !== "Pending"
    //                                         && row.status !== "Acknowledged" && row.status !== "Acknowledged by HR Executive Secretary" ?
    //                                         <Link
    //                                             to="#"
    //                                             className="py-2 px-2.5 pt-2"
    //                                             onClick={() => {
    //                                                 setreminderDialog(true)
    //                                                 setreminderData(row)
    //                                             }}
    //                                         >
    //                                             <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
    //                                         </Link> : <>
    //                                             <Link to="#"> </Link>
    //                                         </>
    //                                 }
    //                             </>
    //                             :
    //                             <>
    //                                 <Link to='#' className="py-2 px-2.5"
    //                                     onClick={() => {
    //                                         // navigateTo('/initiator/stipend_form'); navigateTo(0)
    //                                         onClickEditPopUp(row)
    //                                     }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
    //                                 {
    //                                     row?.Assignee !== "-" && row?.Assignee !== " " && row.status !== PSA_Status.REJECTED
    //                                         && row.status !== "Pending" && row.status !== "Acknowledged" && row.status !== "Acknowledged by HR Executive Secretary"
    //                                         ?
    //                                         <Link
    //                                             to="#"
    //                                             className="py-2 px-2.5 pt-2"
    //                                             onClick={() => {
    //                                                 setreminderDialog(true)
    //                                                 setreminderData(row)
    //                                             }}
    //                                         >
    //                                             <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
    //                                         </Link> : <></>
    //                                 }
    //                             </>



    //                 }

    //                 {/* added bell icon */}
    //                 {

    //                     <Link
    //                         to="#"
    //                         // icon="pi pi-trash"
    //                         className="pi pi-trash py-2 px-2.5 pt-3 text-[#667085]"
    //                         onClick={() => {
    //                             setIsVisibleDeleteID(row.id);
    //                             setIsVisibleDelete(true)
    //                         }}
    //                     />
    //                 }


    //             </>
    //         </div>

    //         // <div className="flex justify-center w-full gap-2">
    //         //   {row.status === PSA_Status.PENDING_FOR_APPROVAL_PSA_CONSULTANT ||
    //         //     row.status === PSA_Status.REJECTED ||
    //         //     row.status === PSA_Status.PENDING ? (
    //         //     <div className="cursor-pointer" onClick={() => initiateNewReport(row.id)}>
    //         //       <i className="gusd-edit text-[#667085] text-[20px] font-meduim"></i>
    //         //     </div>
    //         //   ) : (
    //         //     <div className="cursor-pointer" onClick={() => viewReport(row.id)}>
    //         //       <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
    //         //     </div>
    //         //   )}

    //         /* {
    //           row.status === "Submitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
    //             row.status === "Approved" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
    //               row.status === "Reviewed & resubmitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
    //                 <Link to='#' className="py-2 px-2.5"
    //                   onClick={() =>
    //                     onClickEditPopUp(row)
    //                   }><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
    //         } */
    //         // </div>
    //     );
    // };
    const initiateReportAction = (row) => {
        return (
            <div className="flex w-full items-center" >
                <Link to='#' className="py-2 px-2.5"
                    onClick={() => {
                        // navigateTo('/initiator/stipend_form'); navigateTo(0)
                        // onClickViewPopup(row, 'right');
                        viewReport(row.id)
                    }}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link>

                <Link to='#' title="restore" className="py-2 px-2.5 cursor-pointer" onClick={() => {
                    setRestoreData(row);
                    setIsVisibleRestore(true)
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="18" viewBox="0 0 30 30">
                        <path d="M 15 3 C 12.053086 3 9.3294211 4.0897803 7.2558594 5.8359375 A 1.0001 1.0001 0 1 0 8.5449219 7.3652344 C 10.27136 5.9113916 12.546914 5 15 5 C 20.226608 5 24.456683 8.9136179 24.951172 14 L 22 14 L 26 20 L 30 14 L 26.949219 14 C 26.441216 7.8348596 21.297943 3 15 3 z M 4.3007812 9 L 0.30078125 15 L 3 15 C 3 21.635519 8.3644809 27 15 27 C 17.946914 27 20.670579 25.91022 22.744141 24.164062 A 1.0001 1.0001 0 1 0 21.455078 22.634766 C 19.72864 24.088608 17.453086 25 15 25 C 9.4355191 25 5 20.564481 5 15 L 8.3007812 15 L 4.3007812 9 z" fill="#667085"></path>
                    </svg>

                </Link>
            </div>
        );
    };

    //Approver
    const alljobactionContentApprover = row => {
        return (
            <div className="flex justify-center w-full gap-2">
                {!row.isApproved &&
                    row.status !== PSA_Status.REJECTED &&
                    row.status !== PSA_Status.PENDING_FOR_APPROVAL_PSA_CONSULTANT ? (
                    <div
                        className="cursor-pointer"
                        onClick={() => {
                            onClickHandleEdit(row, row.pstatus);
                        }}
                    >
                        <i className="gusd-edit text-[#667085] text-[20px] font-meduim"></i>
                    </div>
                ) : (
                    <div className="cursor-pointer" onClick={() => viewReport(row.id)}>
                        <i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i>
                    </div>
                )}

                {/* {
          row.status === "Submitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
            row.status === "Approved" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
              row.status === "Reviewed & resubmitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                <Link to='#' className="py-2 px-2.5"
                  onClick={() =>
                    onClickEditPopUp(row)
                  }><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
        } */}
            </div>
        );
    };

    const getAssigneeName = data => {
        try {
            let assigneeId = data?.to_Employee_Id;
            let assigneeName;
            let userCode;
            try {
                let x = users.filter(u => u.Username === assigneeId);
                let fname = x[0]?.Attributes.filter(u => u?.Name === "custom:firstName");
                let lname = x[0]?.Attributes.filter(u => u?.Name === "custom:lastName");
                userCode = x[0]?.Attributes.filter(u => u?.Name === "custom:userCode")[0]?.Value;
                if (fname) {
                    assigneeName = fname[0].Value;
                }
                if (lname) {
                    assigneeName += " " + lname[0].Value;
                }
            } catch (e) {
                console.info(e);
            }
            return { assigneeName, userCode } || "-";
        } catch (e) {
            console.log(e);
            return "-";
        }
    };

    const onClickHandleEdit = async (requestData, currentstatus) => {
        console.log("requestData", requestData)
        setValue("")
        setIsLoading(true);
        setAckUser(false);
        //const PSAConsultantData = await DataStore.query(PSAConsultant, requestData.id);
        const PSAConsultantData = await graphQLFindRecordById("getPSAConsultant", requestData.id);

        // let PSATransactionCycleData = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(requestData.id), {
        // sort: s => s.dateTime(SortDirection.DESCENDING)
        // });
        let PSATransactionCycleData = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: requestData.id } }])
        PSATransactionCycleData = PSATransactionCycleData.sort((a, b) => (b.createdAt).localeCompare(a.createdAt));

        const loggedUserId = reactLocalStorage.get("loggedUserId");
        //check if final hr user
        //if (PSAConsultantData.hrexecutive === loggedUserId) {
        //if(PSATransactionCycleData[PSATransactionCycleData.length -1].status === PSA_Status.PENDING_FOR_APPROVAL_HR_EXCECUTIVE_SECREATARY){
        if (PSAConsultantData.hrexecutive === loggedUserId && PSATransactionCycleData[0].status === PSA_Status.PENDING_FOR_APPROVAL_HR_EXCECUTIVE_SECREATARY) {
            setAckUser(true);
        }

        //set Approver level drop down
        //approverLevelForReject
        let initiator = PSAConsultantData.createdBy;
        let secondApprover = PSAConsultantData.budgetClerk;
        let budgetManagerApprover = PSAConsultantData.budgetManager;
        let thirdApprover = PSAConsultantData.hrConsultant;
        let fourthApprover = PSAConsultantData.executive;
        let fifthApprover = PSAConsultantData.hrexecutive;
        const cognito = new AWS.CognitoIdentityServiceProvider();

        let createdByUser = "";
        let approverOption = [];
        let fullFirstName;
        //Initiator -
        if (PSAConsultantData.createdBy) {
            try {
                createdByUser = await cognito
                    .adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: PSAConsultantData.createdBy })
                    .promise();
            } catch (e) {
                console.log(e);
            }

            let firstApprovalFirstName = await GetValueFromArray(createdByUser.UserAttributes, "custom:firstName");
            let firstApprovalLastName = await GetValueFromArray(createdByUser.UserAttributes, "custom:lastName");
            fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName;
            let objFirst = { name: fullFirstName, code: PSAConsultantData.createdBy, type: "Initiator" };
            approverOption.push(objFirst);
        }

        let budgetClerk = "";
        if (PSAConsultantData.budgetClerk) {
            try {
                budgetClerk = await cognito
                    .adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: PSAConsultantData.budgetClerk })
                    .promise();
            } catch (e) {
                //console.log(e)
            }
            let firstApprovalFirstName = await GetValueFromArray(budgetClerk.UserAttributes, "custom:firstName");
            let firstApprovalLastName = await GetValueFromArray(budgetClerk.UserAttributes, "custom:lastName");
            let fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName;
            let objFirst = { name: fullFirstName, code: PSAConsultantData.budgetClerk, type: "budgetClerk" };

            approverOption.push(objFirst);
        }

        let budgetManager = "";
        if (PSAConsultantData.budgetManager) {
            try {
                budgetManager = await cognito
                    .adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: PSAConsultantData.budgetManager })
                    .promise();
            } catch (e) {
                //console.log(e)
            }
            let firstApprovalFirstName = await GetValueFromArray(budgetManager.UserAttributes, "custom:firstName");
            let firstApprovalLastName = await GetValueFromArray(budgetManager.UserAttributes, "custom:lastName");
            let fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName;
            let objFirst = { name: fullFirstName, code: PSAConsultantData.budgetManager, type: "budgetManager" };

            approverOption.push(objFirst);
        }

        setPartyDocuments([]);
        const getPSAPartyDocuments = () => {
            return new Promise(async (resolve, reject) => {
                // let PSAPartyDocumentsData = await DataStore.query(PSAPartyDocument, c => c?.reportId.eq(requestData.id), {
                // sort: s => s.createdAt(SortDirection.ASCENDING)
                // });

                let PSAPartyDocumentsData = await graphQLGetAllData("listPSAPartyDocuments", [{ reportId: { eq: requestData?.id } }])
                PSAPartyDocumentsData = PSAPartyDocumentsData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))


                resolve(PSAPartyDocumentsData);
            });
        };
        getPSAPartyDocuments().then(res => {
            setPartyDocuments(res);
        });

        let hrConsultant = "";
        if (PSAConsultantData.hrConsultant) {
            try {
                hrConsultant = await cognito
                    .adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: PSAConsultantData.hrConsultant })
                    .promise();
            } catch (e) {
                //console.log(e)
            }
            let firstApprovalFirstName = await GetValueFromArray(hrConsultant.UserAttributes, "custom:firstName");
            let firstApprovalLastName = await GetValueFromArray(hrConsultant.UserAttributes, "custom:lastName");
            let fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName;
            let objFirst = { name: fullFirstName, code: PSAConsultantData.hrConsultant, type: "hrConsultant" };
            approverOption.push(objFirst);
        }

        let executive = "";
        if (PSAConsultantData.executive) {
            try {
                executive = await cognito
                    .adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: PSAConsultantData.executive })
                    .promise();
            } catch (e) {
                //console.log(e)
            }
            let firstApprovalFirstName = await GetValueFromArray(executive.UserAttributes, "custom:firstName");
            let firstApprovalLastName = await GetValueFromArray(executive.UserAttributes, "custom:lastName");
            let fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName;
            let objFirst = { name: fullFirstName, code: PSAConsultantData.executive, type: "executive" };
            approverOption.push(objFirst);
        }

        let hrexecutive = "";
        if (PSAConsultantData.hrexecutive) {
            try {
                hrexecutive = await cognito
                    .adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: PSAConsultantData.hrexecutive })
                    .promise();
            } catch (e) {
                //console.log(e)
            }

            let firstApprovalFirstName = await GetValueFromArray(hrexecutive.UserAttributes, "custom:firstName");
            let firstApprovalLastName = await GetValueFromArray(hrexecutive.UserAttributes, "custom:lastName");
            let fullFirstName = firstApprovalFirstName + " " + firstApprovalLastName;
            let objFirst = { name: fullFirstName, code: PSAConsultantData.hrexecutive, type: "hrexecutive" };
            approverOption.push(objFirst);
        }
        setApproverListForReject(approverOption);

        let appLevelArray = [];
        switch (loggedUserId) {
            //reporting manager.
            case secondApprover:
                appLevelArray.push({ label: "Initiator", value: 1 });
                let first = approverOption.filter(item => item.type === "Initiator");

                setFallBackApprover(first);
                //appLevelArray.push({ label: "Budget Clerk", value: 2})
                //setApproverLevelForRejet([{ label: "Initiator", value: 1 }])

                //setApproverLevelForRejet([{ label: "Budget Clerk", value: 1 }])

                break;

            case budgetManagerApprover:
                appLevelArray.push({ label: "Initiator", value: 1 });
                if (secondApprover) {
                    appLevelArray.push({ label: "Budget Clerk", value: 2 });

                    let first = approverOption.filter(item => item.type === "budgetClerk");
                    setFallBackApprover(first);
                } else {
                    let first = approverOption.filter(item => item.type === "Initiator");
                    setFallBackApprover(first);
                }

                // setApproverLevelForRejet([{ label: "Budget Clerk", value: 2 }])
                break;

            case thirdApprover:
                appLevelArray.push({ label: "Initiator", value: 1 });
                if (secondApprover) {
                    appLevelArray.push({ label: "Budget Clerk", value: 2 });
                    appLevelArray.push({ label: "Budget Manager", value: 3 });

                    let first = approverOption.filter(item => item.type === "budgetClerk");
                    setFallBackApprover(first);
                } else {
                    let first = approverOption.filter(item => item.type === "Initiator");
                    setFallBackApprover(first);
                }

                // setApproverLevelForRejet([{ label: "Budget Clerk", value: 2 }])
                break;

            case fourthApprover:
                appLevelArray.push({ label: "Initiator", value: 1 });
                if (secondApprover) {
                    appLevelArray.push({ label: "Budget Clerk", value: 2 });
                    appLevelArray.push({ label: "Budget Manager", value: 3 });
                }
                appLevelArray.push({ label: "HR Executive Secretary Approver", value: 4 });

                let first1 = approverOption.filter(item => item.type === "hrConsultant");
                setFallBackApprover(first1);
                //setApproverLevelForRejet()
                break;
            case fifthApprover:
                // setApproverLevelForRejet({ label: "Budget Clerk", value: 1 },
                // { label: "HR Consultant", value: 2 },
                // { label: "Executive Approver", value: 3 },
                // { label: "HR Executive Secretary", value: 4 })

                appLevelArray.push({ label: "Initiator", value: 1 });
                if (secondApprover) {
                    appLevelArray.push({ label: "Budget Clerk", value: 2 });
                    appLevelArray.push({ label: "Budget Manager", value: 3 });
                }
                appLevelArray.push({ label: "HR Executive Secretary Approver", value: 4 });
                appLevelArray.push({ label: "Executive Approver", value: 5 });
                appLevelArray.push({ label: "HR Executive Secretary Payroll", value: 6 });

                let first2 = approverOption.filter(item => item.type === "executive");
                setFallBackApprover(first2);

                break;

            default:
                break;
        }

        //set blank
        setFallBackApproverLevel("");
        setApproverLevelForRejet(appLevelArray);

        //approverListForReject
        //setFallBackApprover

        //approverListForReject
        //setFallBackApprover

        // PSATransactionCycleData = PSATransactionCycleData.map(res => {
        // const asigneeData = getAssigneeName(res);
        // return { ...res, assigneeData: asigneeData };
        // });

        let approvalFinalData = [];

        if (PSATransactionCycleData) {
            for (let i = 0; i < PSATransactionCycleData.length; i++) {
                let adminUsers;
                if (PSATransactionCycleData[i].to_Employee_Id) {
                    try {
                        adminUsers = await cognito
                            .adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: PSATransactionCycleData[i].to_Employee_Id
                            })
                            .promise();
                    } catch (e) {
                        //console.log(e)
                    }
                }
                let userId = adminUsers?.Username;
                let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : "";
                let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : "";
                let userCodeEmp = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode") : "";
                let fullName = userFirstName + " " + userLastName;

                //add designation in array start
                let designation = 'Initiator';
                if (PSATransactionCycleData[i].status === PSA_Status.PENDING_FOR_APPROVAL_BUDGET_CLERK && PSAConsultantData?.budgetClerk === PSATransactionCycleData[i].to_Employee_Id) {
                    designation = "Budget Clerk"
                } else if (PSAConsultantData?.budgetManager === PSATransactionCycleData[i].to_Employee_Id) {
                    designation = "Budget Manager"
                } else if (PSAConsultantData?.hrConsultant === PSATransactionCycleData[i].to_Employee_Id) {
                    //designation = "HR Consultant";
                    designation = "HR Executive Secretary (Approver)"

                } else if (PSAConsultantData?.executive === PSATransactionCycleData[i].to_Employee_Id) {
                    designation = "Executive Approver";
                }
                /* else if (PSAConsultantData?.submittedTo === PSATransactionCycleData[i].to_Employee_Id) {
                  designation = "Initiator";
                } */
                //for HR Secretary PAYROLL
                if (PSAConsultantData?.hrexecutive == PSATransactionCycleData[i].to_Employee_Id && PSATransactionCycleData[i].status === PSA_Status.PENDING_FOR_APPROVAL_HR_EXCECUTIVE_SECREATARY) {
                    //designation = "HR Executive Secretary";
                    designation = "HR Executive Secretary (HR/Payroll)"
                }

                //add designation in array end

                if (PSATransactionCycleData[i].to_Employee_Id === "1") {
                    fullName = "PSA Consultant";
                    userCodeEmp = "PSA 01";
                    designation = "PSA Consultant";
                }

                let appDate = PSATransactionCycleData[i].dateTime
                    ? PSATransactionCycleData[i].dateTime
                    : PSATransactionCycleData[i].updatedAt;

                console.log(PSATransactionCycleData[i].status, "PSATransactionCycleData[i].status");


                let dateTime = PSATransactionCycleData[i].isApproved ||
                    PSATransactionCycleData[i].status === "Rejected" ||
                    PSATransactionCycleData[i].status === "Acknowledged"
                    ? PSATransactionCycleData[i].dateTime : null;

                let obj = {
                    id: PSATransactionCycleData[i].id,
                    name: fullName,
                    title: userCodeEmp,
                    status: PSATransactionCycleData[i].isApproved ? "Approved" : PSATransactionCycleData[i].status,
                    isApproved: PSATransactionCycleData[i].isApproved,
                    updatedAt: handleDateSelect(appDate),
                    dateTime: handleDateSelect(dateTime),
                    userId,
                    designation: designation
                };

                approvalFinalData.push(obj);
            }
        }

        setApprovelStatusData(approvalFinalData);
        console.log("approvalFinalData1234", approvalFinalData);

        let formHistoryData = [{
            name: fullFirstName,
            status: "Submitted",
            dateTime: handleDateSelect(PSAConsultantData.createdAt),
            designation: "Initiator"
        }, ...approvalFinalData.reverse()];

        console.log("formHistoryData123", formHistoryData);

        setEvents(formHistoryData);

        // setApprovelStatusData(
        // PSATransactionCycleData.map(res => ({
        // id: res?.id,
        // title: res?.assigneeData?.userCode,
        // name: res?.assigneeData?.assigneeName,
        // status: res?.status
        // }))
        // );

        setSpecificReportDetailsEdit({
            PSAConsultantData: PSAConsultantData,
            PSATransactionCycleData: PSATransactionCycleData[0]
        });

        //const pSAPartyDat = await DataStore.query(PSAParty, c => c.psaConsultantId.eq(requestData?.id));
        const pSAPartyDat = await graphQLGetAllData("listPSAParties", [{ psaConsultantId: { eq: requestData?.id } }]);
        setPSAPartyData(pSAPartyDat?.[0]);
        setPsaconsultantData(PSAConsultantData);
        setFormData({ ...PSAConsultantData, ...pSAPartyDat?.[0], psaPatyUpdatedDate: PSATransactionCycleData?.[0]?.date });
        setFormViewData({
            ...PSAConsultantData,
            ...pSAPartyDat?.[0],
            psaPatyUpdatedDate: PSATransactionCycleData?.[0]?.date
        });
        setPsaConsultantDoc(pSAPartyDat);

        setInitiatorDocuments([]);
        if (requestData.id) {
            const getPSADocuments = () => {
                return new Promise(async (resolve, reject) => {
                    // let PSADocumentsData = await DataStore.query(PSADocuments, c => c?.reportId.eq(requestData.id), {
                    // sort: s => s.createdAt(SortDirection.ASCENDING)
                    // });
                    let PSADocumentsData = await graphQLGetAllData("listPSADocuments", [{ reportId: { eq: requestData?.id } }])
                    PSADocumentsData = PSADocumentsData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

                    resolve(PSADocumentsData);
                });
            };

            getPSADocuments().then(res => {
                setInitiatorDocuments(res);
            });
        }

        //ye sab code samajh nhi aaya kyu hai
        if (requestData) {
            //set manager data employee
            var newRes = [];
            let userRole = "",
                userName = "",
                userEmail = "",
                userCode = "",
                userReportingManager = "";

            users.forEach((user, i) => {
                userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
                userReportingManager = user.Attributes.find(attr => attr.Name === "custom:SPReportingManager")?.Value;

                let obj = {
                    userId: user.Username,
                    name: userName,
                    email: userEmail,
                    usercode: userCode,
                    role:
                        userRole === USER_TYPES.SUPERADMIN
                            ? USER_TYPES_NAMES.SA
                            : userRole === USER_TYPES.ADMIN
                                ? USER_TYPES_NAMES.A
                                : userRole === USER_TYPES.APPROVER
                                    ? USER_TYPES_NAMES.AP
                                    : userRole === USER_TYPES.PAYROLL
                                        ? USER_TYPES_NAMES.P
                                        : USER_TYPES_NAMES.I,
                    userReportingManager: userReportingManager
                };
                newRes.push(obj);
            });

            //get only those users are without admin
            let usersWithoutAdmin = [];
            const loggedUserId = reactLocalStorage.get("loggedUserId");

            newRes.map(currentItem => {
                if (currentItem.role !== "Admin" && currentItem.userId !== loggedUserId) {
                    usersWithoutAdmin.push(currentItem);
                }
            });

            fetchAndSetLoggedInUserData(loggedInUserData).then(data => {
                setLoggedInUserData(data);
            });

            //set employee list
            let finalEmpList = [];

            users.map(currentItem => {
                const getName = () => {
                    try {
                        let fname = currentItem.Attributes.filter(a => (a.Name === "custom:firstName" ? a.Value : ""));
                        let lname = currentItem.Attributes.filter(a => (a.Name === "custom:lastName" ? a.Value : ""));
                        return fname[0].Value + " " + lname[0].Value;
                    } catch (e) { }
                    return "";
                };
                const getUsercode = () => {
                    try {
                        let usercode = currentItem.Attributes.filter(a => (a.Name === "custom:userCode" ? a.Value : ""));
                        return usercode[0].Value;
                    } catch (e) { }
                    return "";
                };
                const getUserId = () => {
                    try {
                        let userId = currentItem.Attributes.filter(a => (a.Name === "sub" ? a.Value : ""));
                        return userId[0].Value;
                    } catch (e) { }
                    return "";
                };
                let obj = {
                    name: `${getName()} (${getUsercode()})`,
                    code: getUserId(),
                    userCode: getUsercode(),
                    label: getName()
                };
                finalEmpList.push(obj);
            });
            setEmpCodeList(finalEmpList);
            setAllEmployeeDetails(usersWithoutAdmin);
        }
        //-----------------------------------------
        const lastStatusData = approvalFinalData[approvalFinalData?.length - 1];
        setIsHrConsultant(false);
        //if (lastStatusData?.userId === PSAConsultantData?.hrConsultant) {
        // if (PSAConsultantData.hrConsultant === loggedUserId && approvalFinalData[approvalFinalData?.length - 1].status === PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION) {
        //   setIsHrConsultant(true);
        // }
        if (PSAConsultantData.hrexecutive === loggedUserId && approvalFinalData[approvalFinalData?.length - 1].status === PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION) {
            setIsHrConsultant(true);
        }
        setIsLoading(false);
        setPSAedit(true);
    };
    const approveData = []
    //approve selected



    const approveSelectedReport = async (reportId) => {
        //const PSAConsultantData = await DataStore.query(PSAConsultant, c => c.id.eq(reportId));

        const PSAConsultantData = await graphQLFindRecordById("getPSAConsultant", reportId);
        // setFourthApp(PSAConsultantData)
        // approveData.push(PSAConsultantData)

        // dateTime : new Date().toString()

        // const original = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(reportId), {
        // sort: s => s.createdAt(SortDirection.ASCENDING)
        // });

        // convertHtmlToBlobss()
        // return
        // if (loggedUserId === PSAConsultantData.executive) {
        //   debugger
        //   convertHtmlToBlobss()
        //   debugger
        //   return
        // }

        let original = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: reportId } }])
        original = original.sort((a, b) => (a.createdAt).localeCompare(b.createdAt));

        //fetch all approver
        // let teacher = PSAConsultant[0].employee_id;
        let secondApprover = PSAConsultantData.budgetClerk;
        let budgetManagerApprover = PSAConsultantData?.budgetManager;
        let thirdApprover = PSAConsultantData.hrConsultant;
        let fourthApprover = PSAConsultantData.executive;
        let fifthApprover = PSAConsultantData.hrexecutive;

        // let payrollId = PSAConsultant[0].payrollId;
        // let sixthApprover =  financeAnalyst?.userId ?? 0;

        var toEmployeeId = "";

        var psaStatus = PSA_Status.PENDING_FOR_APPROVAL_BUDGET_CLERK;
        var psaDesignation = PSA_Designation.BUDGET_CLERK;
        let PSAConsultantTransactionCycleResponseLate = original.length ? original[original.length - 1] : original[0];

        //case for HR Secretary Approver 
        if (PSAConsultantTransactionCycleResponseLate.status === PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION) {
            thirdApprover = PSAConsultantData.hrexecutive;
            fifthApprover = '';
        }

        //case for HR Secretary Payroll 
        if (PSAConsultantTransactionCycleResponseLate.status === PSA_Status.PENDING_FOR_APPROVAL_HR_EXCECUTIVE_SECREATARY) {
            thirdApprover = '';
            fifthApprover = PSAConsultantData.hrexecutive;
        }

        //case of review resubmitted
        if (PSAConsultantTransactionCycleResponseLate.status === PSA_Status.ReviewedResubmitted) {
            // await DataStore.save(
            // PSATransactionCycle.copyOf(PSAConsultantTransactionCycleResponseLate, updated => {
            // updated.isApproved = true;
            // updated.signature_File_Path = signaturePath;
            // updated.dateTime = moment().toISOString();
            ///// updated.status = 'Approved';
            // })
            // ) 

            await API.graphql({
                query: mutations.updatePSATransactionCycle,
                variables: {
                    input: {
                        id: PSAConsultantTransactionCycleResponseLate.id,
                        _version: PSAConsultantTransactionCycleResponseLate._version,
                        isApproved: true,
                        signature_File_Path: signaturePath,
                        dateTime: moment().toISOString(),
                    }
                }
            });


            // then(async () => {
            /////after we add another row for save report id for reporting managers approver
            // const addNewRowForRMReasponse = await DataStore.save(
            // new PSATransactionCycle({
            // report_Id: reportId,
            // from_Employee_Id: loggedUserId,
            // to_Employee_Id: PSAConsultantData[0].hrConsultant,
            // status: PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION,
            // isApproved: false,
            // remark: "",
            // approver_level: "HR_CONSULTANT_CLEARANCE_VERIFICATION",
            // date: moment().format("YYYY-MM-DD"),
            // dateTime: moment().toISOString()
            // })
            // );



            let newTrans = await API.graphql(
                graphqlOperation(mutations.createPSATransactionCycle, {
                    input: {
                        report_Id: reportId,
                        from_Employee_Id: loggedUserId,
                        to_Employee_Id: PSAConsultantData.hrConsultant,
                        status: PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION,
                        isApproved: false,
                        remark: "",
                        approver_level: "HR_CONSULTANT_CLEARANCE_VERIFICATION",
                        date: moment().format("YYYY-MM-DD"),
                        dateTime: moment().toISOString()
                    }
                })
            );

            // if (addNewRowForRMReasponse) {
            //   // setRequestApprovalConfirmVisible(true);
            //   setCheckedSignature(false);
            //   const reportDetails = await buildReportDetails(
            //     addNewRowForRMReasponse,
            //     PSAConsultantData[0].assignment_title,
            //     "Open",
            //     PSAConsultantData[0].submited_by,
            //     PSAConsultantData[0].employee_id,
            //     loggedUserId,
            //     PSAConsultantData[0].particular_emp_reporting_manager
            //   );
            //   await handleNotificationsOnStatusChange("Approved", reportDetails, "SIX_PERIOD");
            // }
            // updateRequestedReportList(reportId, "Approved", "Approved", approverDesignations.site_admin);
            // });
        } else {
            switch (loggedUserId) {
                //reporting manager.
                case secondApprover:
                    toEmployeeId = budgetManagerApprover;
                    psaStatus = PSA_Status.PENDING_FOR_APPROVAL_BUDGET_MANAGER;
                    psaDesignation = PSA_Designation.BUDGET_MANAGER;
                    break;

                case budgetManagerApprover:
                    toEmployeeId = thirdApprover;
                    psaStatus = PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION
                    psaDesignation = PSA_Designation.HR_EXCECUTIVE_SECREATARY_APPROVER
                    break;
                case thirdApprover:
                    toEmployeeId = fourthApprover;
                    psaStatus = PSA_Status.PENDING_FOR_APPROVAL_EXECUTIVE_APPROVER;
                    psaDesignation = PSA_Designation.EXECUTIVE_APPROVER;
                    break;
                case fourthApprover:
                    toEmployeeId = fifthApprover;
                    psaStatus = PSA_Status.PENDING_FOR_APPROVAL_HR_EXCECUTIVE_SECREATARY;
                    psaDesignation = PSA_Designation.HR_EXCECUTIVE_SECREATARY_PAYROLL;
                    break;
                case fifthApprover:
                    toEmployeeId = "NO_APPROVAL";
                    psaStatus = PSA_Status.ACKNOWLEDGE;
                    psaDesignation = "";
                    break;

                default:
                    // Assign a default variable value if the logged user is not an approver
                    toEmployeeId = "NO_APPROVAL"; //PSAConsultantData[0].payrollId;
                    psaStatus = PSA_Status.ACKNOWLEDGE;
                    psaDesignation = "";
                    break;
            }
            // switch (loggedUserId) {
            //   //reporting manager.
            //   case secondApprover:
            //     toEmployeeId = thirdApprover;
            //     psaStatus = PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION;
            //     break;
            //   case thirdApprover:
            //     toEmployeeId = fourthApprover;
            //     psaStatus = PSA_Status.PENDING_FOR_APPROVAL_EXECUTIVE_APPROVER;
            //     break;
            //   case fourthApprover:
            //     toEmployeeId = fifthApprover;
            //     psaStatus = PSA_Status.PENDING_FOR_APPROVAL_HR_EXCECUTIVE_SECREATARY;
            //     break;
            //   case fifthApprover:
            //     toEmployeeId = "NO_APPROVAL";
            //     psaStatus = PSA_Status.ACKNOWLEDGE;
            //     break;

            //   default:
            //     // Assign a default variable value if the logged user is not an approver
            //     toEmployeeId = "NO_APPROVAL"; //PSAConsultantData[0].payrollId;
            //     psaStatus = PSA_Status.ACKNOWLEDGE;
            //     break;
            // }

            if (toEmployeeId === "NO_APPROVAL") {

                // await DataStore.save(
                // PSATransactionCycle.copyOf(PSAConsultantTransactionCycleResponseLate, updated => {
                // updated.isApproved = true;
                // updated.status = psaStatus;
                // updated.signature_File_Path = signaturePath;
                // updated.dateTime = moment().toISOString();
                // })
                // );


                await API.graphql({
                    query: mutations.updatePSATransactionCycle,
                    variables: {
                        input: {
                            id: PSAConsultantTransactionCycleResponseLate.id,
                            _version: PSAConsultantTransactionCycleResponseLate._version,
                            isApproved: true,
                            status: psaStatus,
                            signature_File_Path: signaturePath,
                            dateTime: moment().toISOString()
                        }
                    }
                });

            } else {
                // await DataStore.save(
                // PSATransactionCycle.copyOf(PSAConsultantTransactionCycleResponseLate, updated => {
                // updated.isApproved = true;
                ///////updated.status = "Approved";
                // updated.signature_File_Path = signaturePath;
                // updated.dateTime = moment().toISOString();
                // })
                // )


                await API.graphql({
                    query: mutations.updatePSATransactionCycle,
                    variables: {
                        input: {
                            id: PSAConsultantTransactionCycleResponseLate.id,
                            _version: PSAConsultantTransactionCycleResponseLate._version,
                            isApproved: true,
                            signature_File_Path: signaturePath,
                            dateTime: moment().toISOString()
                        }
                    }
                });


                //then(async () => {
                //////after we add another row for save
                // const addNewRowForRMReasponse = await DataStore.save(
                // new PSATransactionCycle({
                // report_Id: reportId,
                // from_Employee_Id: loggedUserId,
                // to_Employee_Id: toEmployeeId,
                // status: psaStatus, //// pending for approval
                // isApproved: false,
                // remark: "",
                // date: moment().format("YYYY-MM-DD"),
                // dateTime: moment().toISOString(),
                // designation: psaDesignation
                // })
                // );

                let newTransa = await API.graphql(
                    graphqlOperation(mutations.createPSATransactionCycle, {
                        input: {
                            report_Id: reportId,
                            from_Employee_Id: loggedUserId,
                            to_Employee_Id: toEmployeeId,
                            status: psaStatus, //// pending for approval
                            isApproved: false,
                            remark: "",
                            date: moment().format("YYYY-MM-DD"),
                            dateTime: moment().toISOString(),
                            designation: psaDesignation
                        }
                    })
                );

                // await DataStore.save(
                // PSAConsultant.copyOf(PSAConsultantData[0], updated => {
                // updated.status = "Approved";
                // updated.signature_File_Path = signaturePath;
                // updated.dateTime = moment().toISOString();
                // })
                // );

                try {
                    await API.graphql({
                        query: mutations.updatePSAConsultant,
                        variables: {
                            input: {
                                id: PSAConsultantData.id,
                                _version: PSAConsultantData._version,
                                status: "Approved",
                                signature_File_Path: signaturePath,
                                dateTime: moment().toISOString(),
                            }
                        }
                    });
                }
                catch (e) {
                    console.log(e, "errrrr")
                }
                //});
            }

            if (ackUser) {
                await handleNotificationsOnStatusChangeforPSA(
                    psaStatus,
                    reportId,
                    "PERSONAL_SERVICE_AGREEMENT",
                    PSAConsultantData.createdBy,
                    PSAConsultantData.createdBy,
                    ""
                );

                // await handleNotificationsOnStatusChangeforPSA(
                //   psaStatus,
                //   reportId,
                //   "PERSONAL_SERVICE_AGREEMENT",
                //   PSAConsultantData[0].createdBy,
                //   PSAConsultantData[0].createdBy,
                //   ""
                // );

                //get initiator name
                let url = [];
                const psaconsultantDoc1 = psaconsultantViewDoc.map(res => {
                    return ({ filepath: "psaconsultant/" + res.psaConsultantId + "/document/psaparty/" + res?.filename, filename: res?.filename });
                })
                const psaconsultantDoc2 = psaconsultantViewDoc.map(res => {
                    return ({ filepath: "psaconsultant/" + res.psaConsultantId + "/document/psaparty/" + res?.filename, filename: res?.filename2 });
                })
                console.log("urlurlurl psaconsultantDoc2psaconsultantDoc2:-", psaconsultantDoc2);
                //-----------------------------------------------------------
                let termsAndConditionDoc1 = [{ filename: psaconsultantDoc[0].filename, filepath: await getDocumentURL("psaconsultant/" + psaconsultantDoc[0].psaConsultantId + "/document/psaparty/" + psaconsultantDoc[0].filename) }]
                let termsAndConditionDoc2 = [{ filename: psaconsultantDoc[0].filename2, filepath: await getDocumentURL("psaconsultant/" + psaconsultantDoc[0].psaConsultantId + "/document/psaparty/" + psaconsultantDoc[0].filename2) }]
                {
                    psaconsultantDoc.map(res => {
                        return (
                            // <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
                            // <h5>
                            <p
                                className="psa-attachments-notes-remove-btn"
                                style={{ cursor: "pointer", fontSize: "14px" }}
                                onClick={() => {
                                    const filePath =
                                        "psaconsultant/" + res.psaConsultantId + "/document/psaparty/" + res?.filename2;
                                    res?.filename2 && OpenDocument(filePath);
                                }}
                            >
                                {res?.filename2}
                            </p>
                        );
                    })
                }

                //----------------------------------------------------------
                // const filePathForPSAForm = [{filepath:"public/psareport/"+reportId+"/PSAReport.pdf",filename:'PSAReport'}];
                let urlForPsaForm = [{ filename: "PSAReport.pdf", filepath: await getDocumentURL("public/psareport/" + reportId + "/PSAReport.pdf") }]

                const allFilePathData = [...initiatorDocuments, ...partyDocuments, ...psaconsultantDoc1, ...psaconsultantDoc2]
                for (const res of allFilePathData) {
                    if (res?.filepath) {
                        url.push({
                            filename: res?.filename,
                            filepath: await getDocumentURL(res?.filepath)
                        });
                    }
                }

                fetchAndSetLoggedInUserData(PSAConsultantData.createdBy).then(data => {
                    //then send email to submitted to email
                    let emailMessageList = [
                        {
                            to: PSAConsultantData.submittedCompletedFormTo,
                            type: "EMAIL",
                            user_id: "",
                            subject: "PSA Form Submission Confirmation ",
                            emailSubject: "PSA Form Submission Confirmation ",
                            // emailMessage: `Hello+ ${PSAConsultantData[0].submittedCompletedFormTo}",<br> Report titled Personal Service Agreement -" ${PSAConsultantData[0].assignmentTitle} is Completed.`
                            emailMessage: `
                Hi <br><br><br><br>
                This is to inform you that the Personnel Service Agreement (PSA) form, initiated by ${data.name} on ${moment(
                                PSAConsultantData
                            ).format(
                                "MM-DD-YYYY"
                            )}, has been successfully approved. Attached to this email, you will find the fully executed PSA form, along with the supporting documents. 
    
              <ul style="list-style: decimal;display:block">
              ${url.map(
                                res => `
                <li>
              
                <a href="${res?.filepath}" 
                style="color: black;">  
                ${res?.filename}
                </a> 
                </li>`
                            )}

              <h3>Terms & Condition Documents</h3>
              <li>
              <a href="${termsAndConditionDoc1[0].filepath}" 
                style="color: black;">  
                ${termsAndConditionDoc1[0].filename}
                </a></li> </br>
                <li><a href="${termsAndConditionDoc2[0].filepath}" 
                style="color: black;">  
                ${termsAndConditionDoc2[0].filename}
                </a>
                </li>
            </ul>  
            <ul style="list-style: decimal;display:block">
            <h3>PSA Report</h3>
                <a href="${urlForPsaForm[0].filepath}" 
                style="color: black;">  
                ${urlForPsaForm[0].filename}
            </ul>  

              <br><br><br><br>
                
                NOTE: This is a system generated e-mail and please do not reply. If you have questions regarding the approved form, please contact ${data.name
                                } at ${data.email} 
                `
                        }
                    ];
                    emailMessageList?.map(email => {
                        if (email) {
                            createEmailNotifications(
                                email.to,
                                email.user_id,
                                email.type,
                                id,
                                "PERSONAL_SERVICE_AGREEMENT",
                                email.emailSubject,
                                email.emailMessage,
                                "PERSONAL_SERVICE_AGREEMENT"
                            );
                        }
                    });
                });
            } else {
                await handleNotificationsOnStatusChangeforPSA(
                    psaStatus,
                    reportId,
                    "PERSONAL_SERVICE_AGREEMENT",
                    toEmployeeId,
                    // loggedUserId,
                    PSAConsultantData.createdBy,
                    ""
                );
                await handleNotificationsOnStatusChangeforPSA(
                    "APPROVEDBY",
                    reportId,
                    "PERSONAL_SERVICE_AGREEMENT",
                    PSAConsultantData.createdBy,
                    loggedUserId,
                    value,
                    PSAConsultantData.createdAt
                );

                // if (loggedUserId === PSAConsultantData.executive) {
                //   convertHtmlToBlobss()
                // }

                //check second last app
                // if (loggedUserId === fourthApprover) {
                //   //call function to save updated report to s3 bucket 
                //   // childRef.current.generatePDF()
                //   // alert("Fourth App")
                //   // childRef.current.convertHtmlToBlob()
                //   alert("3444")

                //   setFourthApp(fourthApprover)
                //   // convertHtmlToBlob(PSAConsultantData.id)
                // }
            }
        }
        setPSAedit(false);
        setPleaseWaitButton(false);
        setButtonClicked(true);
        setAckUser(false);
        //load requested report approvers

        //loadRequestReports();
        BindList();

        return loggedUserId === PSAConsultantData.executive

    };


    //reject select report

    const rejectSelectedReport = async reportId => {
        if (value === "") {
            toast.error("Please Add Reason For Rejection");
            return;
        }

        // if (fallBackApproverLevel === '' || fallBackApproverLevel === null) {
        // toast.error("Please Select Approver Level");
        // return;
        // }

        // if (fallBackApprover === '' || fallBackApprover === null) {
        // toast.error("Please Select Approver");
        // return;
        // }

        setAckUser(false);
        //const reportData = await DataStore.query(PSAConsultant, reportId);
        const reportData = await graphQLFindRecordById("getPSAConsultant", reportId);

        try {

            // const original = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(reportId), {
            // sort: s => s.createdAt(SortDirection.ASCENDING)
            // });

            let original = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: reportId } }])
            original = original.sort((a, b) => (a.createdAt).localeCompare(b.createdAt));

            let newOriginal = original.length ? original[original.length - 1] : original[0];

            // for (let i = 0; i < original.length; i++) {
            // let currentItem = original[i];

            // if (currentItem.to_Employee_Id === loggedUserId) {
            // newOriginal.push(currentItem);
            // break;
            // }
            // }
            let copyRemark = "";
            // await DataStore.save(
            // PSATransactionCycle.copyOf(newOriginal, updated => {
            // updated.status = PSA_Status.REJECTED;
            // updated.remark = value;
            // updated.dateTime = moment().toISOString();
            // })
            // )

            await API.graphql({
                query: mutations.updatePSATransactionCycle,
                variables: {
                    input: {
                        id: newOriginal.id,
                        _version: newOriginal._version,
                        status: PSA_Status.REJECTED,
                        remark: value,
                        dateTime: moment().toISOString(),
                    }
                }
            });

            //.then(async response => {
            if (fallBackApproverLevel) {
                //const approverLevels = ["initiator", "BUDGET_CLERK",  "HR_CONSULTANT_CLEARANCE_VERIFICATION", "EXECUTIVE_APPROVER", "HR_EXCECUTIVE_SECREATARY"];
                let pStatus = PSA_Status.REJECTED;

                if (approverLevels[fallBackApproverLevel - 1] === "Initiator") {
                    pStatus = PSA_Status.REJECTED;
                    copyRemark = value;
                } else if (approverLevels[fallBackApproverLevel - 1] === "BUDGET_CLERK") {
                    pStatus = PSA_Status.PENDING_FOR_APPROVAL_BUDGET_CLERK;
                    copyRemark = value;
                } else if (approverLevels[fallBackApproverLevel - 1] === "BUDGET_MANAGER") {
                    pStatus = PSA_Status.PENDING_FOR_APPROVAL_BUDGET_MANAGER;
                    copyRemark = value;
                } else if (approverLevels[fallBackApproverLevel - 1] === "HR_CONSULTANT_CLEARANCE_VERIFICATION") {
                    pStatus = PSA_Status.PENDING_FOR_APPROVAL_HR_CONSULTANT_CLEARANCE_VERIFICATION;
                    copyRemark = value;
                } else if (approverLevels[fallBackApproverLevel - 1] === "EXECUTIVE_APPROVER") {
                    pStatus = PSA_Status.PENDING_FOR_APPROVAL_EXECUTIVE_APPROVER;
                    copyRemark = value;
                } else if (approverLevels[fallBackApproverLevel - 1] === "HR_EXCECUTIVE_SECREATARY") {
                    pStatus = PSA_Status.PENDING_FOR_APPROVAL_HR_EXCECUTIVE_SECREATARY;
                    copyRemark = value;
                }

                // const addNewRowForRMReasponse = await DataStore.save(
                // new PSATransactionCycle({
                // report_Id: reportId,
                // from_Employee_Id: loggedUserId,
                // to_Employee_Id: fallBackApprover?.code,
                // status: pStatus,
                // isApproved: false,
                // approver_level: approverLevels[fallBackApproverLevel],
                // remark: copyRemark,
                // date: moment().format("YYYY-MM-DD"),
                // dateTime: moment().toISOString()
                // })
                // );

                const addNewRowForRMReasponse = await API.graphql(
                    graphqlOperation(mutations.createPSATransactionCycle, {
                        input: {
                            report_Id: reportId,
                            from_Employee_Id: loggedUserId,
                            to_Employee_Id: fallBackApprover?.code,
                            status: pStatus,
                            isApproved: false,
                            approver_level: approverLevels[fallBackApproverLevel],
                            remark: copyRemark,
                            date: moment().format("YYYY-MM-DD"),
                            dateTime: moment().toISOString()
                        }
                    })
                );

                // if (addNewRowForRMReasponse) {
                // const reportDetails = await buildReportDetails(addNewRowForRMReasponse, reportData[0].assignment_title, "Rejected", reportData[0].submited_by, reportData[0].employee_id, loggedUserId, fallBackApprover);
                // await handleNotificationsOnStatusChange("Rejected", reportDetails, "PSA");

                // }
                // updateRequestedReportList(reportId, "Approved", "Approved", approverDesignations[approverLevels[fallBackApproverLevel - 1]])
            }

            //else {
            // const responseRow = { report_Id: reportId, date: reportData[0]?.createdAt, status: "Rejected" }
            // const reportDetails = await buildReportDetails(responseRow, reportData[0].assignment_title, "Rejected", reportData[0].submited_by, reportData[0].employee_id, loggedUserId, fallBackApprover);
            // await handleNotificationsOnStatusChange("Rejected", reportDetails, "PSA");
            // updateRequestedReportList(reportId, "Approved", "Rejected", approverDesignations[approverLevels[fallBackApproverLevel - 1]])
            // }
            // setSendMsg(true);

            //});

            setStipendsFormFullScreen(false);
            setPSAedit(false);

            await handleNotificationsOnStatusChangeforPSA(
                "REJECTED",
                reportId,
                "PERSONAL_SERVICE_AGREEMENT",
                fallBackApprover?.code,
                loggedUserId,
                value
            );



            //send to initiator
            if (reportData?.createdBy !== fallBackApprover?.code) {
                await handleNotificationsOnStatusChangeforPSA(
                    "REJECTED",
                    reportId,
                    "PERSONAL_SERVICE_AGREEMENT",
                    reportData?.createdBy,
                    loggedUserId,
                    value
                );
            }

            //load list after status update
            // loadRequestReports();
            setPSAedit(false);
            setButtonClicked(true);
            setReportLoadingApprover(true)
            BindList();

        } catch (err) { }
    };

    //* onclick view popup
    const onClickViewPopup = async (requestData, position) => {
        setPosition(position);
        setVisible(true);
        const id = requestData?.id
        //set Data for View Popup
        let obj = {
            employee_id: requestData.employee_id,
            assighment_at: requestData.assighment_at,
            from_date: requestData.from_date,
            to_date: requestData.to_date,
            subject_area: requestData.subject_area,
            total_staffing_allocation: requestData.total_staffing_allocation,
            account_charged: requestData.account_charged,
            current_fte_utilized: requestData.current_fte_utilized
        };
        setSpecificReportDetailsView(obj);

        const PSAConsultantData = await graphQLFindRecordById("getPSAConsultant", id);
        const cognito = new AWS.CognitoIdentityServiceProvider();


        // let PSATransactionCycleData = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(id), {
        // sort: s => s.createdAt(SortDirection.ASCENDING)
        // });

        let PSATransactionCycleData = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: id } }])
        PSATransactionCycleData = PSATransactionCycleData.sort((a, b) => (a.createdAt).localeCompare(b.createdAt));

        //const PSAData = await DataStore.query(PSAConsultant, id);
        const PSAData = await graphQLFindRecordById("getPSAConsultant", id);
        let initiaterName;

        if (PSAData.createdBy) {
            try {
                initiaterName = await cognito
                    .adminGetUser({
                        UserPoolId: awsmobile.aws_user_pools_id,
                        Username: PSAData.createdBy
                    })
                    .promise();
            } catch (e) { }
        }
        let userFirstName = initiaterName ? await GetValueFromArray(initiaterName.UserAttributes, "custom:firstName") : "";
        let userLastName = initiaterName ? await GetValueFromArray(initiaterName.UserAttributes, "custom:lastName") : "";
        let fullInitiatorName = userFirstName + " " + userLastName;

        //const pSAPartyDat = await DataStore.query(PSAParty, c => c.psaConsultantId.eq(PSAData?.id));
        let pSAPartyDat = await graphQLGetAllData("listPSAParties", [{ psaConsultantId: { eq: PSAData?.id } }])

        console.log(pSAPartyDat, "pSAPartyDat11")
        setPsaconsultantViewDoc(pSAPartyDat);
        setPSAPartyData(pSAPartyDat?.[0]);
        setPsaconsultantData(PSAData);

        // let PSATransactionCycleData1 = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(PSAData?.id), {
        // sort: s => s.dateTime(SortDirection.DESCENDING)
        // });

        let PSATransactionCycleData1 = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: PSAData?.id } }])
        PSATransactionCycleData1 = PSATransactionCycleData1.sort((a, b) => (b.dateTime).localeCompare(a.dateTime));


        //PSAData.filename = pSAPartyDat && pSAPartyDat?.[0] ? pSAPartyDat[0].filename : '';

        setFormData({ ...PSAData, ...pSAPartyDat?.[0], psaPatyUpdatedDate: PSATransactionCycleData1?.[0]?.date });
        setFormViewData({ ...PSAData, ...pSAPartyDat?.[0], psaPatyUpdatedDate: PSATransactionCycleData1?.[0]?.date });
        let approvalFinalData = [];
        let eventmain = [];
        let identifyHR = [];
        //console.log(PSATransactionCycleData,"PSATransactionCycleData")
        if (PSATransactionCycleData) {
            for (let i = 0; i < PSATransactionCycleData.length; i++) {
                let adminUsers;
                if (PSATransactionCycleData[i].to_Employee_Id) {
                    try {
                        adminUsers = await cognito
                            .adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: PSATransactionCycleData[i].to_Employee_Id
                            })
                            .promise();
                    } catch (e) { }
                }
                let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : "";
                let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : "";
                let userCodeEmp = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode") : "";
                let fullName = userFirstName + " " + userLastName;

                if (PSATransactionCycleData[i].to_Employee_Id === "1") {
                    fullName = "PSA Consultant";
                    userCodeEmp = "PSA 01";
                }

                //check rewiew and resubmit case
                if (PSATransactionCycleData[i].status === "Reviewed Resubmitted") {
                    let initiateUser;
                    if (PSATransactionCycleData[i].from_Employee_Id) {
                        try {
                            initiateUser = await cognito
                                .adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: PSATransactionCycleData[i].from_Employee_Id
                                })
                                .promise();
                        } catch (e) {
                            //console.log(e)
                        }
                    }
                    let userFirstName = adminUsers
                        ? await GetValueFromArray(initiateUser.UserAttributes, "custom:firstName")
                        : "";
                    let userLastName = adminUsers ? await GetValueFromArray(initiateUser.UserAttributes, "custom:lastName") : "";
                    let userCodeEmp = adminUsers ? await GetValueFromArray(initiateUser.UserAttributes, "custom:userCode") : "";
                    fullName = userFirstName + " " + userLastName;
                }

                let appDate = PSATransactionCycleData[i].dateTime
                    ? PSATransactionCycleData[i].dateTime
                    : PSATransactionCycleData[i].updatedAt;

                // let dateTime = PSATransactionCycleData[i].dateTime;
                let dateTime = PSATransactionCycleData[i].isApproved ||
                    PSATransactionCycleData[i].status === "Rejected" ||
                    PSATransactionCycleData[i].status === "Acknowledged"
                    ? PSATransactionCycleData[i].dateTime : null;

                console.log("PSA_StatusPSA_Status", PSATransactionCycleData[i])
                console.log("dateTimedateTime", dateTime)

                let designation = "Initiator";

                if (
                    PSAConsultantData?.budgetClerk &&
                    PSATransactionCycleData[i].to_Employee_Id === PSAConsultantData?.budgetClerk
                ) {
                    designation = "Budget Clerk";
                } else if (
                    PSAConsultantData?.budgetManager &&
                    PSATransactionCycleData[i].to_Employee_Id === PSAConsultantData?.budgetManager
                ) {
                    designation = "Budget Manager";
                } else if (PSAConsultantData?.hrConsultant === PSATransactionCycleData[i].to_Employee_Id) {
                    //designation = "HR Consultant";
                    designation = PSATransactionCycleData[i].designation && PSATransactionCycleData[i].designation === PSA_Designation.HR_EXCECUTIVE_SECREATARY_APPROVER ? "HR Executive Secretary (Approver)" : "HR Executive Secretary (Approver)"
                    identifyHR.push(PSATransactionCycleData[i].to_Employee_Id)
                } else if (PSAConsultantData?.executive === PSATransactionCycleData[i].to_Employee_Id) {
                    designation = "Executive Approver";
                }
                /*  else if (PSAConsultantData?.submittedTo === PSATransactionCycleData[i].to_Employee_Id) {
                   designation = "Initiator";
                 } */

                if (PSAConsultantData?.hrexecutive === PSATransactionCycleData[i].to_Employee_Id) {
                    //designation = "HR Executive Secretary";

                    if (PSATransactionCycleData[i].status === PSA_Status.PENDING_FOR_APPROVAL_HR_EXCECUTIVE_SECREATARY || PSATransactionCycleData[i].status === PSA_Status.ACKNOWLEDGE) {
                        designation = "HR Executive Secretary (HR/Payroll)";
                    }
                }

                //  if (PSATransactionCycleData[i].status === PSA_Status.REJECTED){
                //   designation =   "Initiator";
                //  }

                if (PSATransactionCycleData[i].to_Employee_Id === "1") {
                    fullName = "PSA Consultant";
                    userCodeEmp = "PSA 01";
                    designation = "PSA Consultant";
                }

                if (i == 0) {
                    let obj = {
                        name: fullInitiatorName,
                        status: "Submitted",
                        dateTime: handleDateSelect(PSAData.createdAt),
                        designation: "Initiator"
                    };
                    approvalFinalData.push(obj);
                }

                console.log("ApprovalFinalData", approvalFinalData);

                let obj = {
                    id: PSATransactionCycleData[i].id,
                    name: fullName,
                    title: userCodeEmp,
                    status:
                        PSATransactionCycleData[i].status == "Reviewed Resubmitted"
                            ? "Reviewed & Resubmitted"
                            : PSATransactionCycleData[i].isApproved
                                ? "Approved"
                                : PSATransactionCycleData[i].status,
                    isApproved: PSATransactionCycleData[i].isApproved,
                    updatedAt: handleDateSelect(appDate),
                    dateTime: handleDateSelect(dateTime),
                    designation: designation
                };

                approvalFinalData.push(obj);
            }
        }
        setEvents(approvalFinalData);

    };

    const onClickEditPopUp = async requestData => {
        setVisibleEdit(true);

        //set Data for View Popup
        let obj = {
            employee_id: requestData.employee_id,
            assighment_at: requestData.assighment_at,
            from_date: requestData.from_date,
            to_date: requestData.to_date,
            subject_area: requestData.subject_area,
            total_staffing_allocation: requestData.total_staffing_allocation,
            account_charged: requestData.account_charged,
            current_fte_utilized: requestData.current_fte_utilized
        };
        setSpecificReportDetailsEdit(obj);
    };

    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region
    });

    const toggleActive = () => {
        setActivate(activate === "actives" ? "" : "actives");
    };

    async function onLoad() {
        try {
            await Auth.currentSession();
            if (!ValidateInitiatorRole()) {
                userHasAuthenticated(false);
            }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region
    });

    //*get getEmployeeResponse
    const getEmployeeResponse = id => {
        let _employeeList = [...employeeList];
        var returnRecord = _employeeList.find(o => o.id === String(id));
        if (returnRecord !== null && returnRecord !== undefined) {
            return returnRecord;
        } else {
            return null;
        }
    };

    const getRoutingList = async psaconsultantData => {
        let newData = [];

        if (psaconsultantData.budgetClerk) {
            //let empName = await DataStore.query(Employee, c => c.user_Id.eq(psaconsultantData.budgetClerk));
            let empName = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: psaconsultantData.budgetClerk } }])
            let name = empName[0].employee_code
                ? `${empName[0].employee_name} (${empName[0].employee_code})`
                : empName[0].employee_name;

            let obj1 = { name: name, code: psaconsultantData.budgetClerk };
            newData.push(obj1);
        }

        if (psaconsultantData.budgetManager) {
            //let empName = await DataStore.query(Employee, c => c.user_Id.eq(psaconsultantData.budgetManager));
            let empName = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: psaconsultantData.budgetManager } }])
            let name = empName[0].employee_code
                ? `${empName[0].employee_name} (${empName[0].employee_code})`
                : empName[0].employee_name;

            let objbm = { name: name, code: psaconsultantData.budgetManager };
            newData.push(objbm);
        }

        //second
        if (psaconsultantData.hrConsultant) {
            //let empName = await DataStore.query(Employee, c => c.user_Id.eq(psaconsultantData.hrConsultant));
            let empName = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: psaconsultantData.hrConsultant } }])

            let name = empName[0].employee_code
                ? `${empName[0].employee_name} (${empName[0].employee_code})`
                : empName[0].employee_name;

            let obj2 = { name: name, code: psaconsultantData.hrConsultant };
            newData.push(obj2);
        }

        //third
        if (psaconsultantData.executive) {
            //let empName = await DataStore.query(Employee, c => c.user_Id.eq(psaconsultantData.executive));
            let empName = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: psaconsultantData.executive } }]);
            let name = empName[0].employee_code
                ? `${empName[0].employee_name} (${empName[0].employee_code})`
                : empName[0].employee_name;

            let obj3 = { name: name, code: psaconsultantData.executive };
            newData.push(obj3);
        }

        //fourth
        if (psaconsultantData.hrexecutive) {
            //let empName = await DataStore.query(Employee, c => c.user_Id.eq(psaconsultantData.hrexecutive));

            let empName = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: psaconsultantData.hrexecutive } }]);

            let name = empName[0].employee_code
                ? `${empName[0].employee_name} (${empName[0].employee_code})`
                : empName[0].employee_name;

            let obj4 = { name: name, code: psaconsultantData.hrexecutive };
            newData.push(obj4);
        }

        setRoutingData(newData);
    };


    function getArchiveDesignation(currentItem) {
        let archiveDesignation = PSA_ARCHIVE_DESIG.Initiator;
        if (currentItem?.budgetClerk === loggedUserId) {
            archiveDesignation = PSA_ARCHIVE_DESIG.budgetClerk
        } else if (currentItem.budgetManager === loggedUserId) {
            archiveDesignation = PSA_ARCHIVE_DESIG.budgetManagerApprover
        } else if (currentItem.executive === loggedUserId) {
            archiveDesignation = PSA_ARCHIVE_DESIG.executiveApprover
        } else if (currentItem.hrexecutive === loggedUserId) {
            archiveDesignation = PSA_ARCHIVE_DESIG.hrExecutiveApprover
        }
        return archiveDesignation;

    }

    //Get PSAConsultant List
    const BindList = async () => {
        // const loggedUserId = reactLocalStorage.get('loggedUserId');
        var index = 0
        var employeeList = await graphQLGetAllData("listEmployees")
        employeeList = employeeList.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));


        setEmployeeList(employeeList);

        //fetch all PSAConsultant table data  Initiator
        let pSAConsultantReportResponseAll = await graphQLGetAllData("listPSAConsultants") //, [{ createdBy: { eq: loggedUserId } }]


        let pSAConsultantReportResponse = pSAConsultantReportResponseAll
        var cycleData = await graphQLGetAllData("listPSATransactionCycles")
        try {
            // const pSAConsultantReportResponse = await DataStore.query(PSAConsultant, c => c.createdBy.eq(loggedUserId), {
            // sort: s => s.createdAt(SortDirection.ASCENDING)
            // });
            pSAConsultantReportResponse = pSAConsultantReportResponse.filter(item => item?.isSoftDelete !== true);

            pSAConsultantReportResponse = pSAConsultantReportResponse.sort((a, b) => (a.createdAt).localeCompare(b.createdAt));
            cycleData = cycleData.sort((a, b) => (a.dateTime).localeCompare(b.dateTime));

            if (pSAConsultantReportResponse) {
                //change data format according to UI.

                let finalData = [];
                const currentDateTime = moment();

                outerLoop:
                for (let i = 0; i < pSAConsultantReportResponse.length; i++) {
                    let currentItem = pSAConsultantReportResponse[i];
                    let sn1 = i

                    try {

                        let PSAConsultantTransactionCycleResponse = cycleData.filter(e => e.report_Id === currentItem.id)  //cycleData.filter(e => e.report_Id.includes(currentItem.id))


                        let pStatus = '';
                        let transRemark = '';
                        if (PSAConsultantTransactionCycleResponse.length > 0) {
                            pStatus = PSAConsultantTransactionCycleResponse[PSAConsultantTransactionCycleResponse.length - 1].status;

                            transRemark = PSAConsultantTransactionCycleResponse[PSAConsultantTransactionCycleResponse.length - 1].remark;
                        }

                        let Assignee = "";
                        let adminUsers;
                        let assigneeId;
                        if (PSAConsultantTransactionCycleResponse.length) {
                            const cognito = new AWS.CognitoIdentityServiceProvider();

                            try {
                                adminUsers = await cognito.adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: (

                                        PSAConsultantTransactionCycleResponse[PSAConsultantTransactionCycleResponse.length - 1].status === "Rejected" && PSAConsultantTransactionCycleResponse[PSAConsultantTransactionCycleResponse.length - 1].to_Employee_Id === "1" ?
                                            pSAConsultantReportResponse[pSAConsultantReportResponse.length - 1].createdBy
                                            :
                                            PSAConsultantTransactionCycleResponse[PSAConsultantTransactionCycleResponse.length - 1].to_Employee_Id)
                                }).promise();
                            } catch (e) {
                                //console.log(e)
                            }

                            let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                            let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                            Assignee = userFirstName + " " + userLastName

                            assigneeId = PSAConsultantTransactionCycleResponse[PSAConsultantTransactionCycleResponse.length - 1].status === "Rejected" && PSAConsultantTransactionCycleResponse[PSAConsultantTransactionCycleResponse.length - 1].to_Employee_Id === "1" ?
                                pSAConsultantReportResponse[pSAConsultantReportResponse.length - 1].createdBy
                                :
                                PSAConsultantTransactionCycleResponse[PSAConsultantTransactionCycleResponse.length - 1].to_Employee_Id

                        }

                        let schoolDetails = schoolListArray.find(o => o.id === currentItem.department)


                        // let schoolDetails = await DataStore.query(Schools, currentItem.department);

                        // let pSAPartyData = await DataStore.query(PSAParty, c => c.psaConsultantId.eq(currentItem.id));
                        let pSAPartyData = psaPartyList.find(o => o.psaConsultantId === currentItem.id)



                        //add code from id get use info start

                        let fullInitiatorName = "";
                        if (currentItem.createdBy === loggedUserId) {
                            fullInitiatorName = loggedFirstName + " " + loggedLastName;
                        }
                        else if (currentItem.createdBy) {

                            try {
                                let x = employeeList.find(u => u.user_Id === currentItem.createdBy);
                                let fname = x?.firstName
                                let lname = x?.lastName
                                if (fname) {
                                    fullInitiatorName = fname;
                                }
                                if (lname) {
                                    fullInitiatorName += " " + lname;
                                }
                            } catch (e) {
                                console.info(e)
                            }
                        }

                        let archiveDesignation = getArchiveDesignation(currentItem)
                        console.log("currentItem isArchive", currentItem.isArchivedUsers)
                        if (currentItem?.isArchivedUsers) {
                            const archieveData = JSON.parse(currentItem?.isArchivedUsers);
                            console.log("currentItem isArchive", archieveData)
                            console.log("currentItem isArchive2", currentItem)
                            let isArchive = CheckArchive(archieveData, archiveDesignation, loggedUserId);
                            if (!isArchive) {
                                continue outerLoop;
                            }
                            index = index + 1
                        } else {
                            continue outerLoop;
                        }
                        //add code from id get use info end

                        let obj = {
                            archiveDesignation: archiveDesignation,
                            id: currentItem.id,
                            srNo: sn1,
                            assignmentTitle: currentItem.assignmentTitle ? currentItem.assignmentTitle : "",
                            department: schoolDetails ? schoolDetails.name : "",
                            psaEmail: currentItem.psaEmail ? currentItem.psaEmail : "",
                            agreementDate: currentItem.agreementDate
                                ? moment(currentItem.agreementDate).format("MM/DD/YYYY")
                                : moment(currentDateTime).toISOString(),
                            amount: currentItem.amount ? currentItem.amount : "",
                            effectiveDate: currentItem.effectiveDate
                                ? moment(currentItem.effectiveDate).format("MM/DD/YYYY")
                                : moment(currentDateTime).toISOString(),
                            expireDate: currentItem.expireDate
                                ? moment(currentItem.expireDate).format("MM/DD/YYYY")
                                : moment(currentDateTime).toISOString(),
                            reviewDate: currentItem.reviewDate
                                ? moment(currentItem.reviewDate).format("MM/DD/YYYY")
                                : moment(currentDateTime).toISOString(),
                            notifyDays: currentItem.notifyDays
                                ? moment(currentItem.notifyDays).format("MM/DD/YYYY")
                                : moment(currentDateTime).toISOString(),
                            accountNo: currentItem.accountNo ? currentItem.accountNo : "",
                            dateofboard: currentItem.dateofboard ? currentItem.dateofboard : "",
                            boardItem: currentItem.boardItem ? currentItem.boardItem : "",
                            pageItem: currentItem.pageItem ? currentItem.pageItem : "",
                            businessEntity: currentItem.businessEntity ? currentItem.businessEntity : "",
                            addendum: currentItem.addendum ? currentItem.addendum : "",
                            addendumNo: currentItem.addendumNo ? currentItem.addendumNo : "",
                            notes: currentItem.notes ? currentItem.notes : "",
                            otherRemark: currentItem.otherRemark ? currentItem.otherRemark : "",
                            // partyName: pSAPartyData ? pSAPartyData.party : "",
                            partyName: pSAPartyData && pSAPartyData.party ? pSAPartyData.party : (currentItem.submittedTo) ? currentItem.submittedTo : "---",
                            clientId: pSAPartyData && pSAPartyData.clientId ? pSAPartyData.clientId : "",
                            pOCName: pSAPartyData && pSAPartyData.pocName ? pSAPartyData.pocName : "",
                            pOCContactNo: pSAPartyData && pSAPartyData.pocNumber ? pSAPartyData.pocNumber : "",
                            partyEmail: pSAPartyData && pSAPartyData.email ? pSAPartyData.email : "",
                            socialSecurityNumber: pSAPartyData && pSAPartyData.ssn ? pSAPartyData.ssn : "",
                            employerIdentification:
                                pSAPartyData && pSAPartyData.employerID ? pSAPartyData.employerID : "",
                            address: pSAPartyData && pSAPartyData.address ? pSAPartyData.address : "",
                            city: pSAPartyData && pSAPartyData.city ? pSAPartyData.city : "",
                            state: pSAPartyData && pSAPartyData.state ? pSAPartyData.state : "",
                            postalCode: pSAPartyData && pSAPartyData.zip ? pSAPartyData.zip : "",
                            assignee: pStatus === 'Acknowledged by HR Executive Secretary'
                                || pStatus === '' ?
                                "-" : pStatus === 'Pending for approval PSA Consultant' ? currentItem.psaEmail :
                                    Assignee,
                            assigneeId: assigneeId,
                            submittedOn: currentItem.createdAt ? moment(currentItem.createdAt).format("MM/DD/YYYY") : moment(currentDateTime).toISOString(), ////currentItem.createdAt ? moment(currentItem.createdAt).format("MM/DD/YYYY") : moment().format("MM/DD/YYYY"),
                            // remark: pStatus === PSA_Status.REJECTED ? transRemark : currentItem.status === PSA_Status.REJECTED ? currentItem.remark : '',
                            // status: currentItem.status === 'Pending' ? currentItem.status : pStatus,
                            remark: transRemark ? transRemark : currentItem.remark ? currentItem.remark : "",
                            status: pStatus ? pStatus : currentItem.status ? currentItem.status : "Pending",

                            //add some fileld
                            submittedBy: fullInitiatorName,
                            psaRefNo: currentItem?.referenceNo ? currentItem?.referenceNo : "",
                            submittedOnFilter: currentItem.createdAt
                                ? moment(currentItem.createdAt).format("MM/DD/YYYY")
                                : moment(currentDateTime).format("MM/DD/YYYY") ////currentItem.createdAt ? moment(currentItem.createdAt).format("MM/DD/YYYY") : moment().format("MM/DD/YYYY"),
                        };
                        // sn1 = sn1 - 1;
                        finalData.push(obj);
                    } catch (e) {
                        console.log("error", e);
                    }
                    //specific report category get approved,submitted and rejected count

                    /* if (currentItem.status === 'SUBMITTED') {
                      submitCount++;
                    } else if (currentItem.status === 'APPROVED') {
                      approvedCount++;
                    } else if (currentItem.status === 'REJECTED') {
                      rejectCount++;
                    }
                    setSubmitCount(submitCount);
                    setApprovedCount(approvedCount);
                    setRejectCount(rejectCount); */
                }

                // const sortedData = [...finalData].sort(
                // (a, b) => new Date(b.submittedOn) - new Date(a.submittedOn)
                // );

                finalData.reverse();
                let filteredData = finalData.filter(item => item.status !== 'Pending');
                const fData = filteredData.map((item, i) => {
                    item.srNo = i + 1;
                    return { ...item, srNo: item.srNo }
                });
                // console.log("finalData", finalData);
                setInitiatorReportList(fData);
                setReportLoading(false)
            }
        } catch (error) {
            console.log("Error when getting initiate data :-", error);
        }

        loadRequestReports(cycleData, pSAConsultantReportResponseAll, schoolListArray);

        // var SubjectCodeResponses = await DataStore.query(Subject, Predicates.ALL, {
        // sort: s => s.name(SortDirection.ASCENDING)
        // });

        var SubjectCodeResponses = await graphQLGetAllData("listSubjects")
        SubjectCodeResponses = SubjectCodeResponses.sort((a, b) => (a.name).localeCompare(b.name));

        setSubjectCodeList(SubjectCodeResponses);
        var myArray = [];
        myArray = ConvertResponseForSelectWithRefCodedropdown(SubjectCodeResponses);
        setSubjectListDropdown(myArray);

        // var SchoolResponses = await DataStore.query(Schools, Predicates.ALL, {
        //   sort: s => s.name(SortDirection.ASCENDING)
        // });
        var schoolArray = [];
        schoolArray = ConvertResponseForSelect(schoolListArray);
        setSchoolList(schoolArray);

        //create an array inclue only name there for filters start
        const arrayOfSchoolNameForFilter = schoolArray.map(obj => obj.name);
        setSchoolNameArrayForFilter(arrayOfSchoolNameForFilter);
        //create an array inclue only name there for filters end

        // var employeeList = await DataStore.query(Employee, Predicates.ALL, {
        // sort: s => s.employee_name(SortDirection.ASCENDING)
        // });



        const cognito = new AWS.CognitoIdentityServiceProvider();
        var params = {
            UserPoolId: awsmobile.aws_user_pools_id,
            Limit: 60
        };
        cognito.listUsers(params, (err, data) => {
            if (err) {
                console.log(err);
            } else {
                SetUsersList(data.Users);

                var newRes = [];
                let userRole = "",
                    userName = "",
                    userEmail = "",
                    userCode = "",
                    sub;
                data.Users.forEach((user, i) => {
                    userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                    userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                    sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                    userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                    userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

                    let obj = {
                        userId: sub,
                        name: userName,
                        email: userEmail,
                        usercode: userCode,
                        role:
                            userRole === USER_TYPES.ADMIN
                                ? USER_TYPES_NAMES.A
                                : userRole === USER_TYPES.APPROVER
                                    ? USER_TYPES_NAMES.AP
                                    : userRole === USER_TYPES.PAYROLL
                                        ? USER_TYPES_NAMES.P
                                        : USER_TYPES_NAMES.I
                    };
                    newRes.push(obj);
                });

                //set employee list
                let finalEmployeeList = [{ name: "No Approval Needed", code: "no_approval_needed" }];

                newRes.map(currentItem => {
                    let obj = { name: currentItem.name, code: currentItem.userId };
                    finalEmployeeList.push(obj);
                });

                var approverArrayReject = [];
                //approverArrayReject = ConvertResponseOfNameCodeForSelect(finalEmployeeList);
                //commented
                //	   setApproverListForReject(finalEmployeeList);
            }
        });

        //loadAbsenceReport();
    };

    //load approver

    const loadRequestReports = async (cycleData, pSAConsultantReportResponse, schoolListArray) => {

        let count = 0;

        pSAConsultantReportResponse = pSAConsultantReportResponse.filter(item => item?.isSoftDelete !== true);

        //Approver
        try {
            //2.fetch those request which needs approval for logged users.

            // let PSAConsultantTransactionCycleResponse = await DataStore.query(
            // PSATransactionCycle,
            // c => c.to_Employee_Id.eq(loggedUserId),
            // { sort: s => s.dateTime(SortDirection.DESCENDING) }
            // );

            let PSAConsultantTransactionCycleResponse = cycleData.filter(item => item.to_Employee_Id === loggedUserId)//await graphQLGetAllData("listPSATransactionCycles", [{ to_Employee_Id: { eq: loggedUserId } }])
            PSAConsultantTransactionCycleResponse = PSAConsultantTransactionCycleResponse.sort((a, b) => (b.dateTime).localeCompare(a.dateTime));



            //get unique records of same report Id.
            const distinctReportIds = Object.values(
                PSAConsultantTransactionCycleResponse.reduce((acc, entry) => {
                    if (!acc[entry.report_Id]) {
                        acc[entry.report_Id] = entry;
                    }
                    return acc;
                }, {})
            );

            // const original = await DataStore.query(PSAConsultant, report_Id);
            //let PSAConsultantTransactionCycleGroupBy = groupBy(PSAConsultantTransactionCycleResponse, "report_Id");

            if (distinctReportIds.length > 0) {
                let pendingCount = 0;
                let approvedCount = 0;
                let rejectCount = 0;
                let approvalFinalData = [];
                // let i = 0;
                let sn2 = distinctReportIds.length;
                // for (let i = 0; i < sixthPeriodReportTransactionCycleResponse.length; i++) {

                //	   for (let report_Id in PSAConsultantTransactionCycleGroupBy) {

                for (let i = 0; i < distinctReportIds.length; i++) {
                    // const currentItem = PSAConsultantTransactionCycleGroupBy[report_Id][0];

                    const currentItem = distinctReportIds[i];

                    const report_Id = currentItem.report_Id;

                    //console.log(currentItem, "currentItem --app")


                    //get Report data using report id
                    //const PSAConsultantTransactionCycleResponse = await DataStore.query(PSAConsultant, c => c.id.eq(report_Id));
                    const PSAConsultantTransactionCycleResponse = pSAConsultantReportResponse.find(item => item.id === report_Id) //await graphQLFindRecordById("getPSAConsultant", report_Id);
                    //console.log(PSAConsultantTransactionCycleResponse[0],"currentItem --app")

                    if (PSAConsultantTransactionCycleResponse) {

                        // let PSAConsultantTransactionCycle = await DataStore.query(
                        // PSATransactionCycle,
                        // c => c.report_Id.eq(report_Id),
                        // { sort: s => s.dateTime(SortDirection.ASCENDING) }
                        // );

                        //let PSAConsultantTransactionCycle = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: report_Id } }])
                        let PSAConsultantTransactionCycle = cycleData.filter(item => item.report_Id === report_Id)
                        PSAConsultantTransactionCycle = PSAConsultantTransactionCycle.sort((a, b) => (a.createdAt).localeCompare(b.createdAt));



                        let Assignee = "";
                        let adminUsers;
                        if (PSAConsultantTransactionCycle.length) {
                            const cognito = new AWS.CognitoIdentityServiceProvider();

                            try {
                                adminUsers = await cognito.adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username:
                                        (PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1].status === "Rejected" && PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1].to_Employee_Id === "1" ?
                                            PSAConsultantTransactionCycleResponse.createdBy
                                            : PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1].to_Employee_Id)
                                }).promise();
                            } catch (e) {
                                //console.log(e)
                            }

                            let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                            let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                            Assignee = userFirstName + " " + userLastName

                        }


                        let pStatus =
                            PSAConsultantTransactionCycle.length > 0
                                ? PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1].status
                                : "";
                        let pStatusIsApproved = currentItem.isApproved;

                        let schoolDetails = "";
                        if (PSAConsultantTransactionCycleResponse) {
                            //schoolDetails = await DataStore.query(Schools, PSAConsultantTransactionCycleResponse[0].department);
                            schoolDetails = schoolListArray.find(item => item.id === PSAConsultantTransactionCycleResponse.department)//await graphQLFindRecordById("getSchools", PSAConsultantTransactionCycleResponse.department);
                        }

                        // let pSAPartyData = await DataStore.query(PSAParty, c =>
                        // c.psaConsultantId.eq(PSAConsultantTransactionCycleResponse[0]?.id)
                        // );

                        //let pSAPartyData = await graphQLGetAllData("listPSAParties", [{ psaConsultantId: { eq: PSAConsultantTransactionCycleResponse?.id } }])
                        let pSAPartyData = listParties.filter(item => item.psaConsultantId === PSAConsultantTransactionCycleResponse?.id)
                        let transremark = currentItem.remark;

                        //check if previous status is rejected
                        if (
                            PSAConsultantTransactionCycle.length > 2 &&
                            PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1].to_Employee_Id !== loggedUserId
                        ) {
                            if (
                                PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 2].status === PSA_Status.REJECTED
                            ) {
                                // if(PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1].status === PSA_Status.PENDING_FOR_APPROVAL_BUDGET_CLERK){
                                // pStatus = PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 2].status
                                // }

                                transremark = PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 2].remark;
                            }
                        }

                        //Reject case when Exe App reject to Budget clerk Then  HR consultnat
                        if (
                            PSAConsultantTransactionCycle.length > 2
                            //&&
                            //PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1].to_Employee_Id !== loggedUserId
                        ) {
                            //console.log(PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1], "approver_level")
                            if (
                                PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 2].status ===
                                PSA_Status.REJECTED //&&
                                //PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1].approver_level ===
                                //"HR_CONSULTANT_CLEARANCE_VERIFICATION"
                            ) {

                                switch (PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1].approver_level) {

                                    // case "BUDGET_CLERK":



                                    // break;

                                    case "BUDGET_MANAGER":
                                        if (PSAConsultantTransactionCycleResponse.budgetManager === loggedUserId || PSAConsultantTransactionCycleResponse.hrConsultant === loggedUserId) {
                                            pStatus = PSA_Status.REJECTED;
                                        }
                                        break;

                                    case "HR_CONSULTANT_CLEARANCE_VERIFICATION":
                                        if (PSAConsultantTransactionCycleResponse.hrConsultant === loggedUserId) {
                                            pStatus = PSA_Status.REJECTED;
                                        }
                                        break;
                                }

                                // if (
                                // PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1].to_Employee_Id ===
                                // PSAConsultantTransactionCycleResponse[0].budgetManager
                                // ) {
                                // pStatus = PSA_Status.REJECTED;
                                // }


                                //if budgetManager
                                // if (
                                // PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 1].to_Employee_Id ===
                                // PSAConsultantTransactionCycleResponse[0].budgetClerk
                                // ) {
                                // pStatus = PSA_Status.REJECTED;
                                // }

                                //PSAConsultantTransactionCycleResponse[0].executive === PSAConsultantTransactionCycle[PSAConsultantTransactionCycle.length - 2].to_Employee_Id
                            }
                        }

                        // let itr1 = i + 1;
                        let itr1 = count + 1;

                        //add code from id get use info start
                        let createdBy = "";
                        let fullInitiatorName = "";
                        if (PSAConsultantTransactionCycleResponse.createdBy) {
                            try {
                                let x = employeeList.find(u => u.user_Id === PSAConsultantTransactionCycleResponse.createdBy);
                                let fname = x?.firstName
                                let lname = x?.lastName
                                if (fname) {
                                    fullInitiatorName = fname;
                                }
                                if (lname) {
                                    fullInitiatorName += " " + lname;
                                }
                            } catch (e) {
                                console.info(e)
                            }
                        }


                        //add code from id get use info end

                        let obj = {
                            srNo: itr1,
                            id: report_Id,
                            assignmentTitle: PSAConsultantTransactionCycleResponse.assignmentTitle
                                ? PSAConsultantTransactionCycleResponse.assignmentTitle
                                : "",
                            department: schoolDetails ? schoolDetails.name : "",
                            psaEmail: PSAConsultantTransactionCycleResponse.psaEmail
                                ? PSAConsultantTransactionCycleResponse.psaEmail
                                : "",
                            agreementDate: PSAConsultantTransactionCycleResponse.agreementDate
                                ? moment(PSAConsultantTransactionCycleResponse.agreementDate).format("MM/DD/YYYY")
                                : moment(currentDateTime).toISOString(),
                            amount: PSAConsultantTransactionCycleResponse.amount
                                ? PSAConsultantTransactionCycleResponse.amount
                                : "",
                            effectiveDate: PSAConsultantTransactionCycleResponse.effectiveDate
                                ? moment(PSAConsultantTransactionCycleResponse.effectiveDate).format("MM/DD/YYYY")
                                : moment(currentDateTime).toISOString(),
                            expireDate: PSAConsultantTransactionCycleResponse.expireDate
                                ? moment(PSAConsultantTransactionCycleResponse.expireDate).format("MM/DD/YYYY")
                                : moment(currentDateTime).toISOString(),
                            reviewDate: PSAConsultantTransactionCycleResponse.reviewDate
                                ? moment(PSAConsultantTransactionCycleResponse.reviewDate).format("MM/DD/YYYY")
                                : moment(currentDateTime).toISOString(),
                            notifyDays: PSAConsultantTransactionCycleResponse.notifyDays
                                ? moment(PSAConsultantTransactionCycleResponse.notifyDays).format("MM/DD/YYYY")
                                : moment(currentDateTime).toISOString(),
                            accountNo: PSAConsultantTransactionCycleResponse.accountNo
                                ? PSAConsultantTransactionCycleResponse.accountNo
                                : "",
                            dateofboard: PSAConsultantTransactionCycleResponse.dateofboard
                                ? PSAConsultantTransactionCycleResponse.dateofboard
                                : "",
                            boardItem: PSAConsultantTransactionCycleResponse.boardItem
                                ? PSAConsultantTransactionCycleResponse.boardItem
                                : "",
                            pageItem: PSAConsultantTransactionCycleResponse.pageItem
                                ? PSAConsultantTransactionCycleResponse.pageItem
                                : "",
                            businessEntity: PSAConsultantTransactionCycleResponse.businessEntity
                                ? PSAConsultantTransactionCycleResponse.businessEntity
                                : "",
                            addendum: PSAConsultantTransactionCycleResponse.addendum
                                ? PSAConsultantTransactionCycleResponse.addendum
                                : "",
                            addendumNo: PSAConsultantTransactionCycleResponse.addendumNo
                                ? PSAConsultantTransactionCycleResponse.addendumNo
                                : "",
                            notes: PSAConsultantTransactionCycleResponse.notes
                                ? PSAConsultantTransactionCycleResponse.notes
                                : "",
                            otherRemark: PSAConsultantTransactionCycleResponse.otherRemark
                                ? PSAConsultantTransactionCycleResponse.otherRemark
                                : "",
                            partyName: pSAPartyData[0] && pSAPartyData[0].party ? pSAPartyData[0].party : PSAConsultantTransactionCycleResponse?.submittedTo,
                            clientId: pSAPartyData[0] ? pSAPartyData[0].clientId : "",
                            pOCName: pSAPartyData[0] ? pSAPartyData[0].pocName : "",
                            pOCContactNo: pSAPartyData[0] ? pSAPartyData[0].pocNumber : "",
                            partyEmail: pSAPartyData[0] ? pSAPartyData[0].email : "",
                            socialSecurityNumber: pSAPartyData[0] ? pSAPartyData[0].ssn : "",
                            employerIdentification: pSAPartyData[0] ? pSAPartyData[0].employerID : "",
                            address: pSAPartyData[0] ? pSAPartyData[0].address : "",
                            city: pSAPartyData[0] ? pSAPartyData[0].city : "",
                            state: pSAPartyData[0] ? pSAPartyData[0].state : "",
                            postalCode: pSAPartyData[0] ? pSAPartyData[0].zip : "",
                            budgetClerk: PSAConsultantTransactionCycleResponse.budgetClerk
                                ? PSAConsultantTransactionCycleResponse.budgetClerk
                                : "",
                            hrConsultant: PSAConsultantTransactionCycleResponse.hrConsultant
                                ? PSAConsultantTransactionCycleResponse.hrConsultant
                                : "",
                            executive: PSAConsultantTransactionCycleResponse.executive
                                ? PSAConsultantTransactionCycleResponse.executive
                                : "",
                            hrexecutive: PSAConsultantTransactionCycleResponse.hrexecutive
                                ? PSAConsultantTransactionCycleResponse.hrexecutive
                                : "",
                            submittedTo: PSAConsultantTransactionCycleResponse.submittedTo
                                ? PSAConsultantTransactionCycleResponse.submittedTo
                                : "",
                            submittedOn: PSAConsultantTransactionCycleResponse.createdAt
                                ? moment(PSAConsultantTransactionCycleResponse.createdAt).format("MM/DD/YYYY")
                                : moment(currentDateTime).toISOString(),
                            remark: transremark,
                            status: currentItem.status === PSA_Status.REJECTED ? currentItem.status : pStatus,
                            isApproved: pStatusIsApproved,

                            //add some fileld
                            submittedBy: fullInitiatorName,
                            assignee: currentItem.status === 'Acknowledged by HR Executive Secretary'
                                || pStatus === "Acknowledged by HR Executive Secretary" ?
                                "-" :
                                Assignee,
                            "-": currentItem.status === 'Pending for approval PSA Consultant' || pStatus === 'Pending for approval PSA Consultant' ? PSAConsultantTransactionCycleResponse.psaEmail :
                                Assignee,
                            psaRefNo: PSAConsultantTransactionCycleResponse?.referenceNo,
                            submittedOnFilter: PSAConsultantTransactionCycleResponse.createdAt
                                ? moment(PSAConsultantTransactionCycleResponse.createdAt).format("MM/DD/YYYY")
                                : moment(currentDateTime).format("MM/DD/YYYY") ////currentItem.createdAt ? moment(currentItem.createdAt).format("MM/DD/YYYY") : moment().format("MM/DD/YYYY"),
                        };

                        sn2 = sn2 - 1;
                        count++;
                        approvalFinalData.push(obj);
                    }
                }
                // approvalFinalData.reverse();
                setApprovalList(approvalFinalData);
                setReportLoadingApprover(false);
            }
        } catch (error) {
            console.log("Error for bindList", error);
        }
    };

    //initiate only approver side
    const initiateNewReportApprover = async id => {
        //cooment for low priority issue 
        //setPSAedit(false);

        setIsApproverEdit(true);

        initiateNewReport(id);
    };
    //initiate new report
    const initiateNewReport = async id => {
        // setShowNextPopUp(true);
        //fetch employee table data
        console.log(id, "id of edit report ")
        setPsaconsultantData({});
        setPSAPartyData([]);
        setFormData({})
        setIsEdit(false);
        setId(0);
        setImEdit(false);
        if (id) {
            setId(id);
            setIsEdit(true);
            setImEdit(true);
            //const original2 = await DataStore.query(PSAConsultant, id);
            const original2 = await graphQLFindRecordById("getPSAConsultant", id);
            //const pSAPartyDat = await DataStore.query(PSAParty, c => c.psaConsultantId.eq(original2?.id));
            const pSAPartyDat = await graphQLGetAllData("listPSAParties", [{ psaConsultantId: { eq: original2?.id } }])
            getRoutingList(original2);
            setPsaconsultantData(original2)
            setPSAPartyData(pSAPartyDat?.[0])
            setFormData({ ...original2, ...pSAPartyDat?.[0] });
        } else {
            //alert('hi')
            setIsEdit(false);
            setRoutingData([]);
            setFormData({});
            setPsaconsultantData({});
            setPSAPartyData([]);
            setApprovelStatusData([]);
            setFormViewData({});
            setApprovalList([]);
            setInitiatorDocuments([]);
            setEmpCodeList([]);
        }

        setShowNextPopUp(true);
    };

    //*loadAbsenceReport
    const loadAbsenceReport = async () => {
        //*Set Weekly Absence Report-Classified List
        var weeklyAbsenceReport = await DataStore.query(InitiateClassifiedWeeklyAbsenceReport);
        let newResponse = [];
        for (let i = 0; i < weeklyAbsenceReport.length; i++) {
            let schoolName = "";
            let workDuration = "";
            let submittedOn = "";
            let status = "";
            let remark = "";

            //*Work Duration
            if (weeklyAbsenceReport[i].from_date && weeklyAbsenceReport[i].to_date) {
                let fromDate = moment(weeklyAbsenceReport[i].from_date, "YYYY-DD-MM").format("Do");
                let toDate = moment(weeklyAbsenceReport[i].to_date, "YYYY-DD-MM").format("Do MMMM'YY");
                workDuration = fromDate + " - " + toDate;
            } else {
                workDuration = "-";
            }

            //*submitted On
            if (weeklyAbsenceReport[i].status_date_time !== null && weeklyAbsenceReport[i].status_date_time !== undefined) {
                submittedOn =
                    weeklyAbsenceReport[i].status_date_time !== null
                        ? moment(weeklyAbsenceReport[i].status_date_time).format("Do MMMM'YY")
                        : "-";
            } else {
                submittedOn = "-";
            }

            // //*School Name
            if (weeklyAbsenceReport[i].school_id !== null && weeklyAbsenceReport[i].school_id !== undefined) {
                var schoolResponses = await DataStore.query(Schools, c => c.id.eq(weeklyAbsenceReport[i].school_id));
                if (schoolResponses.length > 0) {
                    schoolName = schoolResponses[0].name;
                } else {
                    schoolName = "";
                }
            } else {
                schoolName = "";
            }

            if (
                weeklyAbsenceReport[i].payroll_status !== null &&
                weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_ACCEPTED
            ) {
                status = "Approved (P)";
                remark = "-";
            } else if (
                weeklyAbsenceReport[i].payroll_status !== null &&
                weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_REJECTED
            ) {
                status = "Rejected (P)";
                remark = weeklyAbsenceReport[i].payroll_remark;
            } else if (
                weeklyAbsenceReport[i].approver_status !== null &&
                weeklyAbsenceReport[i].approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_ACCEPTED
            ) {
                status = "Approved (A)";
                remark = "-";
            } else if (
                weeklyAbsenceReport[i].approver_status !== null &&
                weeklyAbsenceReport[i].approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_REJECTED
            ) {
                status = "Rejected (A)";
                remark = weeklyAbsenceReport[i].approver_remark;
            } else if (
                weeklyAbsenceReport[i].payroll_status === null &&
                weeklyAbsenceReport[i].approver_status === null &&
                weeklyAbsenceReport[i].status === InitiateClassifiedWeeklyAbsenceReportStatus.SUBMITTED
            ) {
                status = "Submitted";
                remark = "-";
            } else if (
                weeklyAbsenceReport[i].payroll_status === null &&
                weeklyAbsenceReport[i].approver_status === null &&
                weeklyAbsenceReport[i].status === InitiateClassifiedWeeklyAbsenceReportStatus.OPEN
            ) {
                status = "Pending";
                remark = "-";
            }

            newResponse.push({
                id: weeklyAbsenceReport[i].id,
                user_id: weeklyAbsenceReport[i].user_id,
                status: status,
                school_id: weeklyAbsenceReport[i].school_id,
                from_date: weeklyAbsenceReport[i].from_date,
                to_date: weeklyAbsenceReport[i].to_date,
                status_date_time: weeklyAbsenceReport[i].status_date_time,
                approver_remark: weeklyAbsenceReport[i].approver_remark,
                payroll_remark: weeklyAbsenceReport[i].payroll_remark !== null ? weeklyAbsenceReport[i].payroll_remark : "-",
                schoolName: schoolName,
                workDuration: workDuration,
                submittedOn: submittedOn,
                remark: remark,
                createdAt: weeklyAbsenceReport[i].createdAt,
                updatedAt: weeklyAbsenceReport[i].updatedAt
            });

            if (i === weeklyAbsenceReport.length - 1) {
                setWeeklyAbsenceReports(newResponse);
                //SubmittedCount
                const submittedCount = newResponse.filter(obj => obj.status === "Submitted");
                setWeeklyAbsenceReportSubmitted(submittedCount.length);

                //SubmittedCount
                const approvedCountP = newResponse.filter(obj => obj.status === "Approved (P)");
                const approvedCountA = newResponse.filter(obj => obj.status === "Approved (A)");
                let approvedCount = approvedCountP.length + approvedCountA.length;
                setWeeklyAbsenceReportApproved(approvedCount);

                //RejectedCount
                const rejectedCountP = newResponse.filter(obj => obj.status === "Rejected (P)");
                const rejectedCountA = newResponse.filter(obj => obj.status === "Rejected (A)");
                const rejectedCount = rejectedCountP.length + rejectedCountA.length;
                setWeeklyAbsenceReportRejected(rejectedCount);

                //RejectedCount
                const pendingCount = newResponse.filter(obj => obj.status === "Pending");
                setWeeklyAbsenceReportPending(pendingCount.length);
            }
        }
    };

    //severty for form history timeline
    const approveStatusOptionsTimeline = product => {
        switch (product.status) {
            case "Approved":
                return "success";

            case "Rejected":
                return "danger";

            case "Pending for approval Budget Manager":
                return "warning";

            case "Pending for approval HR Executive Secretary":
                return "warning";

            case "Pending for approval Executive Approver":
                return "warning";

            case "Pending for approval HR Consultant":
                return "warning";

            case "Pending for Acknowledgement HR Executive Secretary":
                return "warning";

            case "Closed":
                return "success";

            case "Pending for approval Budget Clerk":
                return "warning";

            case "Pending for approval PSA Consultant":
                return "warning";

            case "APPROVAL_ACCEPTED":
                return "success";

            case "Acknowledged by HR Executive Secretary":
                return "success";

            case "Reviewed & Resubmitted":
                return "info";

            case "SUBMITTED":
                return "info";

            case "Submitted":
                return "info";

            case "Reviewed & resubmitted":
                return "info";
            case 'OPEN':
                return 'info';
            default:
                return null;
        }
    };
    //---------------------------------

    const approveStatusOptions = product => {
        switch (product.status) {
            case "Rejected":
                return "danger";

            case "Pending for approval Executive Approver":
                return "warning";

            case "Pending for approval HR Consultant":
                return "warning";

            case "Pending for approval HR Executive Secretary":
                return "warning";

            case "Closed":
                return "success";
            case "Pending for approval PSA Consultant":
                return "warning";

            case "APPROVAL_ACCEPTED":
                return "success";

            case "Acknowledge":
                return "success";

            case "RESUBMITTED":
                return "info";

            case "SUBMITTED":
                return "info";

            case "Submitted":
                return "info";

            case "Reviewed & resubmitted":
                return "info";
            case 'OPEN':
                return 'info';
            default:
                return null;
        }
    };

    async function OpenDocument(filePath) {
        filePath = filePath.replace("public/", "");
        filePath = "public/" + filePath;
        let filePathURL = await GetAWSObjectURL(filePath);
        const link = document.createElement("a");
        link.href = filePathURL;
        link.target = "_blank";
        // link.download = "";
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
    async function getDocumentURL(filePath) {
        filePath = filePath.replace("public/", "");
        filePath = "public/" + filePath;
        let filePathURL = await GetAWSObjectURL(filePath);
        return filePathURL;
    }

    const viewReport = async id => {
        console.log(id, "id of view report ")
        if (id) {
            setId(id);
            setIsEdit(true);
        } else {
            setIsEdit(false);
        }
        setPSAview(true);

        //Approval timeline
        //const PSAConsultantData = await DataStore.query(PSAConsultant, id);
        const PSAConsultantData = await graphQLFindRecordById("getPSAConsultant", id);
        const cognito = new AWS.CognitoIdentityServiceProvider();


        // let PSATransactionCycleData = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(id), {
        // sort: s => s.createdAt(SortDirection.ASCENDING)
        // });

        let PSATransactionCycleData = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: id } }])
        PSATransactionCycleData = PSATransactionCycleData.sort((a, b) => (a.createdAt).localeCompare(b.createdAt));

        //const PSAData = await DataStore.query(PSAConsultant, id);
        const PSAData = await graphQLFindRecordById("getPSAConsultant", id);
        let initiaterName;

        if (PSAData.createdBy) {
            try {
                initiaterName = await cognito
                    .adminGetUser({
                        UserPoolId: awsmobile.aws_user_pools_id,
                        Username: PSAData.createdBy
                    })
                    .promise();
            } catch (e) { }
        }
        let userFirstName = initiaterName ? await GetValueFromArray(initiaterName.UserAttributes, "custom:firstName") : "";
        let userLastName = initiaterName ? await GetValueFromArray(initiaterName.UserAttributes, "custom:lastName") : "";
        let fullInitiatorName = userFirstName + " " + userLastName;

        //const pSAPartyDat = await DataStore.query(PSAParty, c => c.psaConsultantId.eq(PSAData?.id));
        let pSAPartyDat = await graphQLGetAllData("listPSAParties", [{ psaConsultantId: { eq: PSAData?.id } }])

        console.log(pSAPartyDat, "pSAPartyDat11")
        setPsaconsultantViewDoc(pSAPartyDat);
        setPSAPartyData(pSAPartyDat?.[0]);
        setPsaconsultantData(PSAData);

        // let PSATransactionCycleData1 = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(PSAData?.id), {
        // sort: s => s.dateTime(SortDirection.DESCENDING)
        // });

        let PSATransactionCycleData1 = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: PSAData?.id } }])
        PSATransactionCycleData1 = PSATransactionCycleData1.sort((a, b) => (b.dateTime).localeCompare(a.dateTime));


        //PSAData.filename = pSAPartyDat && pSAPartyDat?.[0] ? pSAPartyDat[0].filename : '';

        setFormData({ ...PSAData, ...pSAPartyDat?.[0], psaPatyUpdatedDate: PSATransactionCycleData1?.[0]?.date });
        setFormViewData({ ...PSAData, ...pSAPartyDat?.[0], psaPatyUpdatedDate: PSATransactionCycleData1?.[0]?.date });
        let approvalFinalData = [];
        let eventmain = [];
        let identifyHR = [];
        //console.log(PSATransactionCycleData,"PSATransactionCycleData")
        if (PSATransactionCycleData) {
            for (let i = 0; i < PSATransactionCycleData.length; i++) {
                let adminUsers;
                if (PSATransactionCycleData[i].to_Employee_Id) {
                    try {
                        adminUsers = await cognito
                            .adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: PSATransactionCycleData[i].to_Employee_Id
                            })
                            .promise();
                    } catch (e) { }
                }
                let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : "";
                let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : "";
                let userCodeEmp = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode") : "";
                let fullName = userFirstName + " " + userLastName;

                if (PSATransactionCycleData[i].to_Employee_Id === "1") {
                    fullName = "PSA Consultant";
                    userCodeEmp = "PSA 01";
                }

                //check rewiew and resubmit case
                if (PSATransactionCycleData[i].status === "Reviewed Resubmitted") {
                    let initiateUser;
                    if (PSATransactionCycleData[i].from_Employee_Id) {
                        try {
                            initiateUser = await cognito
                                .adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: PSATransactionCycleData[i].from_Employee_Id
                                })
                                .promise();
                        } catch (e) {
                            //console.log(e)
                        }
                    }
                    let userFirstName = adminUsers
                        ? await GetValueFromArray(initiateUser.UserAttributes, "custom:firstName")
                        : "";
                    let userLastName = adminUsers ? await GetValueFromArray(initiateUser.UserAttributes, "custom:lastName") : "";
                    let userCodeEmp = adminUsers ? await GetValueFromArray(initiateUser.UserAttributes, "custom:userCode") : "";
                    fullName = userFirstName + " " + userLastName;
                }

                let appDate = PSATransactionCycleData[i].dateTime
                    ? PSATransactionCycleData[i].dateTime
                    : PSATransactionCycleData[i].updatedAt;

                // let dateTime = PSATransactionCycleData[i].dateTime;
                let dateTime = PSATransactionCycleData[i].isApproved ||
                    PSATransactionCycleData[i].status === "Rejected" ||
                    PSATransactionCycleData[i].status === "Acknowledged"
                    ? PSATransactionCycleData[i].dateTime : null;

                console.log("PSA_StatusPSA_Status", PSATransactionCycleData[i])
                console.log("dateTimedateTime", dateTime)

                let designation = "Initiator";

                if (
                    PSAConsultantData?.budgetClerk &&
                    PSATransactionCycleData[i].to_Employee_Id === PSAConsultantData?.budgetClerk
                ) {
                    designation = "Budget Clerk";
                } else if (
                    PSAConsultantData?.budgetManager &&
                    PSATransactionCycleData[i].to_Employee_Id === PSAConsultantData?.budgetManager
                ) {
                    designation = "Budget Manager";
                } else if (PSAConsultantData?.hrConsultant === PSATransactionCycleData[i].to_Employee_Id) {
                    //designation = "HR Consultant";
                    designation = PSATransactionCycleData[i].designation && PSATransactionCycleData[i].designation === PSA_Designation.HR_EXCECUTIVE_SECREATARY_APPROVER ? "HR Executive Secretary (Approver)" : "HR Executive Secretary (Approver)"
                    identifyHR.push(PSATransactionCycleData[i].to_Employee_Id)
                } else if (PSAConsultantData?.executive === PSATransactionCycleData[i].to_Employee_Id) {
                    designation = "Executive Approver";
                }
                /*  else if (PSAConsultantData?.submittedTo === PSATransactionCycleData[i].to_Employee_Id) {
                   designation = "Initiator";
                 } */

                if (PSAConsultantData?.hrexecutive === PSATransactionCycleData[i].to_Employee_Id) {
                    //designation = "HR Executive Secretary";

                    if (PSATransactionCycleData[i].status === PSA_Status.PENDING_FOR_APPROVAL_HR_EXCECUTIVE_SECREATARY || PSATransactionCycleData[i].status === PSA_Status.ACKNOWLEDGE) {
                        designation = "HR Executive Secretary (HR/Payroll)";
                    }
                }

                //  if (PSATransactionCycleData[i].status === PSA_Status.REJECTED){
                //   designation =   "Initiator";
                //  }

                if (PSATransactionCycleData[i].to_Employee_Id === "1") {
                    fullName = "PSA Consultant";
                    userCodeEmp = "PSA 01";
                    designation = "PSA Consultant";
                }

                if (i == 0) {
                    let obj = {
                        name: fullInitiatorName,
                        status: "Submitted",
                        dateTime: handleDateSelect(PSAData.createdAt),
                        designation: "Initiator"
                    };
                    approvalFinalData.push(obj);
                }

                console.log("ApprovalFinalData", approvalFinalData);

                let obj = {
                    id: PSATransactionCycleData[i].id,
                    name: fullName,
                    title: userCodeEmp,
                    status:
                        PSATransactionCycleData[i].status == "Reviewed Resubmitted"
                            ? "Reviewed & Resubmitted"
                            : PSATransactionCycleData[i].isApproved
                                ? "Approved"
                                : PSATransactionCycleData[i].status,
                    isApproved: PSATransactionCycleData[i].isApproved,
                    updatedAt: handleDateSelect(appDate),
                    dateTime: handleDateSelect(dateTime),
                    designation: designation
                };

                approvalFinalData.push(obj);
            }
        }
        setEvents(approvalFinalData);

        if (id) {
            const getPSAPartyDocuments = () => {
                return new Promise(async resolve => {

                    // let PSAPartyDocumentsData = await DataStore.query(PSAPartyDocument, c => c?.reportId.eq(id), {
                    // sort: s => s.createdAt(SortDirection.ASCENDING)
                    // });
                    let PSAPartyDocumentsData = await graphQLGetAllData("listPSAPartyDocuments", [{ reportId: { eq: id } }])
                    PSAPartyDocumentsData = PSAPartyDocumentsData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))

                    resolve(PSAPartyDocumentsData);
                });
            };

            getPSAPartyDocuments().then(res => {
                setPartyDocuments(res);
            });
        }

        if (id) {
            const getPSADocuments = () => {
                return new Promise(async resolve => {
                    // let PSADocumentsData = await DataStore.query(PSADocuments, c => c?.reportId.eq(id), {
                    // sort: s => s.createdAt(SortDirection.ASCENDING)
                    // });

                    let PSADocumentsData = await graphQLGetAllData("listPSADocuments", [{ reportId: { eq: id } }])
                    PSADocumentsData = PSADocumentsData.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))


                    resolve(PSADocumentsData);
                });
            };

            getPSADocuments().then(res => {
                setInitiatorDocuments(res);
            });
        }

        setApprovelStatusData(approvalFinalData);
    };

    // Add Signature

    const uploadSignature = async signature => {
        const fileName = "profile/" + loggedInUserData?.userId ?? loggedUserId + "/signature.png";

        const blob = await dataURLtoBlob(signature);

        try {
            // toast.loading('Uploading please wait...');
            await Storage.put(fileName, blob, {
                resumable: true,
                completeCallback: event => {
                    toast.dismiss();
                    Auth.currentAuthenticatedUser()
                        .then(user => {
                            return Auth.updateUserAttributes(user, {
                                "custom:userSignature": fileName
                            });
                            setIsSignatureAdded(true);
                        })
                        .catch(err => toast.error(err.message));
                },

                errorCallback: err => {
                    toast.error(err.message);
                }
            });
            // setSignatureFileAwsPath(signature);
        } catch (error) {
            console.log("Error uploading file: ", error);
        }
        return fileName;
    };

    const fetchAndSetLoggedInUserData = async userId => {
        const cognito = new AWS.CognitoIdentityServiceProvider();
        var params = {
            UserPoolId: awsmobile.aws_user_pools_id,
            Limit: 1
        };

        params["Filter"] = 'sub ^="' + userId + '"';

        try {
            const data = await cognito.listUsers(params).promise();
            if (data.Users.length > 0) {
                const user = data.Users[0];

                const userRoleAttribute = user.Attributes.find(attr => attr.Name === "custom:role");
                const userNameAttribute = user.Attributes.find(attr => attr.Name === "name");
                const sub = user.Attributes.find(attr => attr.Name === "sub");
                const userEmailAttribute = user.Attributes.find(attr => attr.Name === "email");
                const userCodeAttribute = user.Attributes.find(attr => attr.Name === "custom:userCode");
                const signatureAttribute = user.Attributes.find(attr => attr.Name === "custom:userSignature");

                let role;
                switch (userRoleAttribute?.Value) {
                    case USER_TYPES.SUPERADMIN:
                        role = USER_TYPES_NAMES.SA;
                        break;
                    case USER_TYPES.ADMIN:
                        role = USER_TYPES_NAMES.A;
                        break;
                    case USER_TYPES.APPROVER:
                        role = USER_TYPES_NAMES.AP;
                        break;
                    case USER_TYPES.PAYROLL:
                        role = USER_TYPES_NAMES.P;
                        break;
                    default:
                        role = USER_TYPES_NAMES.I;
                }

                return {
                    userId: sub?.Value,
                    name: userNameAttribute?.Value,
                    email: userEmailAttribute?.Value,
                    usercode: userCodeAttribute?.Value,
                    signature: signatureAttribute?.Value,
                    role: role
                };
            }
        } catch (error) {
            toast.error(error.message);
            return null;
        }
        return null;
    };

    const handleSignatureSelection = async image => {
        setSignatureDialog(false);
        setSignatureFileAwsPath(null);
        const signatureFilePath = await uploadSignature(image);
        if (signatureFilePath.trim() !== "") {
            setSignaturePath(signatureFilePath);
            // loadSignatureFile(signatureFilePath);
            setSignatureFileAwsPath(image);
        } else {
            signatureFilePath(null);
        }
    };

    const loadSignatureFile = async filePath => {
        let file = null;
        try {
            await Storage.get(filePath).then(result => {
                file = result;
            });

            if (file) {
                setSignatureFileAwsPath(file);
            }
        } catch (e) {
            setSignatureDialog(true);
        }
    };

    const handleAddSignature = async () => {
        const cognito = new AWS.CognitoIdentityServiceProvider();

        var params = {
            UserPoolId: awsmobile.aws_user_pools_id,
            Limit: 60
        };

        params["Filter"] = 'sub ^="' + loggedUserId + '"';
        await cognito.listUsers(params, (err, data) => {
            if (data) {
                let signature = data.Users[0].Attributes.find(attr => attr.Name === "custom:userSignature")?.Value;
                if (signature != null && signature.trim() !== "") {
                    setSignaturePath(signature);
                    loadSignatureFile(signature);
                } else {
                    setSignatureDialog(true);
                }
            }
        });
    };

    const getMasterData = async () => {
        console.log("calling masterdata")
        // var schoolListResponse = await DataStore.query(Schools, Predicates.ALL, {
        // sort: s => s.name(SortDirection.ASCENDING)
        // });

        var schoolListResponse = await graphQLGetAllData("listSchools");
        schoolListResponse = schoolListResponse.sort((a, b) => (a.name).localeCompare(b.name));

        console.log('schoolListResponse->legnth', schoolListResponse.length)

        setSchoolListArray(schoolListResponse);

        // var employeeList = await DataStore.query(Employee, Predicates.ALL, {
        // sort: s => s.employee_name(SortDirection.ASCENDING)
        // });

        var employeeList = await graphQLGetAllData("listEmployees")
        employeeList = employeeList.sort((a, b) => (a.employee_name?.toLowerCase() ?? "").localeCompare(b.employee_name?.toLowerCase() ?? ""));


        //let pSAPartyData = await DataStore.query(PSAParty);
        let pSAPartyData = await graphQLGetAllData("listPSAParties");
        setPSAPartyList(pSAPartyData);

        // var cycleData = await DataStore.query(PSATransactionCycle, Predicates.ALL, {
        // sort: s => s.dateTime(SortDirection.ASCENDING)
        // });


        // setCycleData(cycleData);
        setEmployeeList(employeeList);
        console.log('employeeList->legnth', employeeList.length)
        setIsMasterDataLoaded(true);
        setIsDataLoaded(Math.random())
        var listPartyData = await graphQLGetAllData("listPSAParties")
        setListParties(listPartyData)
        console.log('setIsMasterDataLoaded', masterDataLoaded)
    }

    useEffect(() => {
        getMasterData();
    }, [])

    useEffect(() => {
        if (addSignature) {
            handleAddSignature();
        }
    }, [addSignature]);

    useEffect(() => {
        console.log("masterDataLoaded", masterDataLoaded)
        if (masterDataLoaded === true) {
            console.log("calling bindlist")
            BindList();
        }

        if (isEdit) {
            (async () => {
                //const PSAData = await DataStore.query(PSAConsultant, id);
                const PSAData = await graphQLFindRecordById("getPSAConsultant", id);

                //const pSAPartyDat = await DataStore.query(PSAParty, c => c.psaConsultantId.eq(PSAData?.id));
                const pSAPartyDat = await graphQLGetAllData("listPSAPartyDocuments", [{ psaConsultantId: { eq: PSAData?.id } }])

                setPSAPartyData(pSAPartyDat?.[0]);
                setPsaconsultantData(PSAData);

                // let PSATransactionCycleData = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(PSAData?.id), {
                // sort: s => s.createdAt(SortDirection.DESCENDING)
                // });

                let PSATransactionCycleData = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: PSAData?.id } }])
                PSATransactionCycleData = PSATransactionCycleData.sort((a, b) => (b.createdAt).localeCompare(a.createdAt));


                setFormData({ ...PSAData, ...pSAPartyDat?.[0], psaPatyUpdatedDate: PSATransactionCycleData?.[0]?.date });
                setFormViewData({ ...PSAData, ...pSAPartyDat?.[0], psaPatyUpdatedDate: PSATransactionCycleData?.[0]?.date });
            })();
        }


    }, [masterDataLoaded, isEdit, isDataLoaded]);

    useEffect(() => {
        // if (loggedPersonnelServiceAgreeApprover == 1) {
        //   setActiveIndex(1);
        // }

        // if (loggedPersonnelServiceAgreeInitiator == 1) {
        //   setActiveIndex(0);
        // }
    }, []);

    // useEffect(() => {

    // console.log(formViewData,"formViewData--")
    // }, [isPsaPdfUpdate]);




    const psaPdfUpdate = async id => {
        console.log(id, "id")
        // alert("1")
        const PSAData = await graphQLFindRecordById("getPSAConsultant", id);

        //const pSAPartyDat = await DataStore.query(PSAParty, c => c.psaConsultantId.eq(PSAData?.id));
        const pSAPartyDat = await graphQLGetAllData("listPSAParties", [{ psaConsultantId: { eq: PSAData?.id } }])

        setPSAPartyData(pSAPartyDat?.[0]);
        setPsaconsultantData(PSAData);

        // let PSATransactionCycleData = await DataStore.query(PSATransactionCycle, c => c.report_Id.eq(PSAData?.id), {
        // sort: s => s.createdAt(SortDirection.DESCENDING)
        // });

        let PSATransactionCycleData = await graphQLGetAllData("listPSATransactionCycles", [{ report_Id: { eq: PSAData?.id } }])
        PSATransactionCycleData = PSATransactionCycleData.sort((a, b) => (b.createdAt).localeCompare(a.createdAt));


        setFormData({ ...PSAData, ...pSAPartyDat?.[0], psaPatyUpdatedDate: PSATransactionCycleData?.[0]?.date });
        setFormViewData({ ...PSAData, ...pSAPartyDat?.[0], psaPatyUpdatedDate: PSATransactionCycleData?.[0]?.date });

        console.log(formViewData, "formViewData")
        console.log(pSAPartyDat?.[0], "pSAPartyDat?.[0]")



    }

    // CSV Code
    const exportFilteredDataToCSV = async fileName => {
        // dt.current.exportCSV();

        const cognito = new AWS.CognitoIdentityServiceProvider();
        for (let i = 0; i < initiatorReportList.length; i++) {
            let budgetClerk = "";
            if (initiatorReportList[i].budgetClerk) {
                try {
                    budgetClerk = await cognito
                        .adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: initiatorReportList[i].budgetClerk
                        })
                        .promise();
                } catch (e) { }
            }
            let bugetClerkName = budgetClerk ? budgetClerk.UserAttributes.find(attr => attr.Name === "name") : "";

            let hrConsultant;
            if (initiatorReportList[i].hrConsultant) {
                try {
                    hrConsultant = await cognito
                        .adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: initiatorReportList[i].hrConsultant
                        })
                        .promise();
                } catch (e) {
                    //console.log(e)
                }
            }
            let hrConsultantName = hrConsultant ? hrConsultant.UserAttributes.find(attr => attr.Name === "name") : "";

            let executive = "";
            if (initiatorReportList[i].executive) {
                try {
                    executive = await cognito
                        .adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: initiatorReportList[i].executive
                        })
                        .promise();
                } catch (e) {
                    //console.log(e)
                }
            }
            let executiveName = executive ? executive.UserAttributes.find(attr => attr.Name === "name") : "";

            let hrexecutive;
            if (initiatorReportList[i].hrexecutive) {
                try {
                    hrexecutive = await cognito
                        .adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: initiatorReportList[i].hrexecutive
                        })
                        .promise();
                } catch (e) {
                    //console.log(e)
                }
            }
            let hrexecutiveName = hrexecutive ? hrexecutive.UserAttributes.find(attr => attr.Name === "name") : "";

            let submittedTo;
            if (initiatorReportList[i].submittedTo) {
                try {
                    submittedTo = await cognito
                        .adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: initiatorReportList[i].submittedTo
                        })
                        .promise();
                } catch (e) {
                    //console.log(e)
                }
            }
            let submittedToName = submittedTo ? submittedTo.UserAttributes.find(attr => attr.Name === "name") : "";

            initiatorReportList[i] = {
                ...initiatorReportList[i],
                budgetclerk: bugetClerkName ? bugetClerkName.Value : "",
                hrConsultant: hrConsultantName ? hrConsultantName.Value : "",
                executive: executiveName ? executiveName.Value : "",
                hrexecutive: hrexecutiveName ? hrexecutiveName.Value : "",
                submittedTo: submittedToName ? submittedToName.Value : ""
            };
        }

        const dataToExport = initiatorReportList.map(
            ({
                srNo,
                assignmentTitle,
                department,
                submittedTo,
                psaEmail,
                agreementDate,
                amount,
                effectiveDate,
                expireDate,
                reviewDate,
                notifyDays,
                accountNo,
                dateofboard,
                boardItem,
                pageItem,
                businessEntity,
                addendum,
                addendumNo,
                notes,
                otherRemark,
                partyName,
                clientId,
                pOCName,
                pOCContactNo,
                partyEmail,
                socialSecurityNumber,
                employerIdentification,
                address,
                city,
                state,
                submittedOn,
                remark,
                status,
                budgetclerk,
                hrConsultant,
                executive,
                hrexecutive,
                postalCode
            }) => ({
                "Sl No": srNo,
                "Assignment Title": assignmentTitle,
                "Submitted On": submittedOn,
                Department: department,
                "PSA Consultant Name": submittedTo, //submittedTo
                "PSA Conultant email": psaEmail,
                "Agreement Date": agreementDate,
                Amount: amount,
                "Effective Date": effectiveDate,
                "Expiration Date": expireDate,
                "Review Date": reviewDate,
                "Notify Days": notifyDays,
                "Submitted To": submittedTo, //submittedTo
                "Account No": accountNo,
                "Date of Board Meeting": dateofboard,
                "Board Item": boardItem,
                "Page/Item": pageItem,
                "Type of Business Entity": businessEntity,
                Addendum: addendum,
                "Attached Addendum Number": addendumNo,
                Notes: notes,
                "Other Remarks": otherRemark,
                "PSA Consultant's Name": partyName,
                "Client ID": clientId,
                "POC Name": pOCName,
                "POC Contact No": pOCContactNo,
                Email: partyEmail,
                "Social Security Number": socialSecurityNumber,
                "Employer Identification": employerIdentification,
                Address: address,
                City: city,
                State: state,
                "Postal Code": postalCode,
                "Budget Clerk": budgetclerk, //budgetClerk
                "HR Consultant Clearance Verification": hrConsultant, //hrConsultant
                "Executive Approver": executive, //executive
                "HR Executive Secretary": hrexecutive, //hrexecutive
                Remarks: remark,
                Status: status
            })
        );

        const csvData = convertArrayOfObjectsToCSV(dataToExport);
        downloadCSV(csvData, fileName);
    };

    // CSV Code
    const exportFilteredApproverDataToCSV = async fileName => {
        // dt.current.exportCSV();

        const cognito = new AWS.CognitoIdentityServiceProvider();
        for (let i = 0; i < approvalList.length; i++) {
            let budgetClerk = "";
            if (approvalList[i].budgetClerk) {
                try {
                    budgetClerk = await cognito
                        .adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: approvalList[i].budgetClerk
                        })
                        .promise();
                } catch (e) {
                    //console.log(e)
                }
            }
            let bugetClerkName = budgetClerk ? budgetClerk.UserAttributes.find(attr => attr.Name === "name") : "";

            let hrConsultant;
            if (approvalList[i].hrConsultant) {
                try {
                    hrConsultant = await cognito
                        .adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: approvalList[i].hrConsultant
                        })
                        .promise();
                } catch (e) {
                    //console.log(e)
                }
            }
            let hrConsultantName = hrConsultant ? hrConsultant.UserAttributes.find(attr => attr.Name === "name") : "";

            let executive = "";
            if (approvalList[i].executive) {
                try {
                    executive = await cognito
                        .adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: approvalList[i].executive
                        })
                        .promise();
                } catch (e) {
                    //console.log(e)
                }
            }
            let executiveName = executive ? executive.UserAttributes.find(attr => attr.Name === "name") : "";

            let hrexecutive;
            if (approvalList[i].hrexecutive) {
                try {
                    hrexecutive = await cognito
                        .adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: approvalList[i].hrexecutive
                        })
                        .promise();
                } catch (e) {
                    //console.log(e)
                }
            }
            let hrexecutiveName = hrexecutive ? hrexecutive.UserAttributes.find(attr => attr.Name === "name") : "";

            let submittedTo;
            if (approvalList[i].submittedTo) {
                try {
                    submittedTo = await cognito
                        .adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: approvalList[i].submittedTo
                        })
                        .promise();
                } catch (e) {
                    //console.log(e)
                }
            }
            let submittedToName = submittedTo ? submittedTo.UserAttributes.find(attr => attr.Name === "name") : "";

            approvalList[i] = {
                ...approvalList[i],
                budgetclerk: bugetClerkName ? bugetClerkName.Value : "",
                hrConsultant: hrConsultantName ? hrConsultantName.Value : "",
                executive: executiveName ? executiveName.Value : "",
                hrexecutive: hrexecutiveName ? hrexecutiveName.Value : "",
                submittedTo: submittedToName ? submittedToName.Value : ""
            };
        }

        const dataToExport = approvalList.map(
            ({
                srNo,
                assignmentTitle,
                department,
                submittedTo,
                psaEmail,
                agreementDate,
                amount,
                effectiveDate,
                expireDate,
                reviewDate,
                notifyDays,
                accountNo,
                dateofboard,
                boardItem,
                pageItem,
                businessEntity,
                addendum,
                addendumNo,
                notes,
                otherRemark,
                partyName,
                clientId,
                pOCName,
                pOCContactNo,
                partyEmail,
                socialSecurityNumber,
                employerIdentification,
                address,
                city,
                state,
                submittedOn,
                remark,
                status,
                budgetclerk,
                hrConsultant,
                executive,
                hrexecutive,
                postalCode
            }) => ({
                "Sl No": srNo,
                "Assignment Title": assignmentTitle,
                "Submitted On": submittedOn,
                Department: department,
                "PSA Consultant Name": submittedTo, //submittedTo
                "PSA Conultant email": psaEmail,
                "Agreement Date": agreementDate,
                Amount: amount,
                "Effective Date": effectiveDate,
                "Expiration Date": expireDate,
                "Review Date": reviewDate,
                "Notify Days": notifyDays,
                "Submitted To": submittedTo, //submittedTo
                "Account No": accountNo,
                "Date of Board Meeting": dateofboard,
                "Board Item": boardItem,
                "Page/Item": pageItem,
                "Type of Business Entity": businessEntity,
                Addendum: addendum,
                "Attached Addendum Number": addendumNo,
                Notes: notes,
                "Other Remarks": otherRemark,
                "PSA Consultant's Name": partyName,
                "Client ID": clientId,
                "POC Name": pOCName,
                "POC Contact No": pOCContactNo,
                Email: partyEmail,
                "Social Security Number": socialSecurityNumber,
                "Employer Identification": employerIdentification,
                Address: address,
                City: city,
                State: state,
                "Postal Code": postalCode,
                "Budget Clerk": budgetclerk, //budgetClerk
                "HR Consultant Clearance Verification": hrConsultant, //hrConsultant
                "Executive Approver": executive, //executive
                "HR Executive Secretary": hrexecutive, //hrexecutive
                Remarks: remark,
                Status: status
            })
        );

        const csvData = convertArrayOfObjectsToCSV(dataToExport);
        downloadCSV(csvData, fileName);
    };

    const convertArrayOfObjectsToCSV = data => {
        const csvRows = [];
        const headers = Object.keys(data[0]);

        csvRows.push(headers.join(","));

        for (const row of data) {
            const values = headers.map(header => row[header]);
            csvRows.push(values.join(","));
        }

        return csvRows.join("\n");
    };

    const downloadCSV = (data, filename) => {
        const blob = new Blob([data], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement("a");
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };

    const statusRowFilterTemplate = options => {
        return (
            <Dropdown
                value={options.value}
                options={status}
                onChange={e => options.filterApplyCallback(e.value)}
                itemTemplate={statusItemTemplate}
                placeholder="Select"
                className="p-column-filter custDropdown"
                showClear
                style={{ minWidth: "7rem" }}
            />
        );
    };
    const depatmentRowFilterTemplate = options => {
        return (
            <Dropdown
                value={options.value}
                options={schoolNameArrayForFilter}
                onChange={e => options.filterApplyCallback(e.value)}
                // itemTemplate={statusItemTemplate}
                placeholder="Select"
                className="p-column-filter custDropdown"
                showClear
                style={{ minWidth: "7rem" }}
            />
        );
    };
    //format submitted on date format
    const TimeSubmitted = rowdata => {
        return rowdata.submittedOn !== null ? <span> {moment(rowdata.submittedOn).format("MM/DD/YYYY")} </span> : "-";
    };

    return isAuthenticated ? (
        <>
            <ReactFullscreen>
                {({ onToggle }) => (
                    <Layout
                        pageTitle="All Forms"
                        appId="PERSONAL_SERVICE_AGREEMENT"
                        reDirectUrl={"/personalserviceagreement"}
                        reDirectUrlforSA={"/psaconsultant/SuperAdminreports"}
                        activeMenu="Archive"
                        IsSuperadmin={PSAIsSuperadmin == 1 ? true : false}
                        IsArchive={true}
                        reDirectUrlforArchive={"/personalserviceagreement/ArchiveReport"}
                    >
                        <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
                            {/* <div className="flex justify-end visible lg:hidden">
                <Button
                  icon="pi pi-bars"
                  onClick={toggleActive}
                  style={{
                    color: "#308B90",
                    background: "#ffffff00",
                    border: "1",
                    borderColor: "#308B90",
                    width: "38px",
                    padding: "6px 0",
                    borderRadius: "4px"
                  }}
                ></Button>  
              </div>*/}
                            <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
                                <div className="relative z-10 col-span-12" data-aos="fade-down" data-aos-duration="800">
                                    <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]">
                                        <div className="flex items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                                            <p className="text-[22px] xl:text-[0.938vw]  text-[#101828] font-medium">
                                                Personal Service Agreement
                                            </p>

                                            <div className="flex gap-2 xl:gap-[0.990vw] items-center">
                                                {/* advance filter code start */}
                                                {/* <div className="card flex justify-content-center">
                          <Button className="custFilter" label="Filter" icon="pi pi-filter" onClick={() => setVisibleAdvanceFilter(true)} />
                          <Dialog header="Advanced Filter" visible={visibleAdvanceFilter} style={{ width: '50vw' }} onHide={() => setVisibleAdvanceFilter(false)} footer={footerContentForAdvanceFilter}>
                            <div className="grid grid-cols-2 gap-4">
                              <div>
                                <div className="flex-auto">
                                  <label htmlFor="integer" className="font-bold block mb-2">
                                    Assignment Title
                                  </label>
                                  <InputText value={assignmentTitleValue} onChange={(e) => setAssignmentTitleValue(e.target.value)} className="w-full" />
                                </div>
                                <div className="flex-auto">
                                  <label htmlFor="integer" className="font-bold block mb-2">
                                    Submitted On
                                  </label>
                                  <Calendar value={submittedDateValue} onChange={(e) => setSubmittedDateValue(e.value)} className="w-full" />
                                </div>
                                <div className="flex-auto">
                                  <label htmlFor="integer" className="font-bold block mb-2">
                                    Status
                                  </label>
                                  <Dropdown value={selectedStatus} onChange={(e) => setSelectedStatus(e.value)}
                                    // options={status}
                                    options={[
                                      { name: 'Pending', code: 'p' },
                                      { name: 'Pending for approval PSA Consultant', code: 'p1' },
                                      { name: 'Pending for approval Budget Clerk', code: 'p2' },
                                      { name: 'Pending for approval Budget Manager', code: 'p3' },
                                      { name: 'Pending for approval HR Consultant', code: 'p4' },
                                      { name: 'Pending for approval Executive Approver', code: 'p5' },
                                      { name: 'Pending for Acknowledgement HR Executive Secretary', code: 'p6' },
                                      { name: 'Acknowledged by HR Executive Secretary', code: 'p7' },
                                      { name: 'Rejected', code: 'p7' }
                                    ]}
                                    optionLabel="name"
                                    showClear
                                    // itemTemplate={statusItemTemplate}
                                    placeholder="Select a Status" className="w-full md:w-14rem" />
                                </div>
                                <div className="flex-auto">
                                  <label htmlFor="integer" className="font-bold block mb-2">
                                    Initiator
                                  </label>
                                  <Dropdown value={selectedInitiator} onChange={(e) => setSelectedInitiator(e.value)} filter options={employeeList} optionLabel="employee_name"
                                    showClear placeholder="Select an Initiator" className="w-full md:w-14rem" />
                                </div>

                              </div>

                              <div>
                                <div className="flex-auto">
                                  <label htmlFor="integer" className="font-bold block mb-2">
                                    Site/Department
                                  </label>
                                  <Dropdown value={selectedDepartment} onChange={(e) => setSelectedDepartment(e.value)} options={schoolList} optionLabel="name"
                                    showClear placeholder="Select a Department" className="w-full md:w-14rem" />
                                </div>
                                <div className="flex-auto">
                                  <label htmlFor="integer" className="font-bold block mb-2">
                                    PSA Consultant
                                  </label>
                                  <InputText value={psaConsultantValue} onChange={(e) => setPsaConsultantValue(e.target.value)} className="w-full" />
                                </div>
                                <div className="flex-auto">
                                  <label htmlFor="integer" className="font-bold block mb-2">
                                    Personnal Action reference Number
                                  </label>
                                  <InputText value={psaRefValue} onChange={(e) => setPsaRefValue(e.target.value)} className="w-full" />
                                </div>
                              </div>
                            </div>
                          </Dialog>
                        </div> */}
                                                {/* advance filter code end */}

                                                {activeIndex === 0 && loggedPersonnelServiceAgreeInitiator === "1" & reportLoading === false ? (
                                                    <>
                                                        <Link
                                                            to="#"
                                                            className="w-full text-center tableBtn blue radius8"
                                                            onClick={() => {
                                                                // setFormData({});
                                                                // setPsaconsultantData({});
                                                                initiateNewReport();
                                                            }}
                                                        >
                                                            <i className="gusd-pluse-circle mx-1.5 "></i> Initiate New Report
                                                        </Link>

                                                        <Link
                                                            to="#"
                                                            onClick={() => {
                                                                exportFilteredDataToCSV("PSAInitiator.csv");
                                                            }}
                                                            className=" "
                                                        >
                                                            {" "}
                                                            <i className="pi pi-download "></i>
                                                        </Link>
                                                    </>
                                                ) : loggedPersonnelServiceAgreeApprover === "1" ? (
                                                    <>
                                                        <Link
                                                            to="#"
                                                            onClick={() => {
                                                                exportFilteredApproverDataToCSV("PSAApprover.csv");
                                                            }}
                                                            className=" "
                                                        >
                                                            {" "}
                                                            <i className="pi pi-download "></i>
                                                        </Link>
                                                    </>
                                                ) : (
                                                    ""
                                                )}

                                                <Link to="" onClick={onToggle}>
                                                    {" "}
                                                    <i className="gusd-expand"></i>
                                                </Link>
                                            </div>
                                        </div>

                                        <div>

                                            <>
                                                <TabView
                                                    activeIndex={activeIndex}
                                                    onTabChange={e => {
                                                        setActiveIndex(e.index);
                                                    }}
                                                >
                                                    <TabPanel header="Archive Reports">
                                                        <div
                                                            className={
                                                                initiatorReportList.length === 0
                                                                    ? "datatableemptymessage arrowhide"
                                                                    : "initiator  arrowshow"
                                                            }
                                                        >
                                                            <div className="">
                                                                <div className="initiator">
                                                                    <DataTable
                                                                        className="custpaginator custIcons custmBtnTable custTable"
                                                                        scrollable
                                                                        loading={reportLoading}
                                                                        filters={filters}
                                                                        filterDisplay="row"
                                                                        value={initiatorReportList}
                                                                        // value={(isUseFilter) ? filteredData : initiatorReportList}
                                                                        // value={filteredData.length ? filteredData : initiatorReportList}
                                                                        paginator
                                                                        responsiveLayout="scroll"
                                                                        paginatorTemplate="PrevPageLink PageLinks NextPageLink"
                                                                        rows={10}
                                                                        // sortOrder="-1"
                                                                        sortField="submittedOn"
                                                                        emptyMessage={customEmptyMessage}
                                                                    >
                                                                        <Column
                                                                            field="srNo"
                                                                            header="SL#"
                                                                            sortable
                                                                            style={{ minWidth: "3rem" }}
                                                                        ></Column>
                                                                        <Column
                                                                            field="assignmentTitle"
                                                                            filters
                                                                            header="Assignment Title"
                                                                            sortable
                                                                            filter
                                                                            filterPlaceholder="Search"
                                                                            style={{ minWidth: "12rem" }}
                                                                        ></Column>
                                                                        {/* <Column field="period" filters header="Period" sortable filter filterPlaceholder="Search"></Column> */}
                                                                        <Column
                                                                            field="submittedOn"
                                                                            filters
                                                                            header="Submitted On"
                                                                            sortable
                                                                            filter
                                                                            filterPlaceholder="Search"
                                                                            // style={{ minWidth: "12rem" }}
                                                                            style={{ minWidth: "5rem" }}
                                                                            body={TimeSubmitted}
                                                                        ></Column>
                                                                        <Column
                                                                            field="status"
                                                                            header="Status"
                                                                            body={TaskStatusSLA}
                                                                            filter
                                                                            filterElement={statusRowFilterTemplate}
                                                                            sortable
                                                                            style={{ minWidth: "12rem" }}
                                                                        ></Column>
                                                                        <Column field="assignee" filter
                                                                            filterPlaceholder="Search" header="Assignee" align='center' sortable style={{ minWidth: '6rem' }}></Column>
                                                                        <Column
                                                                            field="remark"
                                                                            header="Remarks"
                                                                            align="center"
                                                                            style={{ minWidth: "12rem" }}
                                                                        ></Column>

                                                                        {/* add new four columns */}
                                                                        <Column
                                                                            field="department"
                                                                            header="Site/Department"
                                                                            align="center"
                                                                            filter
                                                                            filterElement={depatmentRowFilterTemplate}
                                                                            style={{ minWidth: "12rem" }}
                                                                        ></Column>
                                                                        <Column
                                                                            field="partyName"
                                                                            header="PSA Consultant"
                                                                            align="center"
                                                                            filter
                                                                            filterPlaceholder="Search"
                                                                            style={{ minWidth: "12rem" }}
                                                                        ></Column>
                                                                        <Column
                                                                            field="psaRefNo"
                                                                            header="PA Ref. No"
                                                                            align="center"
                                                                            filter
                                                                            filterPlaceholder="Search"
                                                                            style={{ minWidth: "10rem" }}
                                                                        ></Column>
                                                                        <Column
                                                                            field="submittedBy"
                                                                            header="Initiator Name"
                                                                            align="center"
                                                                            filter
                                                                            filterPlaceholder="Search"
                                                                            style={{ minWidth: "12rem" }}
                                                                        ></Column>
                                                                        <Column
                                                                            field="action"
                                                                            header="Action"
                                                                            align="center"
                                                                            body={initiateReportAction}
                                                                            frozen
                                                                            alignFrozen="right"
                                                                            style={{ minWidth: "10rem" }}
                                                                        ></Column>
                                                                    </DataTable>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </TabPanel>
                                                </TabView>
                                            </>

                                        </div>
                                        {
                                            (isVisibleRestore) ?
                                                <RestoreDialog
                                                    isVisibleDelete={isVisibleRestore}
                                                    setIsVisibleDelete={setIsVisibleRestore}
                                                    isVisibleDeleteID={isVisibleDeleteID}
                                                    restoreData={restoreData}
                                                    loggedUserId={loggedUserId}
                                                    getMasterData={() => BindList()}
                                                    setIsLoadData={() => setReportLoading(true)}
                                                    queries={queries.getPSAConsultant}
                                                    tableName={"getPSAConsultant"}
                                                    mutations={mutations.updatePSAConsultant}
                                                /> : null
                                        }
                                        <Dialog
                                            className="relative reports-popup"
                                            visible={visible}
                                            position={position}
                                            style={{ width: "80vw" }}
                                            breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                                            onHide={() => setVisible(false)}
                                            draggable={false}
                                            resizable={false}
                                        >
                                            <div className="grid grid-cols-1 lg:grid-cols-12">
                                                <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">
                                                    <div className="p-5">
                                                        <div onClick={() => setVisible(false)} className="py-3">
                                                            <Image src={sideBarRight} alt="user" width="24" height="24" />
                                                        </div>

                                                        {!fullViewForView ? (
                                                            <div className="">
                                                                <div className="text-center">
                                                                    <div className="text-[#000000] text-md lg:text-[0.833vw] font-bold">
                                                                        GLENDALE UNIFIED SCHOOL DISTRICT
                                                                    </div>
                                                                    <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">
                                                                        Request For Approval - Sixth Period Teaching Assignment
                                                                    </div>
                                                                </div>

                                                                <div className="pt-3">
                                                                    <p>Approval Status</p>
                                                                    <div className="py-3 emp-simple-tbl">
                                                                        <DataTable
                                                                            value={[
                                                                                {
                                                                                    id: "1000",
                                                                                    title: "Principal",
                                                                                    name: "Alrick Barwa",
                                                                                    status: "Approved"
                                                                                },
                                                                                {
                                                                                    id: "1001",
                                                                                    title: "Teacher",
                                                                                    name: "John Mishra",
                                                                                    status: "Approved"
                                                                                },
                                                                                {
                                                                                    id: "1002",
                                                                                    title: "EAFE Program Administrator",
                                                                                    name: "Alrick Barwa",
                                                                                    status: "Approved"
                                                                                }
                                                                            ]}
                                                                        >
                                                                            <Column field="title" header="Title"></Column>
                                                                            <Column field="name" header="Name"></Column>
                                                                            <Column field="status" header="Status"></Column>
                                                                        </DataTable>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : null}

                                                        <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">
                                                            <div className="flex justify-between">
                                                                <div className="text-[#344054] font-medium text-[20px] pb-3">
                                                                    <i className="mr-3 gusd-file-icon"></i>Sixth Period Teaching Assignment.pdf
                                                                </div>
                                                                <button
                                                                    onClick={() => {
                                                                        !fullViewForView ? setFullViewForView(true) : setFullViewForView(false);
                                                                    }}
                                                                    className="text-[#113699] font-medium text-[14px] pb-3"
                                                                >
                                                                    <i className="pi pi-calendar mr-1 mt-2"></i>
                                                                    {!fullViewForView ? "View Full Screen" : "Exit Full Screen"}{" "}
                                                                </button>
                                                            </div>

                                                            <div className="grid grid-cols-1">
                                                                {/* <img src={pdfImage} alt='myImg' /> */}
                                                                {/* <HtmlToPdf
                              data={{
                                'employeeName': 'Abc',
                                'employeeId': selectedEmployee.name,
                                'schoolName': schoolSelect.name,
                                'dateFrom': moment(startDate).format("YYYY-DD-MM"),
                                'dateTo': moment(endDate).format("YYYY-DD-MM"),
                                'subjectName': subjectCode.name,
                                'staffAllocation': totalStaffingAllocationectedRole,
                                'accountCharged': accountCharge,
                                'fteUtilized': fteUtilized
                              }}
                            /> */}
                                                                <PsaPdf2
                                                                    agreementDate="26/09/98"
                                                                    partyName="BlueOrbit"
                                                                    amount=""
                                                                    services="lunch dinner free"
                                                                    effectiveDate="02/09/1998"
                                                                    expirationDate="06/09/1998"
                                                                    typeOfBusinessEntityAandN="Insaurance Form"
                                                                    submittedTo="30/06/2023"
                                                                    referenceNo="33"
                                                                    // PSA Consultant details
                                                                    typeOfBusinessEntityPartyDetails="Individual"
                                                                    licenseNumber="LE02145"
                                                                    addressPSa="USA"
                                                                    psaDate="03/25/2024"
                                                                    contactNumber="9823456988"
                                                                    fax="66665"
                                                                    //Tax Identification Details
                                                                    socialSecurityNumber="30"
                                                                    employerIdentification="This is Employer Identification"
                                                                    //Gusd Detailes
                                                                    gusdDate="02/12/2023"
                                                                    accountNumber="98745211"
                                                                    dateOfBoardMeeting="26/09/98"
                                                                    BoardItem="Board"
                                                                    pageItem="page"
                                                                    superintendentAssistent="Mahesh"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="grid grid-cols-2 gap-4">
                                                            <div className="bg-white border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                                <i className="mr-3 gusd-print-outline"></i>
                                                                <span>Print</span>
                                                            </div>

                                                            <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                                <i className="mr-3 gusd-print-outline"></i>
                                                                <span>Download</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="p-5">
                                                    <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                                                    <div className="card custTable">
                                                        <Timeline
                                                            value={events}
                                                            opposite={item => (
                                                                <Tag
                                                                    severity={approveStatusOptionsTimeline(item)}
                                                                    className="mr-2 relative d-tag top-[-5px]"
                                                                    value={item.status}
                                                                ></Tag>
                                                            )}
                                                            content={(item, i) => (
                                                                <div className="relative top-[-10px]">
                                                                    Step {i + 1}
                                                                    {/* <div className="text-[#667085] text-[12px] ml-2">
                                Step{" "}
                                {
                                i + item.designation === "Initiator"
                                  ? "1"
                                  : item.designation === "PSA Consultant"
                                    ? "2"
                                    : item.designation === "Budget Clerk"
                                      ? "3"
                                      : item.designation === "Budget Manager"
                                        ? "4"
                                        : item.designation === "HR Executive Secretary (Approver)" 
                                          ? "5"
                                          : item.designation === "Executive Approver"
                                            ? "6"
                                            : item.designation === "HR Executive Secretary (HR/Payroll)"
                                              ? "7"
                                              : 1
                                              }
                                              
                              </div> */}
                                                                    <div className="text-[11px]  xl:text-[0.729vw]  font-semibold text-[#113699] leading-tight ml-2">
                                                                        {item.designation}
                                                                    </div>
                                                                    <div className="text-[11px] xl:text-[0.729vw]  font-semibold leading-tight ml-2">
                                                                        {item.name}
                                                                    </div>
                                                                    <div className="text-color-secondary text-[9px] ml-2">{item.dateTime !== "Invalid date" ? item.dateTime : ''}</div>

                                                                </div>
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">
                          <div className="p-5">
                            <div className="text-[#344054] text-[16px] font-medium py-3">Form History</div>
                            <div>
                              <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">
                                Yesterday
                              </div>
                              <div className="flex items-start justify-between gap-2 py-2">
                                <Image src={user1} alt="user" width="32" height="32" />
                                <div className="">
                                  <div className="flex justify-between">
                                    <div>
                                      <div className="text-[#344054] font-semibold text-[14px]">Jhon Paul</div>
                                      <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                        <i className="mr-1 gusd-commented"></i>
                                        <span>Commented on parties Tab</span>
                                      </div>
                                    </div>
                                    <div className="text-[#344054] text-[12px]">09:00</div>
                                  </div>
                                  <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">
                                    changed the input name of employee from “Kalvin” to “Samston”.
                                  </div>
                                </div>
                              </div>
                              <div className="flex items-start justify-between gap-2 py-2">
                                <Image src={user2} alt="user" width="32" height="32" />
                                <div className="">
                                  <div className="flex justify-between">
                                    <div>
                                      <div className="text-[#344054] font-semibold text-[14px]">Jhoana Maria</div>
                                      <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                        <i className="mr-1 gusd-commented"></i>
                                        <span>Commented on parties Tab</span>
                                      </div>
                                    </div>
                                    <div className="text-[#344054] text-[12px]">09:00</div>
                                  </div>
                                  <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">
                                    changed the input name of employee from “Kalvin” to “Samston”.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">
                                April 7h
                              </div>
                              <div className="flex items-start justify-between gap-2 py-2">
                                <Image src="/assets/images/user3.svg" alt="user" width="32" height="32" />
                                <div className="">
                                  <div className="flex justify-between">
                                    <div>
                                      <div className="text-[#344054] font-semibold text-[14px]">Jennifer Lopez</div>
                                      <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                        <i className="mr-1 gusd-commented"></i>
                                        <span>Commented on parties Tab</span>
                                      </div>
                                    </div>
                                    <div className="text-[#344054] text-[12px]">09:00</div>
                                  </div>
                                  <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">
                                    changed the input name of employee from “Kalvin” to “Samston”.
                                  </div>
                                </div>
                              </div>
                              <div className="flex items-start justify-between gap-2 py-2">
                                <Image src="/assets/images/user4.svg" alt="user" width="32" height="32" />
                                <div className="">
                                  <div className="flex justify-between">
                                    <div>
                                      <div className="text-[#344054] font-semibold text-[14px]">Lethicia Jhansen</div>
                                      <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                        <i className="mr-1 gusd-commented"></i>
                                        <span>Commented on parties Tab</span>
                                      </div>
                                    </div>
                                    <div className="text-[#344054] text-[12px]">09:00</div>
                                  </div>
                                  <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">
                                    changed the input name of employee from “Kalvin” to “Samston”.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">
                                April 7h
                              </div>
                              <div className="flex items-start justify-between gap-2 py-2">
                                <Image src="/assets/images/user5.svg" alt="user" width="32" height="32" />
                                <div className="">
                                  <div className="flex justify-between">
                                    <div>
                                      <div className="text-[#344054] font-semibold text-[14px]">Jhon Doe</div>
                                      <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                        <i className="mr-1 gusd-commented"></i>
                                        <span>Commented on parties Tab</span>
                                      </div>
                                    </div>
                                    <div className="text-[#344054] text-[12px]">09:00</div>
                                  </div>
                                  <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">
                                    changed the input name of employee from “Kalvin” to “Samston”.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                                            </div>
                                        </Dialog>

                                        {/* edit popup start */}
                                        <Dialog
                                            className="relative reports-popup"
                                            visible={visibleEdit}
                                            position="right"
                                            style={{ width: `${fullViewEdit ? "50vw" : "30vw"}` }}
                                            breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                                            onHide={() => setVisibleEdit(false)}
                                            draggable={false}
                                            resizable={false}
                                        >
                                            <div className="">
                                                <div className="bg-[#F5F6F7] relative h-screen">
                                                    <div className="p-5">
                                                        <a to="" onClick={() => setVisibleEdit(false)} className="py-3">
                                                            <Image src={sidebar} alt="user" width="24" height="24" />
                                                        </a>

                                                        {!fullViewEdit ? (
                                                            <div>
                                                                <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">
                                                                    Personal Service Agreement
                                                                </div>
                                                                <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">
                                                                    Sixth Period Teaching Assignment - Classified form
                                                                </div>
                                                                <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                                                    <div className="mb-1">
                                                                        <label
                                                                            className="text-[#344054] text-[0.729vw] font-medium pb-1"
                                                                            htmlFor="username"
                                                                        >
                                                                            Approval Status
                                                                        </label>
                                                                        <div className="py-3 emp-simple-tbl">
                                                                            <DataTable
                                                                                value={[
                                                                                    {
                                                                                        id: "1000",
                                                                                        title: "Principal",
                                                                                        name: "Alrick Barwa",
                                                                                        status: "Approved"
                                                                                    },
                                                                                    {
                                                                                        id: "1001",
                                                                                        title: "Teacher",
                                                                                        name: "John Mishra",
                                                                                        status: "Approved"
                                                                                    },
                                                                                    {
                                                                                        id: "1002",
                                                                                        title: "EAFE Program Administrator",
                                                                                        name: "Alrick Barwa",
                                                                                        status: "Approved"
                                                                                    }
                                                                                ]}
                                                                            >
                                                                                <Column field="title" header="Title"></Column>
                                                                                <Column field="name" header="Name"></Column>
                                                                                <Column field="status" header="Status"></Column>
                                                                            </DataTable>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : null}

                                                        <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">
                                                            {!fullViewEdit ? (
                                                                <div className="flex justify-between">
                                                                    <div className="text-[#344054] font-medium text-[20px] pb-3">
                                                                        <i className="mr-3 gusd-document"></i>Sixth Period.pdf
                                                                    </div>
                                                                    <button
                                                                        onClick={() => setFullViewEdit(true)}
                                                                        className="text-[#113699] font-medium text-[14px] pb-3"
                                                                    >
                                                                        <i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <div className="flex justify-between">
                                                                    <div className="text-[#344054] font-medium text-[20px] pb-3">
                                                                        <i className="mr-3 gusd-document"></i>Sixth Period Teaching Assignment.pdf
                                                                    </div>
                                                                    <button
                                                                        onClick={() => setFullViewEdit(false)}
                                                                        className="text-[#113699] font-medium text-[14px] pb-3"
                                                                    >
                                                                        <i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen
                                                                    </button>
                                                                </div>
                                                            )}

                                                            {!fullViewEdit ? (
                                                                <div className="grid grid-cols-1 border border-[red] h-80 overflow-hidden">
                                                                    {/* <img src={pdfImageForEdit} alt='myImg' /> */}
                                                                    <HtmlToPdf
                                                                        data={{
                                                                            employeeName: "Abc",
                                                                            employeeId: specificReportDetailsEdit.employee_id,
                                                                            schoolName: specificReportDetailsEdit.assighment_at,
                                                                            dateFrom: specificReportDetailsEdit.from_date,
                                                                            dateTo: specificReportDetailsEdit.to_date,
                                                                            subjectName: specificReportDetailsEdit.subject_area,
                                                                            staffAllocation: specificReportDetailsEdit.total_staffing_allocation,
                                                                            accountCharged: specificReportDetailsEdit.account_charged,
                                                                            fteUtilized: specificReportDetailsEdit.current_fte_utilized
                                                                        }}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] overflow-y-auto"
                                                                    style={{ height: "580px" }}
                                                                >
                                                                    {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                                                    <HtmlToPdf
                                                                        data={{
                                                                            employeeName: "Abc",
                                                                            employeeId: specificReportDetailsEdit.employee_id,
                                                                            schoolName: specificReportDetailsEdit.assighment_at,
                                                                            dateFrom: specificReportDetailsEdit.from_date,
                                                                            dateTo: specificReportDetailsEdit.to_date,
                                                                            subjectName: specificReportDetailsEdit.subject_area,
                                                                            staffAllocation: specificReportDetailsEdit.total_staffing_allocation,
                                                                            accountCharged: specificReportDetailsEdit.account_charged,
                                                                            fteUtilized: specificReportDetailsEdit.current_fte_utilized
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">
                                                        <Link
                                                            to="#"
                                                            className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                                                            //  onClick={() => setVisibleCreteReportPopup(false)}
                                                            onClick={() => setConfirmVisible(true)}
                                                        >
                                                            <i className="pi pi-save mr-1" style={{ fontSize: "1rem" }}></i>Save
                                                        </Link>

                                                        <Link
                                                            to=""
                                                            className=" text-center flex items-center tableBtn blue radius8"
                                                            //  onClick={() => saveGroupInfo()}
                                                            onClick={() => setConfirmVisible(true)}
                                                        >
                                                            <i className="pi pi-check mr-1" style={{ fontSize: "1rem" }}></i>Submit
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </Dialog>

                                        {/* confirmation dialog */}

                                        <Dialog
                                            header=""
                                            visible={confirmVisible}
                                            style={{ width: "30vw" }}
                                            onHide={() => {
                                                setConfirmVisible(false);
                                                setVisibleEdit(false);
                                            }}
                                            footer={footerContent}
                                        >
                                            <p className="m-0 text-[#0487C8]">
                                                <i className="pi pi-check-circle mr-2"></i>
                                                <span className="font-medium text-[18px]">Your changes has been saved in this report</span>
                                            </p>
                                        </Dialog>
                                        {/* edit popup end */}

                                        <SignatureDialog
                                            isVisible={signatureDialog}
                                            onClickHandler={image => handleSignatureSelection(image)}
                                            onCloseHandler={() => {
                                                setSignatureDialog(false);
                                                setAddSignature(false);
                                                setIsSignatureAdded(false);
                                            }}
                                            username={loggedInUserData?.name}
                                        />
                                    </div>

                                    <Sidebar
                                        visible={visibleRight}
                                        position="right"
                                        onHide={() => setVisibleRight(false)}
                                        style={{ width: "35vw" }}
                                        className="customesidebar1 responsivepoup"
                                    >
                                        <Editpopup
                                            popupstate={() => setVisibleRight(false)}
                                            fromDate={fromDate}
                                            toDate={toDate}
                                            schoolName={schoolName}
                                            reportEmployeeList={reportEmployeeList}
                                            status={status}
                                            reportId={reportId}
                                            bindList={() => loadAbsenceReport()}
                                            type={"Initior"}
                                        />
                                    </Sidebar>
                                </div>
                            </div>
                        </div>

                        {/* popup's */}
                        <Dialog
                            className="relative reports-popup"
                            visible={visibleCreteReportPopup}
                            position="right"
                            style={{ width: "30vw" }}
                            breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                            onHide={() => setVisibleCreteReportPopup(false)}
                            draggable={false}
                            resizable={false}
                        >
                            <div className="">
                                <div className="bg-[#F5F6F7] relative h-screen">
                                    <div className="p-5">
                                        <a to="" onClick={() => setVisibleCreteReportPopup(false)} className="py-3">
                                            <Image src={sidebar} alt="user" width="24" height="24" />
                                        </a>
                                        <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">Personal Service Agreement</div>
                                        {/* <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Roles</div> */}
                                        <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                            <div className="mb-1">
                                                <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">
                                                    Assignment Title
                                                </label>
                                                <div>
                                                    <InputText
                                                        value={groupName}
                                                        onChange={e => setGroupName(e.target.value)}
                                                        id="username"
                                                        placeholder="Type Here"
                                                        className="w-full placeholder:text-[#667085] "
                                                        aria-describedby="username-help"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">
                                        <Link
                                            to="#"
                                            className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                                            onClick={() => setVisibleCreteReportPopup(false)}
                                        >
                                            <i className="pi pi-times mr-1" style={{ fontSize: "1rem" }}></i>Cancel
                                        </Link>

                                        <Link
                                            to=""
                                            className=" text-center flex items-center tableBtn blue radius8"
                                            onClick={() => {
                                                setShowNextPopUp(true);
                                                // saveGroupInfo();
                                            }}
                                        >
                                            <i className="pi pi-arrow-right mr-1" style={{ fontSize: "1rem" }}></i>Next
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </Dialog>

                        {/* next full popup */}
                        <PersonalsServiceagreementModal
                            showNextPopUp={showNextPopUp}
                            setShowNextPopUp={setShowNextPopUp}
                            showPreviewPopUp={showPreviewPopUp}
                            setShowPreviewPopUp={setShowPreviewPopUp}
                            psaconsultantData={psaconsultantData}
                            setPsaconsultantData={setPsaconsultantData}
                            empCodeList={empCodeList}
                            setEmpCodeList={setEmpCodeList}
                            schoolList={schoolList}
                            setSchoolList={setSchoolList}
                            formData={formData}
                            setFormData={setFormData}
                            visibleCreteReportPopup={visibleCreteReportPopup}
                            setVisibleCreteReportPopup={setVisibleCreteReportPopup}
                            visibleEdit={visibleEdit}
                            setVisibleEdit={setVisibleEdit}
                            setIsEdit={setIsEdit}
                            isEdit={isEdit}
                            pSAPartyData={pSAPartyData}
                            setPSAPartyData={setPSAPartyData}
                            isApproverEdit={isApproverEdit}
                            setIsApproverEdit={setIsApproverEdit}
                            routingData={routingData}
                            setRoutingData={setRoutingData}
                            BindList={() => BindList()}
                            getMasterData={() => getMasterData()}
                            setActiveIndex={setActiveIndex}
                            imEdit={imEdit}
                            psaPdfUpdate={psaPdfUpdate}
                            setIsPsaPdfUpdate={setIsPsaPdfUpdate}
                        />

                        <Sidebar
                            className="PSAviewPopup psapopus"
                            visible={PSAview}
                            position="right"
                            onHide={() => {
                                setPsaconsultantViewDoc([]);
                                setInitiatorDocuments([]);
                                setPartyDocuments([]);
                                setPSAPartyData([]);
                                setPSAview(false);
                            }}
                            style={{ width: "80vw", background: "#F5F6F7" }}
                            breakpoints={{ '960px': '100vw', '641px': '100vw' }}
                        >
                            <div className="">
                                <div className="grid grid-cols-3">
                                    <div className="col-span-2 xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px]">
                                        <div className="cursor-pointer mb-[20px]" onClick={() => setPSAview(false)}>
                                            <Image src={sideBarRight} alt="user" width="20" height="20" />
                                        </div>
                                        <div className="text-black font-bold xl:text-[1.406vw] text-[25px] text-center">
                                            GLENDALE UNIFIED SCHOOL DISTRICT
                                        </div>
                                        <div className="text-black font-normal xl:text-[0.938vw] text-[16px] text-center">
                                            Request For Approval - Personal Service Agreement123
                                        </div>
                                        {initiatorDocuments?.length > 0 && (
                                            <>
                                                <div className="flex gap-1 mt-2">
                                                    <span>Uploaded Documents</span>
                                                    <span className="gusd-file-icon mt-1.5 w-4 h-4 inline-block"></span>
                                                </div>
                                            </>
                                        )}
                                        {initiatorDocuments?.length > 0 ? (
                                            <>
                                                <div className=" bg-[#F5F6F7] flex items-center justify-between">
                                                    <div className="flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]">
                                                        <div className="col mt-2">
                                                            <div class="border border-dashed border-gray-500 relative" style={{ padding: "10px" }}>
                                                                {initiatorDocuments.map(res => {
                                                                    return (
                                                                        // <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
                                                                        // <h5>
                                                                        <p
                                                                            className="psa-attachments-notes-remove-btn"
                                                                            style={{ cursor: "pointer", fontSize: "14px" }}
                                                                            onClick={() => {
                                                                                res?.filepath && OpenDocument(res?.filepath);
                                                                            }}
                                                                        >
                                                                            {res?.filename}
                                                                        </p>
                                                                        // </h5>
                                                                        // </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            ""
                                        )}
                                        {psaconsultantViewDoc?.length > 0 ? (
                                            <div className=" bg-[#F5F6F7] flex items-center justify-between mt-4">
                                                <div className="flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]">
                                                    <div className="col">
                                                        {psaconsultantViewDoc.map(res => {
                                                            if (res?.filename) {
                                                                return (

                                                                    <div class="border border-dashed border-gray-500 relative" style={{ padding: "10px" }}>
                                                                        {/* <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
                                       <h5> */}
                                                                        <p
                                                                            className="psa-attachments-notes-remove-btn"
                                                                            style={{ cursor: "pointer", fontSize: "14px" }}
                                                                            onClick={() => {
                                                                                const filePath =
                                                                                    "psaconsultant/" + res.psaConsultantId + "/document/psaparty/" + res?.filename;
                                                                                res?.filename && OpenDocument(filePath);
                                                                            }}
                                                                        >
                                                                            {res?.filename}
                                                                        </p>
                                                                        {/* </h5>
                                       </div>
                                       :
                                       < ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="5" fill="var(--surface-ground)" animationDuration="2s" /> */}
                                                                    </div>
                                                                );
                                                            }


                                                        })}
                                                    </div>
                                                    <div className="col ">
                                                        {psaconsultantViewDoc.map(res => {
                                                            if (res?.filename2) {
                                                                return (
                                                                    <div class="border border-dashed border-gray-500 relative" style={{ padding: "10px" }}>
                                                                        <p
                                                                            className="psa-attachments-notes-remove-btn"
                                                                            style={{ cursor: "pointer", fontSize: "14px" }}
                                                                            onClick={() => {
                                                                                const filePath =
                                                                                    "psaconsultant/" + res.psaConsultantId + "/document/psaparty/" + res?.filename2;
                                                                                res?.filename2 && OpenDocument(filePath);
                                                                            }}
                                                                        >
                                                                            {res?.filename2}
                                                                        </p>
                                                                    </div>
                                                                );
                                                            }

                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}

                                        {partyDocuments.length > 0 ? (
                                            <div className="mt-4 grid grid-cols-2 gap-8">
                                                <div className="col">
                                                    <p>{partyDocuments.length ? "View Uploaded Document" : null}</p>
                                                    <div
                                                        class="border border-dashed border-gray-500 relative space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px] mt-2"
                                                        style={{ padding: "10px" }}
                                                    >
                                                        {partyDocuments.length
                                                            ? partyDocuments.map((res, index) => {
                                                                return (
                                                                    <a
                                                                        href={"#"}
                                                                        onClick={() => {
                                                                            res?.filepath && OpenDocument(res?.filepath);
                                                                        }}
                                                                        disabled
                                                                        style={{ cursor: "pointer", fontSize: "14px" }}
                                                                        className="psa-attachments-notes-remove-btn"
                                                                        target="_blank"
                                                                    >
                                                                        {res?.filename}
                                                                    </a>
                                                                );
                                                            })
                                                            : null}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}

                                        <div className="xl:p-[1.250vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between mt-[20px]">
                                            <div className="flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]">
                                                <span className="gusd-file-icon w-4 h-4 inline-block"></span>
                                                <span>Personal Service Agreement.pdf</span>
                                            </div>
                                        </div>
                                        <div>
                                            <div className=" xl:p-[1.250vw] p-[20px] bg-[#F5F5F5] rounded-bl rounded-br" style={{ height: 550 }}>
                                                <div className="lg:h-[28vw] h-[550px] overflow-auto">
                                                    <PsaPdf2
                                                        agreementDate={formViewData?.agreementDate}
                                                        partyName={formViewData?.party}
                                                        amount={formViewData?.amount}
                                                        services={formViewData?.services}
                                                        effectiveDate={formViewData?.effectiveDate}
                                                        expirationDate={formViewData?.expireDate}
                                                        typeOfBusinessEntityAandN={formViewData?.businessEntity}
                                                        submittedTo={formViewData?.submittedTo?.name}
                                                        submittedCompletedFormTo={formViewData?.submittedCompletedFormTo}
                                                        referenceNo={formViewData?.referenceNo}
                                                        purchaseOrderNo={formViewData?.purchaseOrderNo}
                                                        refPrint={componentRef}
                                                        addendumNo={formViewData?.addendumNo}
                                                        typeBE={formViewData?.typeBE}
                                                        dateOfApprove={formViewData?.dateOfApprove}
                                                        otherTypeBE={formViewData?.typeBE}
                                                        businessEntity={
                                                            psaconsultantData?.businessEntity && psaconsultantData?.businessEntity?.split(",")
                                                        }
                                                        typeOfBusinessEntityPartyDetails={formViewData?.typeOfBusinessEntityPartyDetails}
                                                        title={formViewData?.title}
                                                        licenseNumber={formViewData?.license}
                                                        addressPSa={`${formViewData?.address != null ? formViewData?.address : "-"}
                          ${formViewData?.city != null ? formViewData?.city : "-"}
                          ${formViewData?.state != null ? formViewData?.state : "-"}
                          ${formViewData?.zip != null ? formViewData?.zip : "-"}
                          `}
                                                        psaDate={formViewData?.psaDate}
                                                        pocNumber={formViewData?.pocNumber}
                                                        // contactNumber={formViewData?.contactNumber}
                                                        contactNumber={formViewData?.pocNumber}
                                                        fax={formViewData?.pocName}
                                                        //Tax Identification Details
                                                        socialSecurityNumber={formViewData?.ssn}
                                                        employerIdentification={formViewData?.employerID}
                                                        //Gusd Detailes
                                                        gusdDate={formViewData?.gusdDate}
                                                        accountNumber={formViewData?.accountNo}
                                                        dateOfBoardMeeting={formViewData?.dateofboard}
                                                        BoardItem={formViewData?.boardItem}
                                                        pageItem={formViewData?.pageItem}
                                                        superintendentAssistent={formViewData?.superintendentAssistent}
                                                        approvelStatusData={approvelStatusData}
                                                        strs={formViewData?.strs}
                                                        calpers={formViewData?.calpers}
                                                        updatedAt={formViewData?.psaPatyUpdatedDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-span-1  bg-[#EFF0F1] h-auto">
                                        {/* <div className="p-5">
                      <div className="text-[#344054] text-[16px] font-medium py-3">Approval Status</div>
                      <div className="custTimelines">
                        <Timeline
                          className='custTable'
                          value={approvelStatusData}
                          opposite={(item) =>
                            <Tag severity={'success'} value={item.status}></Tag>
                          }
                          content={(item) => <small className="text-color-secondary">{item.name}<br />{item.updatedAt}</small>} />
                      </div>
                    </div> */}

                                        <div className="p-5">
                                            <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                                            <div className="card custTable">
                                                <Timeline
                                                    value={events}
                                                    opposite={item => (
                                                        <Tag
                                                            severity={approveStatusOptionsTimeline(item)}
                                                            className="mr-2 relative d-tag top-[-5px]"
                                                            value={item.status}
                                                        ></Tag>
                                                    )}
                                                    content={(item, i) => (
                                                        <div className="relative top-[-10px]">
                                                            Step {i + 1}
                                                            {/* <div className="text-[#667085] text-[12px] ml-2">
                                Step{" "}
                                {
                                i + item.designation === "Initiator"
                                  ? "1"
                                  : item.designation === "PSA Consultant"
                                    ? "2"
                                    : item.designation === "Budget Clerk"
                                      ? "3"
                                      : item.designation === "Budget Manager"
                                        ? "4"
                                        : item.designation === "HR Executive Secretary (Approver)" 
                                          ? "5"
                                          : item.designation === "Executive Approver"
                                            ? "6"
                                            : item.designation === "HR Executive Secretary (HR/Payroll)"
                                              ? "7"
                                              : 1
                                              }
                                              
                              </div> */}
                                                            <div className="text-[11px]  xl:text-[0.729vw]  font-semibold text-[#113699] leading-tight ml-2">
                                                                {item.designation}
                                                            </div>
                                                            <div className="text-[11px] xl:text-[0.729vw]  font-semibold leading-tight ml-2">
                                                                {item.name}
                                                            </div>
                                                            <div className="text-color-secondary text-[9px] ml-2">{item.dateTime !== "Invalid date" ? item.dateTime : ''}</div>

                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-[20px] gap-[14px]">
                                    <div
                                        className="text-[#FFFFFF] printicon font-medium text-xs xl:text-[0.833vw] bg-[#113699] border border-[#113699] text-center flex items-center justify-center gap-x-2 xl:py-[0.521vw] py-[6px] xl:px-[0.833vw] px-[12px] rounded-lg"
                                        onClick={handlePrint}
                                    >
                                        <i className="Download_WhiteIcon"></i>
                                        <span>Print</span>
                                    </div>
                                    {/* <div>
                    <Link
                      to={""}
                      className="text-[#FFFFFF] font-medium text-xs xl:text-[0.833vw] bg-[#113699] border border-[#113699] text-center flex items-center justify-center gap-x-2 xl:py-[0.521vw] py-[6px] xl:px-[0.833vw] px-[12px] rounded-lg"
                    >
                      <i className="Download_WhiteIcon"></i>
                      <span>Download</span>
                    </Link>
                  </div> */}
                                </div>
                            </div>
                        </Sidebar>

                        <Sidebar
                            className="PSAviewPopup psapopus"
                            visible={PSAedit}
                            position="right"
                            onHide={() => {
                                setPSAedit(false);
                                setAddSignature(false);
                            }}
                            style={{ width: "55vw", minWidth: "40rem", background: "#F5F6F7", position: "relative" }}
                        >
                            <div
                                style={{
                                    // transform: "translate(-999px, 1000px)",

                                    // visibility:"hidden",
                                    position: "absolute",
                                    top: "0",
                                    zIndex: "-1"
                                    // right: "-100%",

                                    // width:"70%"
                                }}
                            >
                                <PsaPdf4
                                    ref={childRef}
                                    // isExecutive={loggedUserId === psaconsultantData.executive}
                                    isExecutive={true}
                                    psaConsultantId={psaconsultantData?.id}
                                    agreementDate={formViewData?.agreementDate}
                                    partyName={formViewData?.party}
                                    amount={formViewData?.amount}
                                    services={formViewData?.services}
                                    effectiveDate={formViewData?.effectiveDate}
                                    expirationDate={formViewData?.expireDate}
                                    dateOfApprove={formViewData?.dateOfApprove}
                                    typeOfBusinessEntityAandN={formViewData?.businessEntity}
                                    submittedTo={formViewData?.submittedTo?.name}
                                    submittedCompletedFormTo={formViewData?.submittedCompletedFormTo}
                                    referenceNo={formViewData?.referenceNo}
                                    purchaseOrderNo={formViewData?.purchaseOrderNo}
                                    refPrint={componentRef}
                                    addendumNo={formViewData?.addendumNo}
                                    typeBE={formViewData?.typeBE}
                                    businessEntity={
                                        psaconsultantData?.businessEntity && psaconsultantData?.businessEntity?.split(",")
                                    }
                                    // PSA Consultant details
                                    typeOfBusinessEntityPartyDetails={formViewData?.typeOfBusinessEntityPartyDetails}
                                    title={formViewData?.title}
                                    licenseNumber={formViewData?.license}
                                    // addressPSa={`${formViewData?.address && formViewData?.address} ${formViewData?.city && formViewData?.city
                                    //   } ${formViewData?.state && formViewData?.state} ${formViewData?.zip && formViewData?.zip}`}

                                    addressPSa={`${formViewData?.address != null ? formViewData?.address : "-"}
                        ${formViewData?.city != null ? formViewData?.city : "-"}
                        ${formViewData?.state != null ? formViewData?.state : "-"}
                        ${formViewData?.zip != null ? formViewData?.zip : "-"}
                        `}
                                    psaDate={formViewData?.psaDate}
                                    // contactNumber={formViewData?.pocNumber}
                                    pocNumber={formViewData?.pocNumber}
                                    fax={formViewData?.fax}
                                    //Tax Identification Details
                                    socialSecurityNumber={formViewData?.ssn}
                                    employerIdentification={formViewData?.employerID}
                                    //Gusd Detailes
                                    gusdDate={formViewData?.gusdDate}
                                    accountNumber={formViewData?.accountNo}
                                    dateOfBoardMeeting={formViewData?.dateofboard}
                                    BoardItem={formViewData?.boardItem}
                                    pageItem={formViewData?.pageItem}
                                    superintendentAssistent={formViewData?.superintendentAssistent}
                                    approvelStatusData={approvelStatusData}
                                    strs={formViewData?.strs}
                                    calpers={formViewData?.calpers}
                                    updatedAt={formViewData?.psaPatyUpdatedDate}
                                />
                            </div>
                            <div className="grid grid-cols-3">
                                <div className="col-span-2 xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px] lg:space-y-[1.250vw] space-y-2">
                                    {/*col*/}
                                    <div
                                        className="cursor-pointer mb-[20px]"
                                        onClick={() => {
                                            setPSAedit(false);
                                            setAddSignature(false);
                                        }}
                                    >
                                        <i className="gusd-close-sidebar"></i>
                                    </div>
                                    {/*col*/}
                                    <div>
                                        <div className="text-[#113699] font-semibold text-sm xl:text-[0.938vw]">
                                            Glendale Unified School District
                                        </div>
                                        <div className="text-[#344054] font-normal text-xs xl:text-[0.677vw]">
                                            Personal Service Agreement{" "}
                                        </div>
                                    </div>

                                    {initiatorDocuments?.length > 0 && (
                                        <>
                                            <div className="flex gap-1 mt-2">
                                                <span>Uploaded Documents</span>
                                                <span className="gusd-file-icon mt-1.5 w-4 h-4 inline-block"></span>
                                            </div>
                                        </>
                                    )}
                                    {initiatorDocuments?.length > 0 ? (
                                        <>
                                            <div className=" bg-[#F5F6F7] flex items-center justify-between ">
                                                <div className="flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]">
                                                    <div className="col mt-6">
                                                        <div class="border border-dashed border-gray-500 relative" style={{ padding: "10px" }}>
                                                            {initiatorDocuments.map(res => {
                                                                return (
                                                                    // <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
                                                                    // <h5>
                                                                    <p
                                                                        className="psa-attachments-notes-remove-btn"
                                                                        style={{ cursor: "pointer", fontSize: "14px" }}
                                                                        onClick={() => {
                                                                            res?.filepath && OpenDocument(res?.filepath);
                                                                        }}
                                                                    >
                                                                        {res?.filename}
                                                                    </p>
                                                                    // </h5>
                                                                    // </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        ""
                                    )}

                                    {psaconsultantDoc?.length > 0 ? (
                                        <div className=" bg-[#F5F6F7] flex items-center justify-between ">
                                            <div className="flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]">
                                                <div className="col">
                                                    <div class="border border-dashed border-gray-500 relative" style={{ padding: "10px" }}>
                                                        {psaconsultantDoc.map(res => {
                                                            return (
                                                                // <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
                                                                // <h5>
                                                                <p
                                                                    className="psa-attachments-notes-remove-btn"
                                                                    style={{ cursor: "pointer", fontSize: "14px" }}
                                                                    onClick={() => {
                                                                        const filePath =
                                                                            "psaconsultant/" + res.psaConsultantId + "/document/psaparty/" + res?.filename;
                                                                        res?.filename && OpenDocument(filePath);
                                                                    }}
                                                                >
                                                                    {res?.filename}
                                                                </p>
                                                                // </h5>
                                                                // </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                                <div className="col ">
                                                    <div class="border border-dashed border-gray-500 relative" style={{ padding: "10px" }}>
                                                        {psaconsultantDoc.map(res => {
                                                            return (
                                                                // <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
                                                                // <h5>
                                                                <p
                                                                    className="psa-attachments-notes-remove-btn"
                                                                    style={{ cursor: "pointer", fontSize: "14px" }}
                                                                    onClick={() => {
                                                                        const filePath =
                                                                            "psaconsultant/" + res.psaConsultantId + "/document/psaparty/" + res?.filename2;
                                                                        res?.filename2 && OpenDocument(filePath);
                                                                    }}
                                                                >
                                                                    {res?.filename2}
                                                                </p>
                                                                // </h5>
                                                                // </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}

                                    {partyDocuments.length > 0 ? (
                                        <div className="mt-4 grid grid-cols-2 gap-8">
                                            <div className="col">
                                                <p>{partyDocuments.length ? "View Uploaded Document" : null}</p>
                                                <div
                                                    class="border border-dashed border-gray-500 relative space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px] mt-2"
                                                    style={{ padding: "10px" }}
                                                >
                                                    {partyDocuments.length
                                                        ? partyDocuments.map((res, index) => {
                                                            return (
                                                                <a
                                                                    href={"#"}
                                                                    onClick={() => {
                                                                        res?.filepath && OpenDocument(res?.filepath);
                                                                    }}
                                                                    disabled
                                                                    style={{ cursor: "pointer", fontSize: "14px" }}
                                                                    className="psa-attachments-notes-remove-btn"
                                                                    target="_blank"
                                                                >
                                                                    {res?.filename}
                                                                </a>
                                                            );
                                                        })
                                                        : null}
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}

                                    {/*col*/}
                                    <div className="bg-[#EFF0F1] p-4 xl:p-[0.885vw]">
                                        <div className="text-[#344054] font-semibold text-xs xl:text-[0.677vw]">Approval Status</div>
                                        <div className="bg-white p-2 xl:p-[0.469vw] rounded-lg mt-[8px]">
                                            <table class="table-auto w-full">
                                                <thead>
                                                    <tr className="text-[#667085] text-xs py-2 px-2 inline-block">
                                                        <th align="left" width={200} className="font-medium">
                                                            Title
                                                        </th>
                                                        <th align="left" width={130} className="font-medium">
                                                            Name
                                                        </th>
                                                        <th align="left" width={150} className="font-medium">
                                                            Status
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {approvelStatusData?.length > 0 &&
                                                        approvelStatusData.map(res => {
                                                            let labelStyle;
                                                            switch (res?.status) {
                                                                case "Approved":
                                                                    labelStyle = "bg-[#E5F3EC] text-[#029046]";
                                                                    break;
                                                                case "Pending for HR Consultant Clearance Verification":
                                                                    labelStyle = "bg-[#E5F3EC] text-[#029046]";
                                                                    break;
                                                                case "Pending for approval HR Consultant":
                                                                    labelStyle = "bg-[#B4D4F3] text-[#0A7FF3]";
                                                                    break;
                                                                case "Pending for approval HR Executive Secretary":
                                                                    labelStyle = "bg-[#B4D4F3] text-[#0A7FF3]";
                                                                    break;
                                                                case "Pending for Review":
                                                                    labelStyle = "bg-[#FFF2E5] text-[#FF7F01]";
                                                                    break;
                                                                case "Rejected":
                                                                    labelStyle = "bg-[#FEF3F2] text-[#D92D20]";
                                                                    break;
                                                                case "Pending for approval Executive Approver":
                                                                    labelStyle = "bg-[#B4D4F3] text-[#0A7FF3]";
                                                                    break;
                                                                case "Pending for Acknowledgement HR Executive Secretary":
                                                                    labelStyle = "bg-[#B4D4F3] text-[#0A7FF3]";
                                                                    break;
                                                                case "Pending for approval Budget Clerk":
                                                                    labelStyle = "bg-[#B4D4F3] text-[#0A7FF3]";
                                                                    break;
                                                                case "Pending for approval Budget Manager":
                                                                    labelStyle = "bg-[#B4D4F3] text-[#0A7FF3]";
                                                                    break;
                                                                default:
                                                                    labelStyle = "bg-[#E5F3EC] text-[#029046]";
                                                                    break;
                                                            }
                                                            return (
                                                                <tr className="text-[#344054] text-xs font-normal py-2 px-2 inline-block border-b border-[#E4E7EC]">
                                                                    <td align="left" width={200}>
                                                                        {res.designation}
                                                                    </td>
                                                                    <td align="left" width={130}>
                                                                        {res.name}
                                                                    </td>
                                                                    {res.isApproved ? (
                                                                        <td align="left" width={150}>
                                                                            <div
                                                                                className={`${labelStyle} text-[10px] xl:px-[0.521vw] px-[8px] xl:py-[0.313vw] py-[4px] rounded-[18px] space-x-2 inline-flex items-center justify-center`}
                                                                            >
                                                                                <i className="pi pi-circle-fill" style={{ fontSize: "8px" }}></i>
                                                                                <span>{"Approved"}</span>
                                                                            </div>
                                                                        </td>
                                                                    ) : (
                                                                        <td align="left" width={150}>
                                                                            <div
                                                                                className={`${labelStyle} text-[10px] xl:px-[0.521vw] px-[8px] xl:py-[0.313vw] py-[4px] rounded-[18px] space-x-2 inline-flex items-center justify-center`}
                                                                            >
                                                                                <i className="pi pi-circle-fill" style={{ fontSize: "8px" }}></i>
                                                                                <span>{res.status}</span>
                                                                            </div>
                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            );
                                                        })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    {/*col*/}
                                    <div>
                                        <div className="xl:p-[1.042vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between">
                                            <div className="flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]">
                                                <span className="gusd-file-icon w-4 h-4 inline-block"></span>
                                                <span>Personal Service Agreement .pdf</span>
                                            </div>
                                            <div
                                                className="text-[#113699] font-medium text-xs flex items-center gap-2 cursor-pointer"
                                                onClick={() => setStipendsFormFullScreen(true)}
                                            >
                                                <span className="view_full_screen block w-[18px] h-[18px]"></span>
                                                <span>View Full Screen</span>
                                            </div>

                                            <div
                                                className="text-[#113699] font-medium text-xs flex items-center gap-2 cursor-pointer"
                                                onClick={() => { setAddSignature(false); initiateNewReportApprover(specificReportDetailsEdit?.PSAConsultantData?.id) }}
                                            >
                                                <i class="gusd-edit mr-1 mt-2"></i>
                                                <span>Edit</span>
                                            </div>
                                        </div>

                                        <div className="xl:p-[1.250vw] p-[20px] bg-[#EFF0F1] rounded-md">
                                            <div className="lg:h-[10.938vw] h-[242px] overflow-auto">
                                                {/* <Image src={PreviewAgreement} width={"473"} height={"612"} alt='preview-agreement' /> */}
                                                {/* <PsaPdf
                        agreementDate="26/09/98"
                        partyName="BlueOrbit"
                        amount="2016"
                        services="lunch dinner free"
                        effectiveDate="02/09/1998"
                        expirationDate="06/09/1998"
                        typeOfBusinessEntityAandN="Insaurance Form"
                        submittedTo="30/06/2023"
                        referenceNo="33"
                        // PSA Consultant details
                        typeOfBusinessEntityPartyDetails="Individual"
                        licenseNumber="LE02145"
                        addressPSa="USA"
                        contactNumber="9823456988"
                        fax="66665"
                        //Tax Identification Details
                        socialSecurityNumber="30"
                        employerIdentification="This is Employer Identification"
                        //Gusd Detailes
                        gusdDate="02/12/2023"
                        accountNumber="98745211"
                        dateOfBoardMeeting="26/09/98"
                        BoardItem="26"
                        pageItem="09"
                      /> */}
                                                {/* <PsaPdf
                        agreementDate={formData?.agreementDate}
                        partyName={formData?.partyName}
                        amount={formData?.amount}
                        services={formData?.services}
                        effectiveDate={formData?.effectiveDate}
                        expirationDate={formData?.expireDate}
                        typeOfBusinessEntityAandN={formData?.typeBE}
                        submittedTo={formData?.submittedTo?.name}
                        referenceNo={formData?.referenceNo}
                        // PSA Consultant details
                        typeOfBusinessEntityPartyDetails={formData?.typeOfBusinessEntityPartyDetails}
                        title={formData?.assignmentTitle}
                        licenseNumber={formData?.license}
                        addressPSa={formData?.addressPSa}
                        psaDate={formData?.psaDate}
                        contactNumber={formData?.contactNumber}
                        fax={formData?.fax}
                        //Tax Identification Details
                        socialSecurityNumber={formData?.socialSecurityNumber}
                        employerIdentification={formData?.employerIdentification}
                        //Gusd Detailes
                        gusdDate={formData?.gusdDate}
                        accountNumber={formData?.accountNo}
                        dateOfBoardMeeting={formData?.dateOfBoardMeeting}
                        BoardItem={formData?.boardItem}
                        pageItem={formData?.pageItem}
                        superintendentAssistent={formData?.superintendentAssistent}
                        approvelStatusData={approvelStatusData}
                      /> */}

                                                <PsaPdf2
                                                    // ref={childRef}
                                                    psaConsultantId={formViewData?.psaConsultantId}
                                                    agreementDate={formViewData?.agreementDate}
                                                    partyName={formViewData?.party}
                                                    amount={formViewData?.amount}
                                                    services={formViewData?.services}
                                                    effectiveDate={formViewData?.effectiveDate}
                                                    expirationDate={formViewData?.expireDate}
                                                    dateOfApprove={formViewData?.dateOfApprove}
                                                    typeOfBusinessEntityAandN={formViewData?.businessEntity}
                                                    submittedTo={formViewData?.submittedTo?.name}
                                                    submittedCompletedFormTo={formViewData?.submittedCompletedFormTo}
                                                    referenceNo={formViewData?.referenceNo}
                                                    purchaseOrderNo={formViewData?.purchaseOrderNo}
                                                    refPrint={componentRef}
                                                    addendumNo={formViewData?.addendumNo}
                                                    typeBE={formViewData?.typeBE}
                                                    businessEntity={
                                                        psaconsultantData?.businessEntity && psaconsultantData?.businessEntity?.split(",")
                                                    }
                                                    // PSA Consultant details
                                                    typeOfBusinessEntityPartyDetails={formViewData?.typeOfBusinessEntityPartyDetails}
                                                    title={formViewData?.title}
                                                    licenseNumber={formViewData?.license}
                                                    // addressPSa={`${formViewData?.address && formViewData?.address} ${formViewData?.city && formViewData?.city
                                                    //   } ${formViewData?.state && formViewData?.state} ${formViewData?.zip && formViewData?.zip}`}

                                                    addressPSa={`${formViewData?.address != null ? formViewData?.address : "-"}
                        ${formViewData?.city != null ? formViewData?.city : "-"}
                        ${formViewData?.state != null ? formViewData?.state : "-"}
                        ${formViewData?.zip != null ? formViewData?.zip : "-"}
                        `}
                                                    psaDate={formViewData?.psaDate}
                                                    // contactNumber={formViewData?.pocNumber}
                                                    pocNumber={formViewData?.pocNumber}
                                                    fax={formViewData?.fax}
                                                    //Tax Identification Details
                                                    socialSecurityNumber={formViewData?.ssn}
                                                    employerIdentification={formViewData?.employerID}
                                                    //Gusd Detailes
                                                    gusdDate={formViewData?.gusdDate}
                                                    accountNumber={formViewData?.accountNo}
                                                    dateOfBoardMeeting={formViewData?.dateofboard}
                                                    BoardItem={formViewData?.boardItem}
                                                    pageItem={formViewData?.pageItem}
                                                    superintendentAssistent={formViewData?.superintendentAssistent}
                                                    approvelStatusData={approvelStatusData}
                                                    strs={formViewData?.strs}
                                                    calpers={formViewData?.calpers}
                                                    updatedAt={formViewData?.psaPatyUpdatedDate}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/*col*/}
                                    <div className="custm_InputSwitch flex items-center text-[#1E3E5A] font-medium text-sm gap-2">
                                        <InputSwitch
                                            checked={addSignature}
                                            onChange={e => {
                                                if (e.value) {
                                                    setIsSignatureAdded(true);
                                                } else {
                                                    setIsSignatureAdded(false);
                                                }
                                                setAddSignature(e.value);
                                            }}
                                        />
                                        <span>
                                            Add Signature<span class="text-[red] pl-0.2">*</span>
                                        </span>
                                    </div>
                                    {/*col*/}
                                    {isHrConsultant && (
                                        <div className="custm_InputSwitch  items-center text-[#1E3E5A] font-medium text-sm gap-2">
                                            <div>
                                                <p>
                                                    {" "}
                                                    Have you added the 'Board Item' and 'Page/Item'? <span className="text-[red] pl-0.2">*</span>
                                                </p>
                                            </div>
                                            <div className="flex flex-wrap gap-3">
                                                <div className="flex align-items-center">
                                                    <RadioButton
                                                        inputId="ingredient1"
                                                        name="pizza"
                                                        value={true}
                                                        onChange={e => {
                                                            setIsItemsAdded(true);
                                                        }}
                                                        checked={isItemsAdded}
                                                    />
                                                    <label htmlFor="ingredient1" className="ml-2">
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="flex align-items-center">
                                                    <RadioButton
                                                        inputId="ingredient2"
                                                        name="pizza"
                                                        value={false}
                                                        onChange={e => {
                                                            setIsItemsAdded(false);
                                                        }}
                                                        checked={!isItemsAdded}
                                                    />
                                                    <label htmlFor="ingredient2" className="ml-2">
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {/*col*/}
                                    {addSignature && signatureFileAwsPath !== null ? (
                                        <div className="py-3 px-5 rounded-[8px] mt-3">
                                            <Card>
                                                <img className={"w-[20%] h-[15%]"} src={signatureFileAwsPath} />
                                            </Card>
                                        </div>
                                    ) : null}
                                    <div className="grid grid-cols-3 gap-2">
                                        <div
                                            className="text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer"
                                            onClick={() => {
                                                setPSAedit(false);
                                                setAddSignature(false);
                                            }}
                                        >
                                            <i className="gusd-close-circle text-base"></i>
                                            <span>Cancel</span>
                                        </div>
                                        {!ackUser ? (
                                            <div
                                                className="text-[#D92D20] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer"
                                                onClick={() => setRejectReport(true)}
                                            >
                                                <i className="gusd-close"></i>
                                                <span>Reject</span>
                                            </div>
                                        ) : null}

                                        {!ackUser ? (
                                            <button
                                                // disabled={pleaseWaitButton === true}
                                                // className="text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer"
                                                onClick={async () => {
                                                    // setFourthApp(fourthApprover)
                                                    if (isSignatureAdded && (isHrConsultant ? isItemsAdded : true)) {
                                                        setPleaseWaitButton(true);
                                                        // if (true) {
                                                        // convertHtmlToBlobss()
                                                        const isExecutive = loggedUserId === psaconsultantData.executive
                                                        if (isExecutive) {
                                                            await convertHtmlToBlob({ isExecutive: isExecutive, psaConsultantId: specificReportDetailsEdit?.PSAConsultantData?.id });
                                                        }
                                                        // childRef.current.convertHtmlToBlob();


                                                        approveSelectedReport(specificReportDetailsEdit?.PSAConsultantData?.id)
                                                        setReport_Approved(true);
                                                        setIsSignatureAdded(false);
                                                        setIsItemsAdded(false);
                                                        setAddSignature(false);
                                                        setReportLoading(true)
                                                        setReportLoadingApprover(true)

                                                    } else if (!isSignatureAdded) {
                                                        toast.error("Add Signature.");
                                                    } else if (isHrConsultant ? !isItemsAdded : false) {
                                                        toast.error("Please add 'Board Item' and 'Page/Item.");
                                                    }
                                                }}
                                                // disabled={(isSignatureAdded && isItemsAdded ) ? false : true}
                                                disabled={(pleaseWaitButton) ? true : false}
                                                className={` 
                      ${isSignatureAdded && (isHrConsultant ? isItemsAdded : true) ? "text-[#039855]" : ""}
                      text-center flex items-center tableBtn bg-white border border-[#D0D5DD] radius8 cursor-pointer `}
                                            // className={` ${
                                            //   signatureFileAwsPath === null || !addSignature || buttonClicked ? "" : "text-[#039855] "
                                            // }text-center flex items-center tableBtn bg-white border border-[#D0D5DD] radius8 cursor-pointer `}
                                            // disabled={signatureFileAwsPath === null || !addSignature || buttonClicked}
                                            >
                                                <i className="pi pi-check mr-2 mt-1"></i>
                                                <span>
                                                    {(pleaseWaitButton) ? 'Please Wait' : "Approve"}
                                                </span>
                                            </button>
                                            // <button onClick={() => childRef.current.generatePDF()}>Click</button>
                                        ) : (
                                            <button
                                                // className="text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer"
                                                onClick={() => {
                                                    if (isSignatureAdded && (isHrConsultant ? isItemsAdded : true)) {

                                                        approveSelectedReport(specificReportDetailsEdit?.PSAConsultantData?.id);
                                                        setReport_Approved(true);
                                                        setIsSignatureAdded(false);
                                                        setIsItemsAdded(false);
                                                        setReportLoading(true);
                                                        setReportLoadingApprover(true);
                                                    } else if (!isSignatureAdded) {
                                                        toast.error("Add Signature.");
                                                    } else if (isHrConsultant ? isItemsAdded : false) {
                                                        toast.error("Please add 'Board Item' and 'Page/Item.");
                                                    }
                                                }}
                                                // disabled={(isSignatureAdded && isItemsAdded) ? false : true}
                                                className={` 
                      ${isSignatureAdded && (isHrConsultant ? isItemsAdded : true) ? "text-[#039855]" : ""}
                      text-center flex items-center tableBtn bg-white border border-[#D0D5DD] radius8 cursor-pointer `}
                                            >
                                                <i className="pi pi-check"></i>

                                                <span>Acknowledge</span>
                                            </button>
                                        )}
                                    </div>
                                    {/* <button
                    onClick={() => {
                      convertHtmlToBlobss()
                    }}>Click
                    </button> */}

                                </div>
                                <div className="col-span-1 p-5">
                                    <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                                    <div className="card custTable">
                                        <Timeline
                                            value={events}
                                            opposite={item => (
                                                <Tag
                                                    severity={approveStatusOptionsTimeline(item)}
                                                    className="mr-2 relative d-tag top-[-5px]"
                                                    value={item.status}
                                                ></Tag>
                                            )}
                                            content={(item, i) => (
                                                <div className="relative top-[-10px]">
                                                    <div className="text-[#667085] text-[12px] ml-2">
                                                        Step {i + 1}
                                                        {/* Step{" "}
                            {i + item.designation === "Initiator"
                              ? "1"
                              : item.designation === "PSA Consultant"
                                ? "2"
                                : item.designation === "Budget Clerk"
                                  ? "3"
                                  : item.designation === "Budget Manager"
                                    ? "4"
                                    : item.designation === "HR Executive Secretary (Approver)"
                                      ? "5"
                                      : item.designation === "Executive Approver"
                                        ? "6"
                                        : item.designation === "HR Executive Secretary (HR/Payroll)"
                                          ? "7"
                                          : 1} */}
                                                    </div>
                                                    <div className="text-[0.729vw]  font-semibold text-[#113699] leading-tight ml-2">
                                                        {item.designation}
                                                    </div>
                                                    <div className="xl:text-[0.729vw] text-[12px] font-semibold leading-tight ml-2">
                                                        {item.name}
                                                    </div>
                                                    <div className="text-color-secondary text-[9px] ml-2">{item.dateTime !== "Invalid date" ? item.dateTime : ''}</div>

                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* <div 
            style={{
              // transform: "translate(-999px, 1000px)",

              visibility:"hidden",
              position:"absolute",
              top: "0",
              width:"70%"}}
            >
            <PsaPdf4
                          ref={childRef}
                          psaConsultantId={formViewData?.psaConsultantId}
                          agreementDate={formViewData?.agreementDate}
                          partyName={formViewData?.party}
                          amount={formViewData?.amount}
                          services={formViewData?.services}
                          effectiveDate={formViewData?.effectiveDate}
                          expirationDate={formViewData?.expireDate}
                          dateOfApprove={formViewData?.dateOfApprove}
                          typeOfBusinessEntityAandN={formViewData?.businessEntity}
                          submittedTo={formViewData?.submittedTo?.name}
                          submittedCompletedFormTo={formViewData?.submittedCompletedFormTo}
                          referenceNo={formViewData?.referenceNo}
                          purchaseOrderNo={formViewData?.purchaseOrderNo}
                          refPrint={componentRef}
                          addendumNo={formViewData?.addendumNo}
                          typeBE={formViewData?.typeBE}
                          businessEntity={
                            psaconsultantData?.businessEntity && psaconsultantData?.businessEntity?.split(",")
                          }
                          // PSA Consultant details
                          typeOfBusinessEntityPartyDetails={formViewData?.typeOfBusinessEntityPartyDetails}
                          title={formViewData?.title}
                          licenseNumber={formViewData?.license}
                          // addressPSa={`${formViewData?.address && formViewData?.address} ${formViewData?.city && formViewData?.city
                          //   } ${formViewData?.state && formViewData?.state} ${formViewData?.zip && formViewData?.zip}`}

                          addressPSa={`${formViewData?.address != null ? formViewData?.address : "-"}
                        ${formViewData?.city != null ? formViewData?.city : "-"}
                        ${formViewData?.state != null ? formViewData?.state : "-"}
                        ${formViewData?.zip != null ? formViewData?.zip : "-"}
                        `}
                          psaDate={formViewData?.psaDate}
                          // contactNumber={formViewData?.pocNumber}
                          pocNumber={formViewData?.pocNumber}
                          fax={formViewData?.fax}
                          //Tax Identification Details
                          socialSecurityNumber={formViewData?.ssn}
                          employerIdentification={formViewData?.employerID}
                          //Gusd Detailes
                          gusdDate={formViewData?.gusdDate}
                          accountNumber={formViewData?.accountNo}
                          dateOfBoardMeeting={formViewData?.dateofboard}
                          BoardItem={formViewData?.boardItem}
                          pageItem={formViewData?.pageItem}
                          superintendentAssistent={formViewData?.superintendentAssistent}
                          approvelStatusData={approvelStatusData}
                          strs={formViewData?.strs}
                          calpers={formViewData?.calpers}
                          updatedAt={formViewData?.psaPatyUpdatedDate}
                        />
            </div> */}
                        </Sidebar>

                        <Dialog
                            header="Header"
                            className="RejectReport"
                            visible={RejectReport}
                            style={{ width: "30vw" }}
                            onHide={() => setRejectReport(false)}
                        >
                            <div className="p-[22px] space-y-[14px]">
                                {/*col*/}
                                <div>
                                    <div className="text-[#101828] font-bold text-base -tracking-[0.36px]">Reject Report</div>
                                </div>

                                <div className="text-[#344054] font-medium text-[14px] mb-1">
                                    Select an approver level<span className="text-[red] pl-0.2">*</span>
                                </div>
                                <Dropdown
                                    value={fallBackApproverLevel}
                                    options={approverLevelForReject}
                                    onChange={e => {
                                        getApprover(e);
                                    }}
                                    optionLabel="label"
                                    placeholder="Select"
                                    className="p-column-filter custDropdown w-full mb-6"
                                />

                                <div className="text-[#344054] font-medium text-[14px] mb-1">
                                    Select an approver<span className="text-[red] pl-0.2">*</span>
                                </div>
                                <Dropdown
                                    value={fallBackApprover}
                                    disabled
                                    options={approverListForReject}
                                    onChange={e => setFallBackApprover(e.value)}
                                    optionLabel="name"
                                    placeholder="Select"
                                    className="p-column-filter custDropdown w-full mb-6"
                                    filter
                                    onKeyDown={e => {
                                        setEmpList(e, "fallBackApprover");
                                    }}
                                />
                                <Dialog
                                    header="Header"
                                    className="RejectReport"
                                    visible={RejectReport_Send}
                                    style={{ width: "30vw" }}
                                    onHide={() => setRejectReport_Send(false)}
                                >
                                    <div className="p-[22px] space-y-[14px]">
                                        {/*col*/}
                                        <div>
                                            <div className="text-[#101828] font-bold text-base -tracking-[0.36px]">Reject Report</div>
                                        </div>
                                        {/*col*/}
                                        <div className="space-y-1">
                                            <div className="text-[#249144] font-normal text-base">Message sent successfully!</div>
                                            <InputText
                                                disabled
                                                value={value}
                                                onChange={e => setValue(e.target.value)}
                                                placeholder='Information Missing for  "David", Please review and resubmit.'
                                                style={{
                                                    border: "1px",
                                                    borderStyle: "solid",
                                                    borderRadius: "5px",
                                                    borderColor: "#F2F4F7",
                                                    background: "#F2F4F7",
                                                    width: "100%"
                                                }}
                                            />
                                        </div>
                                        {/*col*/}
                                        <div className="flex items-center justify-center">
                                            <div
                                                className="text-white bg-[#113699] py-2 px-4 text-center rounded-lg w-[150px] cursor-pointer"
                                                onClick={() => {
                                                    setRejectReport_Send(false);
                                                    setRejectReport(false);
                                                }}
                                            >
                                                ok
                                            </div>
                                        </div>
                                        {/*col*/}
                                    </div>
                                </Dialog>

                                {/*col*/}
                                <div className="space-y-1 mb-5">
                                    <div className="text-[#344054] font-medium text-[14px] mb-1">
                                        Enter the reason for rejection<span className="text-[red] pl-0.2">*</span>
                                    </div>
                                    <InputText
                                        value={value}
                                        onChange={e => setValue(e.target.value)}
                                        placeholder='Enter the Reason for Rejection'
                                        style={{
                                            border: "1px",
                                            borderStyle: "solid",
                                            borderRadius: "5px",
                                            borderColor: "#E4E7EC",
                                            background: "#fff",
                                            width: "100%"
                                        }}
                                    />
                                </div>
                                {/*col*/}
                                <div className="flex items-center justify-center gap-4 mt-[50px]">
                                    <div
                                        className="text-white bg-[#113699] py-2 px-4 text-center rounded-lg w-[100px] cursor-pointer mt-5"
                                        onClick={() => {
                                            if (fallBackApproverLevel === "" || fallBackApproverLevel === null) {
                                                toast.error("Please Select Approver Level");
                                                return;
                                            } else if (value === "") {
                                                toast.error("Please Add Reason For Rejection");
                                                return;
                                            } else if (fallBackApprover === "" || fallBackApprover === null) {
                                                toast.error("Please Select Approver");
                                                return;
                                            } else {
                                                rejectSelectedReport(specificReportDetailsEdit?.PSAConsultantData?.id);
                                                setRejectReport_Send(true);


                                            }
                                        }}
                                    >
                                        Send
                                    </div>
                                    <button
                                        onClick={() => setRejectReport(false)}
                                        type="button"
                                        className="text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer mt-5"
                                        id="add-family-cancel-btn"
                                        style={{ marginRight: "12px" }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                                {/*col*/}
                            </div>
                        </Dialog>

                        <Dialog
                            header="Header"
                            className="RejectReport"
                            visible={RejectReport_Send}
                            style={{ width: "30vw" }}
                            onHide={() => setRejectReport_Send(false)}
                        >
                            <div className="p-[22px] space-y-[14px]">
                                {/*col*/}
                                <div>
                                    <div className="text-[#101828] font-bold text-base -tracking-[0.36px]">Reject Report</div>
                                </div>
                                {/*col*/}
                                <div className="space-y-1">
                                    <div className="text-[#249144] font-normal text-base">Message sent successfully!</div>
                                    <InputText
                                        disabled
                                        value={value}
                                        // onChange={e => setValue(e.target.value)}
                                        placeholder='Information Missing for  "David", Please review and resubmit.'
                                        style={{
                                            border: "1px",
                                            borderStyle: "solid",
                                            borderRadius: "5px",
                                            borderColor: "#F2F4F7",
                                            background: "#F2F4F7",
                                            width: "100%"
                                        }}
                                    />
                                </div>
                                {/*col*/}
                                <div className="flex items-center justify-center">
                                    <div
                                        className="text-white bg-[#113699] py-2 px-4 text-center rounded-lg w-[150px] cursor-pointer"
                                        onClick={() => {
                                            setRejectReport_Send(false);
                                            setRejectReport(false);
                                        }}
                                    >
                                        ok
                                    </div>
                                </div>
                                {/*col*/}
                            </div>
                        </Dialog>

                        <Dialog
                            header="Header"
                            className="RejectReport"
                            visible={Report_Approved}
                            style={{ width: "30vw" }}
                            onHide={() => setReport_Approved(false)}
                        >
                            <div className="p-[22px] space-y-[14px]">
                                <div className="flex justify-end">
                                    <div className="text-[#667085] text-sm cursor-pointer" onClick={() => setReport_Approved(false)}>
                                        <i className="gusd-close"></i>
                                    </div>
                                </div>
                                <div className="flex items-center justify-center">
                                    <div className="text-[#0487C8] font-medium text-lg flex items-center gap-2">
                                        <span className="right-rounded block w-[20px] h-[20px]"></span>
                                        <span>Selected report was Approved</span>
                                    </div>
                                </div>
                                {/*col*/}
                                <div className="flex items-center justify-center">
                                    <div
                                        className="text-[#1E3E5A] border border-[#C8C8C8] py-2 px-4 text-center rounded-lg cursor-pointer"
                                        onClick={() => setReport_Approved(false)}
                                    >
                                        Close
                                    </div>
                                </div>
                                {/*col*/}
                            </div>
                        </Dialog>

                        <Sidebar
                            className="PSAviewPopup psapopus"
                            visible={StipendsFormFullScreen}
                            position="right"
                            onHide={() => setStipendsFormFullScreen(false)}
                            style={{ width: "60vw", background: "#F5F6F7" }}
                        >
                            <div className="xl:py-[1.667vw] py-[28px] xl:px-[1.250vw] px-[20px]">
                                <div
                                    className="cursor-pointer mb-[20px]"
                                    onClick={() => {
                                        setStipendsFormFullScreen(false);
                                        setAddSignature(false)
                                        setPSAedit(false);
                                    }}
                                >
                                    <Image src={sideBarRight} alt="user" width="20" height="20" />
                                </div>

                                <div className="xl:p-[1.250vw] p-[20px] bg-[#F5F6F7] flex items-center justify-between mt-[20px]">
                                    <div className="flex items-center space-x-2 text-[#000000] font-medium xl:text-[1.250vw] text-[20px]">
                                        <span className="gusd-file-icon w-4 h-4 inline-block"></span>
                                        <span>Personal Service Agreement .pdf</span>
                                    </div>
                                    <div
                                        className="text-[#113699] font-medium text-xs flex items-center gap-2 cursor-pointer"
                                        onClick={() => setStipendsFormFullScreen(false)}
                                    >
                                        <span className="Exit_Full_Screen block w-[18px] h-[18px]"></span>
                                        <span>Exit Full Screen</span>
                                    </div>
                                </div>

                                <div className="xl:p-[1.250vw] p-[20px] bg-[#F5F5F5] rounded-bl rounded-br">
                                    <div className="lg:h-[25vw] overflow-auto">
                                        {/* <PsaPdf
                      agreementDate="26/09/98"
                      partyName="BlueOrbit"
                      amount="2016"
                      services="lunch dinner free"
                      effectiveDate="02/09/1998"
                      expirationDate="06/09/1998"
                      typeOfBusinessEntityAandN="Insaurance Form"
                      submittedTo="30/06/2023"
                      referenceNo="33"
                      // PSA Consultant details
                      typeOfBusinessEntityPartyDetails="Individual"
                      licenseNumber="LE02145"
                      addressPSa="USA"
                      psaDate="03/25/2024"
                      contactNumber="9823456988"
                      fax="66665"
                      //Tax Identification Details
                      socialSecurityNumber="30"
                      employerIdentification="This is Employer Identification"
                      //Gusd Detailes
                      gusdDate="02/12/2023"
                      accountNumber="98745211"
                      dateOfBoardMeeting="26/09/98"
                      BoardItem="Board"
                      pageItem="page"
                      superintendentAssistent="Mahesh"
                    /> */}
                                        {/* <PsaPdf
                      agreementDate={specificReportDetailsEdit?.PSAConsultantData?.agreementDate}
                      partyName={specificReportDetailsEdit?.PSAConsultantData?.partyName}
                      amount={specificReportDetailsEdit?.PSAConsultantData?.amount}
                      services={specificReportDetailsEdit?.PSAConsultantData?.services}
                      effectiveDate={specificReportDetailsEdit?.PSAConsultantData?.effectiveDate}
                      expirationDate={specificReportDetailsEdit?.PSAConsultantData?.expireDate}
                      typeOfBusinessEntityAandN={specificReportDetailsEdit?.PSAConsultantData?.typeBE}
                      submittedTo={specificReportDetailsEdit?.PSAConsultantData?.submittedTo?.name}
                      referenceNo={specificReportDetailsEdit?.PSAConsultantData?.referenceNo}
                      // PSA Consultant details
                      typeOfBusinessEntityPartyDetails={
                        specificReportDetailsEdit?.PSAConsultantData?.typeOfBusinessEntityPartyDetails
                      }
                      title={specificReportDetailsEdit?.PSAConsultantData?.assignmentTitle}
                      licenseNumber={specificReportDetailsEdit?.PSAConsultantData?.licenseNumber}
                      addressPSa={specificReportDetailsEdit?.PSAConsultantData?.addressPSa}
                      psaDate={specificReportDetailsEdit?.PSAConsultantData?.psaDate}
                      contactNumber={specificReportDetailsEdit?.PSAConsultantData?.contactNumber}
                      fax={specificReportDetailsEdit?.PSAConsultantData?.fax}
                      //Tax Identification Details
                      socialSecurityNumber={specificReportDetailsEdit?.PSAConsultantData?.socialSecurityNumber}
                      employerIdentification={specificReportDetailsEdit?.PSAConsultantData?.employerIdentification}
                      //Gusd Detailes
                      gusdDate={specificReportDetailsEdit?.PSAConsultantData?.gusdDate}
                      accountNumber={specificReportDetailsEdit?.PSAConsultantData?.accountNo}
                      dateOfBoardMeeting={specificReportDetailsEdit?.PSAConsultantData?.dateOfBoardMeeting}
                      BoardItem={specificReportDetailsEdit?.PSAConsultantData?.boardItem}
                      pageItem={specificReportDetailsEdit?.PSAConsultantData?.pageItem}
                      superintendentAssistent={specificReportDetailsEdit?.PSAConsultantData?.superintendentAssistent}
                      approvelStatusData={approvelStatusData}
		/> */}

                                        <PsaPdf2
                                            agreementDate={formViewData?.agreementDate}
                                            partyName={formViewData?.party}
                                            amount={formViewData?.amount}
                                            services={formViewData?.services}
                                            effectiveDate={formViewData?.effectiveDate}
                                            expirationDate={formViewData?.expireDate}
                                            typeOfBusinessEntityAandN={formViewData?.businessEntity}
                                            submittedTo={formViewData?.submittedTo?.name}
                                            submittedCompletedFormTo={formViewData?.submittedCompletedFormTo}
                                            referenceNo={formViewData?.referenceNo}
                                            purchaseOrderNo={formViewData?.purchaseOrderNo}
                                            refPrint={componentRef}
                                            addendumNo={formViewData?.addendumNo}
                                            typeBE={formViewData?.typeBE}

                                            businessEntity={
                                                psaconsultantData?.businessEntity && psaconsultantData?.businessEntity?.split(",")
                                            }
                                            // PSA Consultant details
                                            typeOfBusinessEntityPartyDetails={formViewData?.typeOfBusinessEntityPartyDetails}
                                            title={formViewData?.title}
                                            licenseNumber={formViewData?.license}
                                            // addressPSa={`${formViewData?.address && formViewData?.address} ${formViewData?.city && formViewData?.city
                                            //   } ${formViewData?.state && formViewData?.state} ${formViewData?.zip && formViewData?.zip}`}
                                            addressPSa={`${formViewData?.address != null ? formViewData?.address : "-"}
                      ${formViewData?.city != null ? formViewData?.city : "-"}
                      ${formViewData?.state != null ? formViewData?.state : "-"}
                      ${formViewData?.zip != null ? formViewData?.zip : "-"}
                      `}
                                            psaDate={formViewData?.psaDate}
                                            pocNumber={formViewData?.pocNumber}
                                            fax={formViewData?.fax}
                                            //Tax Identification Details
                                            socialSecurityNumber={formViewData?.ssn}
                                            employerIdentification={formViewData?.employerID}
                                            //Gusd Detailes
                                            gusdDate={formViewData?.gusdDate}
                                            dateOfApprove={formViewData?.dateOfApprove}
                                            accountNumber={formViewData?.accountNo}
                                            dateOfBoardMeeting={formViewData?.dateofboard}
                                            BoardItem={formViewData?.boardItem}
                                            pageItem={formViewData?.pageItem}
                                            superintendentAssistent={formViewData?.superintendentAssistent}
                                            approvelStatusData={approvelStatusData}
                                            strs={formViewData?.strs}
                                            calpers={formViewData?.calpers}
                                            updatedAt={formViewData?.psaPatyUpdatedDate}
                                        />
                                    </div>
                                </div>

                                {/*col*/}
                                <div className="custm_InputSwitch flex items-center text-[#1E3E5A] font-medium text-sm gap-2 py-[20px]">
                                    {/*<InputSwitch checked={checked} onChange={e => AddSign(e.value)} />  */}
                                    <InputSwitch
                                        checked={addSignature}
                                        onChange={e => {
                                            if (e.value) {
                                                setIsSignatureAdded(true);
                                            } else {
                                                setIsSignatureAdded(false);
                                            }
                                            setAddSignature(e.value);
                                        }}
                                    />
                                    <span>
                                        Add Signature<span class="text-[red] pl-0.2">*</span>
                                    </span>
                                </div>
                                {isHrConsultant && (
                                    <div className="custm_InputSwitch  items-center text-[#1E3E5A] font-medium text-sm gap-2">
                                        <div>
                                            <p>
                                                {" "}
                                                Have you added the 'Board Item' and 'Page/Item'? <span className="text-[red] pl-0.2">*</span>
                                            </p>
                                        </div>
                                        <div className="flex flex-wrap gap-3">
                                            <div className="flex align-items-center">
                                                <RadioButton
                                                    inputId="ingredient1"
                                                    name="pizza"
                                                    value={true}
                                                    onChange={e => {
                                                        setIsItemsAdded(true);
                                                    }}
                                                    checked={isItemsAdded}
                                                />
                                                <label htmlFor="ingredient1" className="ml-2">
                                                    Yes
                                                </label>
                                            </div>
                                            <div className="flex align-items-center">
                                                <RadioButton
                                                    inputId="ingredient2"
                                                    name="pizza"
                                                    value={false}
                                                    onChange={e => {
                                                        setIsItemsAdded(false);
                                                    }}
                                                    checked={!isItemsAdded}
                                                />
                                                <label htmlFor="ingredient2" className="ml-2">
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/*col*/}
                                {addSignature && signatureFileAwsPath !== null ? (
                                    <div className="py-3 px-5 rounded-[8px] mt-3">
                                        <Card>
                                            <img className={"w-[20%] h-[15%]"} src={signatureFileAwsPath} />
                                        </Card>
                                    </div>
                                ) : null}

                                <div className="grid grid-cols-3 gap-2">
                                    <div
                                        onClick={() => {
                                            setStipendsFormFullScreen(false);
                                            setPSAedit(false);
                                            setAddSignature(false)
                                        }}
                                        className="text-[#344054] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer"
                                    >
                                        <i className="gusd-close-circle text-base"></i>
                                        <span>Cancel</span>
                                    </div>
                                    {!ackUser ? (
                                        <div
                                            className="text-[#D92D20] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer"
                                            onClick={() => {
                                                setRejectReport(true); setReportLoading(true)
                                                setReportLoadingApprover(true)
                                            }}
                                        >
                                            <i className="gusd-close"></i>
                                            <span>Reject</span>
                                        </div>
                                    ) : null}
                                    {!ackUser ? (
                                        <button
                                            // className="text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer"
                                            onClick={() => {
                                                if (isSignatureAdded && (isHrConsultant ? isItemsAdded : true)) {
                                                    approveSelectedReport(specificReportDetailsEdit?.PSAConsultantData?.id);
                                                    setReport_Approved(true);
                                                    setIsSignatureAdded(false);
                                                    setIsItemsAdded(false);
                                                    setReportLoading(true);
                                                    setReportLoadingApprover(true);
                                                    setStipendsFormFullScreen(false);
                                                    setPleaseWaitButton(true);
                                                    setAddSignature(false);
                                                } else if (!isSignatureAdded) {
                                                    toast.error("Add Signature.");
                                                } else if (isHrConsultant ? !isItemsAdded : false) {
                                                    toast.error("Please add 'Board Item' and 'Page/Item.");
                                                }
                                            }}
                                            // disabled={(isSignatureAdded && isItemsAdded) ? false : true}
                                            className={` 
                      ${isSignatureAdded && (isHrConsultant ? isItemsAdded : true) ? "text-[#039855]" : ""}
                      text-center flex items-center tableBtn bg-white border border-[#D0D5DD] radius8 cursor-pointer `}
                                        // className={` ${
                                        //   signatureFileAwsPath === null || !addSignature || buttonClicked ? "" : "text-[#039855] "
                                        // }text-center flex items-center tableBtn bg-white border border-[#D0D5DD] radius8 cursor-pointer `}
                                        // disabled={signatureFileAwsPath === null || !addSignature || buttonClicked}
                                        >
                                            <i className="pi pi-check mr-2 mt-1"></i>
                                            <span>  {(pleaseWaitButton) ? 'Please Wait' : "Approve"}</span>
                                        </button>
                                    ) : (
                                        <button
                                            // className="text-[#039855] font-medium text-sm text-center xl:py-[0.521vw] py-[8px] xl:px-[0.781vw] px-[14px] border border-[#D0D5DD] bg-white Shadow_xs rounded-lg space-x-2 cursor-pointer"
                                            onClick={() => {
                                                if (isSignatureAdded && (isHrConsultant ? isItemsAdded : true)) {
                                                    approveSelectedReport(specificReportDetailsEdit?.PSAConsultantData?.id);
                                                    setReport_Approved(true);
                                                    setIsSignatureAdded(false);
                                                    setIsItemsAdded(false);
                                                    setStipendsFormFullScreen(false);
                                                } else if (!isSignatureAdded) {
                                                    toast.error("Add Signature.");
                                                } else if (isHrConsultant ? isItemsAdded : false) {
                                                    toast.error("Please add 'Board Item' and 'Page/Item.");
                                                }
                                            }}
                                            // disabled={(isSignatureAdded && isItemsAdded) ? false : true}
                                            className={` 
                      ${isSignatureAdded && (isHrConsultant ? isItemsAdded : true) ? "text-[#039855]" : ""}
                      text-center flex items-center tableBtn bg-white border border-[#D0D5DD] radius8 cursor-pointer `}
                                        >
                                            <i className="pi pi-check"></i>
                                            <span>Acknowledge</span>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </Sidebar>

                        {/* added notification remainer dialog start */}
                        <Dialog
                            header="Reminder"
                            visible={ReminderDialog}
                            style={{ width: "30vw" }}
                            onHide={() => {
                                setreminderDialog(false);
                            }}
                            closable={false}
                            footer={footerContentForReminder}
                        >
                            <p className="m-0 text-[#0487C8] text-center">
                                <i className="mr-2 pi pi-check-circle"></i>
                                <span className="font-medium text-[18px]">{`By clicking Yes, a reminder will be sent to ${ReminderData?.assignee} to approve the form. Click No to cancel.`}</span>
                            </p>
                        </Dialog>
                        {/* added notification remainer dialog end */}



                        {/* {
                            (isVisibleDelete) ?
                                <ReportDeleteDialog
                                    isVisibleDelete={isVisibleDelete}
                                    setIsVisibleDelete={setIsVisibleDelete}
                                    isVisibleDeleteID={isVisibleDeleteID}
                                    getMasterData={() => BindList()}
                                    // setIsLoadData={() => setReportLoading(true)}
                                    setIsLoadData={() => setReportLoading(true)}
                                    queries={queries.getPSAConsultant}
                                    tableName={"getPSAConsultant"}
                                    mutations={mutations.updatePSAConsultant}
                                /> : null
                        } */}

                    </Layout>
                )}
            </ReactFullscreen>
        </>
    ) : (
        <Login sessionExpired={1} />
    );
}
